
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("7acw5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $53732d1a7c36c754$export$2e2bcd8739ae039);

var $kaOCu = parcelRequire("kaOCu");

var $iSwgF = parcelRequire("iSwgF");

var $3RTJ9 = parcelRequire("3RTJ9");

var $f8oza = parcelRequire("f8oza");

var $flGS6 = parcelRequire("flGS6");
/**
 * @type {Locale}
 * @category Locales
 * @summary Czech locale.
 * @language Czech
 * @iso-639-2 ces
 * @author David Rus [@davidrus]{@link https://github.com/davidrus}
 * @author Pavel Hrách [@SilenY]{@link https://github.com/SilenY}
 * @author Jozef Bíroš [@JozefBiros]{@link https://github.com/JozefBiros}
 */ var $53732d1a7c36c754$var$locale = {
    code: 'cs',
    formatDistance: (0, $kaOCu.default),
    formatLong: (0, $iSwgF.default),
    formatRelative: (0, $3RTJ9.default),
    localize: (0, $f8oza.default),
    match: (0, $flGS6.default),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
    }
};
var $53732d1a7c36c754$export$2e2bcd8739ae039 = $53732d1a7c36c754$var$locale;

});
parcelRegister("kaOCu", function(module, exports) {
$parcel$export(module.exports, "default", () => $eafc01e01953c3fb$export$2e2bcd8739ae039);
var $eafc01e01953c3fb$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            regular: "m\xe9n\u011B ne\u017E vte\u0159ina",
            past: "p\u0159ed m\xe9n\u011B ne\u017E vte\u0159inou",
            future: "za m\xe9n\u011B ne\u017E vte\u0159inu"
        },
        few: {
            regular: "m\xe9n\u011B ne\u017E {{count}} vte\u0159iny",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} vte\u0159inami",
            future: "za m\xe9n\u011B ne\u017E {{count}} vte\u0159iny"
        },
        many: {
            regular: "m\xe9n\u011B ne\u017E {{count}} vte\u0159in",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} vte\u0159inami",
            future: "za m\xe9n\u011B ne\u017E {{count}} vte\u0159in"
        }
    },
    xSeconds: {
        one: {
            regular: "vte\u0159ina",
            past: "p\u0159ed vte\u0159inou",
            future: "za vte\u0159inu"
        },
        few: {
            regular: "{{count}} vte\u0159iny",
            past: "p\u0159ed {{count}} vte\u0159inami",
            future: "za {{count}} vte\u0159iny"
        },
        many: {
            regular: "{{count}} vte\u0159in",
            past: "p\u0159ed {{count}} vte\u0159inami",
            future: "za {{count}} vte\u0159in"
        }
    },
    halfAMinute: {
        other: {
            regular: "p\u016Fl minuty",
            past: "p\u0159ed p\u016Fl minutou",
            future: "za p\u016Fl minuty"
        }
    },
    lessThanXMinutes: {
        one: {
            regular: "m\xe9n\u011B ne\u017E minuta",
            past: "p\u0159ed m\xe9n\u011B ne\u017E minutou",
            future: "za m\xe9n\u011B ne\u017E minutu"
        },
        few: {
            regular: "m\xe9n\u011B ne\u017E {{count}} minuty",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} minutami",
            future: "za m\xe9n\u011B ne\u017E {{count}} minuty"
        },
        many: {
            regular: "m\xe9n\u011B ne\u017E {{count}} minut",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} minutami",
            future: "za m\xe9n\u011B ne\u017E {{count}} minut"
        }
    },
    xMinutes: {
        one: {
            regular: 'minuta',
            past: "p\u0159ed minutou",
            future: 'za minutu'
        },
        few: {
            regular: '{{count}} minuty',
            past: "p\u0159ed {{count}} minutami",
            future: 'za {{count}} minuty'
        },
        many: {
            regular: '{{count}} minut',
            past: "p\u0159ed {{count}} minutami",
            future: 'za {{count}} minut'
        }
    },
    aboutXHours: {
        one: {
            regular: "p\u0159ibli\u017En\u011B hodina",
            past: "p\u0159ibli\u017En\u011B p\u0159ed hodinou",
            future: "p\u0159ibli\u017En\u011B za hodinu"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} hodiny",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
            future: "p\u0159ibli\u017En\u011B za {{count}} hodiny"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} hodin",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
            future: "p\u0159ibli\u017En\u011B za {{count}} hodin"
        }
    },
    xHours: {
        one: {
            regular: 'hodina',
            past: "p\u0159ed hodinou",
            future: 'za hodinu'
        },
        few: {
            regular: '{{count}} hodiny',
            past: "p\u0159ed {{count}} hodinami",
            future: 'za {{count}} hodiny'
        },
        many: {
            regular: '{{count}} hodin',
            past: "p\u0159ed {{count}} hodinami",
            future: 'za {{count}} hodin'
        }
    },
    xDays: {
        one: {
            regular: 'den',
            past: "p\u0159ed dnem",
            future: 'za den'
        },
        few: {
            regular: '{{count}} dny',
            past: "p\u0159ed {{count}} dny",
            future: 'za {{count}} dny'
        },
        many: {
            regular: "{{count}} dn\xed",
            past: "p\u0159ed {{count}} dny",
            future: "za {{count}} dn\xed"
        }
    },
    aboutXWeeks: {
        one: {
            regular: "p\u0159ibli\u017En\u011B t\xfdden",
            past: "p\u0159ibli\u017En\u011B p\u0159ed t\xfddnem",
            future: "p\u0159ibli\u017En\u011B za t\xfdden"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} t\xfddny",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xfddny",
            future: "p\u0159ibli\u017En\u011B za {{count}} t\xfddny"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} t\xfddn\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xfddny",
            future: "p\u0159ibli\u017En\u011B za {{count}} t\xfddn\u016F"
        }
    },
    xWeeks: {
        one: {
            regular: "t\xfdden",
            past: "p\u0159ed t\xfddnem",
            future: "za t\xfdden"
        },
        few: {
            regular: "{{count}} t\xfddny",
            past: "p\u0159ed {{count}} t\xfddny",
            future: "za {{count}} t\xfddny"
        },
        many: {
            regular: "{{count}} t\xfddn\u016F",
            past: "p\u0159ed {{count}} t\xfddny",
            future: "za {{count}} t\xfddn\u016F"
        }
    },
    aboutXMonths: {
        one: {
            regular: "p\u0159ibli\u017En\u011B m\u011Bs\xedc",
            past: "p\u0159ibli\u017En\u011B p\u0159ed m\u011Bs\xedcem",
            future: "p\u0159ibli\u017En\u011B za m\u011Bs\xedc"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xedce",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xedci",
            future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xedce"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xedc\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xedci",
            future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xedc\u016F"
        }
    },
    xMonths: {
        one: {
            regular: "m\u011Bs\xedc",
            past: "p\u0159ed m\u011Bs\xedcem",
            future: "za m\u011Bs\xedc"
        },
        few: {
            regular: "{{count}} m\u011Bs\xedce",
            past: "p\u0159ed {{count}} m\u011Bs\xedci",
            future: "za {{count}} m\u011Bs\xedce"
        },
        many: {
            regular: "{{count}} m\u011Bs\xedc\u016F",
            past: "p\u0159ed {{count}} m\u011Bs\xedci",
            future: "za {{count}} m\u011Bs\xedc\u016F"
        }
    },
    aboutXYears: {
        one: {
            regular: "p\u0159ibli\u017En\u011B rok",
            past: "p\u0159ibli\u017En\u011B p\u0159ed rokem",
            future: "p\u0159ibli\u017En\u011B za rok"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} roky",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
            future: "p\u0159ibli\u017En\u011B za {{count}} roky"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} rok\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
            future: "p\u0159ibli\u017En\u011B za {{count}} rok\u016F"
        }
    },
    xYears: {
        one: {
            regular: 'rok',
            past: "p\u0159ed rokem",
            future: 'za rok'
        },
        few: {
            regular: '{{count}} roky',
            past: "p\u0159ed {{count}} roky",
            future: 'za {{count}} roky'
        },
        many: {
            regular: "{{count}} rok\u016F",
            past: "p\u0159ed {{count}} roky",
            future: "za {{count}} rok\u016F"
        }
    },
    overXYears: {
        one: {
            regular: "v\xedce ne\u017E rok",
            past: "p\u0159ed v\xedce ne\u017E rokem",
            future: "za v\xedce ne\u017E rok"
        },
        few: {
            regular: "v\xedce ne\u017E {{count}} roky",
            past: "p\u0159ed v\xedce ne\u017E {{count}} roky",
            future: "za v\xedce ne\u017E {{count}} roky"
        },
        many: {
            regular: "v\xedce ne\u017E {{count}} rok\u016F",
            past: "p\u0159ed v\xedce ne\u017E {{count}} roky",
            future: "za v\xedce ne\u017E {{count}} rok\u016F"
        }
    },
    almostXYears: {
        one: {
            regular: 'skoro rok',
            past: "skoro p\u0159ed rokem",
            future: 'skoro za rok'
        },
        few: {
            regular: 'skoro {{count}} roky',
            past: "skoro p\u0159ed {{count}} roky",
            future: 'skoro za {{count}} roky'
        },
        many: {
            regular: "skoro {{count}} rok\u016F",
            past: "skoro p\u0159ed {{count}} roky",
            future: "skoro za {{count}} rok\u016F"
        }
    }
};
function $eafc01e01953c3fb$export$2e2bcd8739ae039(token, count, options) {
    options = options || {};
    var scheme = $eafc01e01953c3fb$var$formatDistanceLocale[token]; // cs pluralization
    var pluralToken;
    if (typeof scheme.other === 'object') pluralToken = 'other';
    else if (count === 1) pluralToken = 'one';
    else if (count > 1 && count < 5 || count === 0) pluralToken = 'few';
    else pluralToken = 'many';
     // times
    var suffixExist = options.addSuffix === true;
    var comparison = options.comparison;
    var timeToken;
    if (suffixExist && comparison === -1) timeToken = 'past';
    else if (suffixExist && comparison === 1) timeToken = 'future';
    else timeToken = 'regular';
    return scheme[pluralToken][timeToken].replace('{{count}}', count);
}

});

parcelRegister("iSwgF", function(module, exports) {
$parcel$export(module.exports, "default", () => $dbe64cdea7c864de$export$2e2bcd8739ae039);

var $8D7sK = parcelRequire("8D7sK");
var $dbe64cdea7c864de$var$dateFormats = {
    full: 'EEEE, d. MMMM yyyy',
    long: 'd. MMMM yyyy',
    medium: 'd. M. yyyy',
    short: 'dd.MM.yyyy'
};
var $dbe64cdea7c864de$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $dbe64cdea7c864de$var$dateTimeFormats = {
    full: "{{date}} 'v' {{time}}",
    long: "{{date}} 'v' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $dbe64cdea7c864de$var$formatLong = {
    date: (0, $8D7sK.default)({
        formats: $dbe64cdea7c864de$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $8D7sK.default)({
        formats: $dbe64cdea7c864de$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $8D7sK.default)({
        formats: $dbe64cdea7c864de$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $dbe64cdea7c864de$export$2e2bcd8739ae039 = $dbe64cdea7c864de$var$formatLong;

});

parcelRegister("3RTJ9", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d118c95b72b0190$export$2e2bcd8739ae039);
var $2d118c95b72b0190$var$accusativeWeekdays = [
    "ned\u011Bli",
    "pond\u011Bl\xed",
    "\xfater\xfd",
    "st\u0159edu",
    "\u010Dtvrtek",
    "p\xe1tek",
    'sobotu'
];
var $2d118c95b72b0190$var$formatRelativeLocale = {
    lastWeek: "'posledn\xed' eeee 've' p",
    yesterday: "'v\u010Dera v' p",
    today: "'dnes v' p",
    tomorrow: "'z\xedtra v' p",
    nextWeek: function(date, _baseDate, _options) {
        var day = date.getUTCDay();
        return "'v " + $2d118c95b72b0190$var$accusativeWeekdays[day] + " o' p";
    },
    other: 'P'
};
function $2d118c95b72b0190$export$2e2bcd8739ae039(token, date, baseDate, options) {
    var format = $2d118c95b72b0190$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
}

});

parcelRegister("f8oza", function(module, exports) {
$parcel$export(module.exports, "default", () => $b04aa8b72316eabc$export$2e2bcd8739ae039);

var $7juaq = parcelRequire("7juaq");
var $b04aa8b72316eabc$var$eraValues = {
    narrow: [
        "p\u0159. n. l.",
        'n. l.'
    ],
    abbreviated: [
        "p\u0159. n. l.",
        'n. l.'
    ],
    wide: [
        "p\u0159ed na\u0161\xedm letopo\u010Dtem",
        "na\u0161eho letopo\u010Dtu"
    ]
};
var $b04aa8b72316eabc$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1. \u010Dtvrtlet\xed",
        "2. \u010Dtvrtlet\xed",
        "3. \u010Dtvrtlet\xed",
        "4. \u010Dtvrtlet\xed"
    ],
    wide: [
        "1. \u010Dtvrtlet\xed",
        "2. \u010Dtvrtlet\xed",
        "3. \u010Dtvrtlet\xed",
        "4. \u010Dtvrtlet\xed"
    ]
};
var $b04aa8b72316eabc$var$monthValues = {
    narrow: [
        'L',
        "\xda",
        'B',
        'D',
        'K',
        "\u010C",
        "\u010C",
        'S',
        'Z',
        "\u0158",
        'L',
        'P'
    ],
    abbreviated: [
        'led',
        "\xfano",
        "b\u0159e",
        'dub',
        "kv\u011B",
        "\u010Dvn",
        "\u010Dvc",
        'srp',
        "z\xe1\u0159",
        "\u0159\xedj",
        'lis',
        'pro'
    ],
    wide: [
        'leden',
        "\xfanor",
        "b\u0159ezen",
        'duben',
        "kv\u011Bten",
        "\u010Derven",
        "\u010Dervenec",
        'srpen',
        "z\xe1\u0159\xed",
        "\u0159\xedjen",
        'listopad',
        'prosinec'
    ]
};
var $b04aa8b72316eabc$var$formattingMonthValues = {
    narrow: [
        'L',
        "\xda",
        'B',
        'D',
        'K',
        "\u010C",
        "\u010C",
        'S',
        'Z',
        "\u0158",
        'L',
        'P'
    ],
    abbreviated: [
        'led',
        "\xfano",
        "b\u0159e",
        'dub',
        "kv\u011B",
        "\u010Dvn",
        "\u010Dvc",
        'srp',
        "z\xe1\u0159",
        "\u0159\xedj",
        'lis',
        'pro'
    ],
    wide: [
        'ledna',
        "\xfanora",
        "b\u0159ezna",
        'dubna',
        "kv\u011Btna",
        "\u010Dervna",
        "\u010Dervence",
        'srpna',
        "z\xe1\u0159\xed",
        "\u0159\xedjna",
        'listopadu',
        'prosince'
    ]
};
var $b04aa8b72316eabc$var$dayValues = {
    narrow: [
        'ne',
        'po',
        "\xfat",
        'st',
        "\u010Dt",
        "p\xe1",
        'so'
    ],
    short: [
        'ne',
        'po',
        "\xfat",
        'st',
        "\u010Dt",
        "p\xe1",
        'so'
    ],
    abbreviated: [
        'ned',
        'pon',
        "\xfate",
        "st\u0159",
        "\u010Dtv",
        "p\xe1t",
        'sob'
    ],
    wide: [
        "ned\u011Ble",
        "pond\u011Bl\xed",
        "\xfater\xfd",
        "st\u0159eda",
        "\u010Dtvrtek",
        "p\xe1tek",
        'sobota'
    ]
};
var $b04aa8b72316eabc$var$dayPeriodValues = {
    narrow: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    wide: {
        am: 'dopoledne',
        pm: 'odpoledne',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    }
};
var $b04aa8b72316eabc$var$formattingDayPeriodValues = {
    narrow: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    wide: {
        am: 'dopoledne',
        pm: 'odpoledne',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    }
};
function $b04aa8b72316eabc$var$ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + '.';
}
var $b04aa8b72316eabc$var$localize = {
    ordinalNumber: $b04aa8b72316eabc$var$ordinalNumber,
    era: (0, $7juaq.default)({
        values: $b04aa8b72316eabc$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $7juaq.default)({
        values: $b04aa8b72316eabc$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $7juaq.default)({
        values: $b04aa8b72316eabc$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $b04aa8b72316eabc$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $7juaq.default)({
        values: $b04aa8b72316eabc$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $7juaq.default)({
        values: $b04aa8b72316eabc$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $b04aa8b72316eabc$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $b04aa8b72316eabc$export$2e2bcd8739ae039 = $b04aa8b72316eabc$var$localize;

});

parcelRegister("flGS6", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2ca1296f2b85bdd$export$2e2bcd8739ae039);

var $5hQUT = parcelRequire("5hQUT");

var $bFSku = parcelRequire("bFSku");
var $b2ca1296f2b85bdd$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $b2ca1296f2b85bdd$var$parseOrdinalNumberPattern = /\d+/i;
var $b2ca1296f2b85bdd$var$matchEraPatterns = {
    narrow: /^(p[řr]ed Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
    abbreviated: /^(pe[řr]ed Kr\.|pe[řr]ed n\. l\.|po Kr\.|n\. l\.)/i,
    wide: /^(p[řr]ed Kristem|pred na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
};
var $b2ca1296f2b85bdd$var$parseEraPatterns = {
    any: [
        /^p[řr]/i,
        /^(po|n)/i
    ]
};
var $b2ca1296f2b85bdd$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
    wide: /^[1234]\. [čc]tvrtlet[íi]/i
};
var $b2ca1296f2b85bdd$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $b2ca1296f2b85bdd$var$matchMonthPatterns = {
    narrow: /^[lúubdkčcszřrlp]/i,
    abbreviated: /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
    wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
};
var $b2ca1296f2b85bdd$var$parseMonthPatterns = {
    narrow: [
        /^l/i,
        /^[úu]/i,
        /^b/i,
        /^d/i,
        /^k/i,
        /^[čc]/i,
        /^[čc]/i,
        /^s/i,
        /^z/i,
        /^[řr]/i,
        /^l/i,
        /^p/i
    ],
    any: [
        /^led/i,
        /^[úu]n/i,
        /^b[řr]e/i,
        /^dub/i,
        /^kv[ěe]/i,
        /^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i,
        /^[čc]vc|[čc]erven(ec|ce)/i,
        /^srp/i,
        /^z[áa][řr]/i,
        /^[řr][íi]j/i,
        /^lis/i,
        /^pro/i
    ]
};
var $b2ca1296f2b85bdd$var$matchDayPatterns = {
    narrow: /^[npuúsčps]/i,
    short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
    abbreviated: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
    wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
};
var $b2ca1296f2b85bdd$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^[úu]/i,
        /^s/i,
        /^[čc]/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^ne/i,
        /^po/i,
        /^ut/i,
        /^st/i,
        /^[čc]t/i,
        /^p/i,
        /^so/i
    ]
};
var $b2ca1296f2b85bdd$var$matchDayPeriodPatterns = {
    any: /^dopoledne|dop\.?|odpoledne|odp\.?|půlnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci/i
};
var $b2ca1296f2b85bdd$var$parseDayPeriodPatterns = {
    any: {
        am: /^dop/i,
        pm: /^odp/i,
        midnight: /^p[ůu]lnoc/i,
        noon: /^poledne/i,
        morning: /r[áa]no/i,
        afternoon: /odpoledne/i,
        evening: /ve[čc]er/i,
        night: /noc/i
    }
};
var $b2ca1296f2b85bdd$var$match = {
    ordinalNumber: (0, $bFSku.default)({
        matchPattern: $b2ca1296f2b85bdd$var$matchOrdinalNumberPattern,
        parsePattern: $b2ca1296f2b85bdd$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5hQUT.default)({
        matchPatterns: $b2ca1296f2b85bdd$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b2ca1296f2b85bdd$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5hQUT.default)({
        matchPatterns: $b2ca1296f2b85bdd$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b2ca1296f2b85bdd$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $5hQUT.default)({
        matchPatterns: $b2ca1296f2b85bdd$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b2ca1296f2b85bdd$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5hQUT.default)({
        matchPatterns: $b2ca1296f2b85bdd$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b2ca1296f2b85bdd$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5hQUT.default)({
        matchPatterns: $b2ca1296f2b85bdd$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $b2ca1296f2b85bdd$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $b2ca1296f2b85bdd$export$2e2bcd8739ae039 = $b2ca1296f2b85bdd$var$match;

});


parcelRegister("8jd9J", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $60ca4d9276edb2d5$export$2e2bcd8739ae039);

var $kX5jS = parcelRequire("kX5jS");

var $6XxvP = parcelRequire("6XxvP");

var $8NK1j = parcelRequire("8NK1j");

var $9NQzh = parcelRequire("9NQzh");

var $d2rW3 = parcelRequire("d2rW3");
/**
 * @type {Locale}
 * @category Locales
 * @summary Danish locale.
 * @language Danish
 * @iso-639-2 dan
 * @author Mathias Wøbbe [@MathiasKandelborg]{@link https://github.com/MathiasKandelborg}
 * @author Anders B. Hansen [@Andersbiha]{@link https://github.com/Andersbiha}
 * @author [@kgram]{@link https://github.com/kgram}
 * @author [@stefanbugge]{@link https://github.com/stefanbugge}
 */ var $60ca4d9276edb2d5$var$locale = {
    code: 'da',
    formatDistance: (0, $kX5jS.default),
    formatLong: (0, $6XxvP.default),
    formatRelative: (0, $8NK1j.default),
    localize: (0, $9NQzh.default),
    match: (0, $d2rW3.default),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
    }
};
var $60ca4d9276edb2d5$export$2e2bcd8739ae039 = $60ca4d9276edb2d5$var$locale;

});
parcelRegister("kX5jS", function(module, exports) {
$parcel$export(module.exports, "default", () => $f40d71b22310b0c3$export$2e2bcd8739ae039);
var $f40d71b22310b0c3$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre end \xe9t sekund",
        other: 'mindre end {{count}} sekunder'
    },
    xSeconds: {
        one: '1 sekund',
        other: '{{count}} sekunder'
    },
    halfAMinute: "\xe9t halvt minut",
    lessThanXMinutes: {
        one: "mindre end \xe9t minut",
        other: 'mindre end {{count}} minutter'
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minutter'
    },
    aboutXHours: {
        one: 'cirka 1 time',
        other: 'cirka {{count}} timer'
    },
    xHours: {
        one: '1 time',
        other: '{{count}} timer'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dage'
    },
    aboutXWeeks: {
        one: 'cirka 1 uge',
        other: 'cirka {{count}} uger'
    },
    xWeeks: {
        one: '1 uge',
        other: '{{count}} uger'
    },
    aboutXMonths: {
        one: "cirka 1 m\xe5ned",
        other: "cirka {{count}} m\xe5neder"
    },
    xMonths: {
        one: "1 m\xe5ned",
        other: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        one: "cirka 1 \xe5r",
        other: "cirka {{count}} \xe5r"
    },
    xYears: {
        one: "1 \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over 1 \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "n\xe6sten 1 \xe5r",
        other: "n\xe6sten {{count}} \xe5r"
    }
};
function $f40d71b22310b0c3$export$2e2bcd8739ae039(token, count, options) {
    options = options || {};
    var result;
    if (typeof $f40d71b22310b0c3$var$formatDistanceLocale[token] === 'string') result = $f40d71b22310b0c3$var$formatDistanceLocale[token];
    else if (count === 1) result = $f40d71b22310b0c3$var$formatDistanceLocale[token].one;
    else result = $f40d71b22310b0c3$var$formatDistanceLocale[token].other.replace('{{count}}', count);
    if (options.addSuffix) {
        if (options.comparison > 0) return 'om ' + result;
        else return result + ' siden';
    }
    return result;
}

});

parcelRegister("6XxvP", function(module, exports) {
$parcel$export(module.exports, "default", () => $51123fa55d38afbf$export$2e2bcd8739ae039);

var $8D7sK = parcelRequire("8D7sK");
var $51123fa55d38afbf$var$dateFormats = {
    full: "EEEE 'den' d. MMMM y",
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd/MM/y'
};
var $51123fa55d38afbf$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $51123fa55d38afbf$var$dateTimeFormats = {
    full: "{{date}} 'kl'. {{time}}",
    long: "{{date}} 'kl'. {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $51123fa55d38afbf$var$formatLong = {
    date: (0, $8D7sK.default)({
        formats: $51123fa55d38afbf$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $8D7sK.default)({
        formats: $51123fa55d38afbf$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $8D7sK.default)({
        formats: $51123fa55d38afbf$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $51123fa55d38afbf$export$2e2bcd8739ae039 = $51123fa55d38afbf$var$formatLong;

});

parcelRegister("8NK1j", function(module, exports) {
$parcel$export(module.exports, "default", () => $668699003e45cee7$export$2e2bcd8739ae039);
var $668699003e45cee7$var$formatRelativeLocale = {
    lastWeek: "'sidste' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "'p\xe5' eeee 'kl.' p",
    other: 'P'
};
function $668699003e45cee7$export$2e2bcd8739ae039(token, _date, _baseDate, _options) {
    return $668699003e45cee7$var$formatRelativeLocale[token];
}

});

parcelRegister("9NQzh", function(module, exports) {
$parcel$export(module.exports, "default", () => $723177907612b0c9$export$2e2bcd8739ae039);

var $7juaq = parcelRequire("7juaq");
var $723177907612b0c9$var$eraValues = {
    narrow: [
        'fvt',
        'vt'
    ],
    abbreviated: [
        'f.v.t.',
        'v.t.'
    ],
    wide: [
        "f\xf8r vesterlandsk tidsregning",
        'vesterlandsk tidsregning'
    ]
};
var $723177907612b0c9$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1. kvt.',
        '2. kvt.',
        '3. kvt.',
        '4. kvt.'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $723177907612b0c9$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mar.',
        'apr.',
        'maj',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januar',
        'februar',
        'marts',
        'april',
        'maj',
        'juni',
        'juli',
        'august',
        'september',
        'oktober',
        'november',
        'december'
    ]
}; // Note that 'Days - abbreviated - Formatting' has periods at the end.
// https://www.unicode.org/cldr/charts/32/summary/da.html#1760
// This makes grammatical sense in danish, as most abbreviations have periods.
var $723177907612b0c9$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        "s\xf8",
        'ma',
        'ti',
        'on',
        'to',
        'fr',
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n.",
        'man.',
        'tir.',
        'ons.',
        'tor.',
        'fre.',
        "l\xf8r."
    ],
    wide: [
        "s\xf8ndag",
        'mandag',
        'tirsdag',
        'onsdag',
        'torsdag',
        'fredag',
        "l\xf8rdag"
    ]
};
var $723177907612b0c9$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'morgen',
        afternoon: 'eftermiddag',
        evening: 'aften',
        night: 'nat'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'morgen',
        afternoon: 'eftermiddag',
        evening: 'aften',
        night: 'nat'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'morgen',
        afternoon: 'eftermiddag',
        evening: 'aften',
        night: 'nat'
    }
};
var $723177907612b0c9$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'om morgenen',
        afternoon: 'om eftermiddagen',
        evening: 'om aftenen',
        night: 'om natten'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'om morgenen',
        afternoon: 'om eftermiddagen',
        evening: 'om aftenen',
        night: 'om natten'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'om morgenen',
        afternoon: 'om eftermiddagen',
        evening: 'om aftenen',
        night: 'om natten'
    }
};
function $723177907612b0c9$var$ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + '.';
}
var $723177907612b0c9$var$localize = {
    ordinalNumber: $723177907612b0c9$var$ordinalNumber,
    era: (0, $7juaq.default)({
        values: $723177907612b0c9$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $7juaq.default)({
        values: $723177907612b0c9$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $7juaq.default)({
        values: $723177907612b0c9$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $7juaq.default)({
        values: $723177907612b0c9$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $7juaq.default)({
        values: $723177907612b0c9$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $723177907612b0c9$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $723177907612b0c9$export$2e2bcd8739ae039 = $723177907612b0c9$var$localize;

});

parcelRegister("d2rW3", function(module, exports) {
$parcel$export(module.exports, "default", () => $97e121a824295143$export$2e2bcd8739ae039);

var $5hQUT = parcelRequire("5hQUT");

var $bFSku = parcelRequire("bFSku");
var $97e121a824295143$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $97e121a824295143$var$parseOrdinalNumberPattern = /\d+/i;
var $97e121a824295143$var$matchEraPatterns = {
    narrow: /^(fKr|fvt|eKr|vt)/i,
    abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
    wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
};
var $97e121a824295143$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^(v|e)/i
    ]
};
var $97e121a824295143$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]. kvt\./i,
    wide: /^[1234]\.? kvartal/i
};
var $97e121a824295143$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $97e121a824295143$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
};
var $97e121a824295143$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $97e121a824295143$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
var $97e121a824295143$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^o/i,
        /^t/i,
        /^f/i,
        /^l/i
    ],
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $97e121a824295143$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
    any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
};
var $97e121a824295143$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /midnat/i,
        noon: /middag/i,
        morning: /morgen/i,
        afternoon: /eftermiddag/i,
        evening: /aften/i,
        night: /nat/i
    }
};
var $97e121a824295143$var$match = {
    ordinalNumber: (0, $bFSku.default)({
        matchPattern: $97e121a824295143$var$matchOrdinalNumberPattern,
        parsePattern: $97e121a824295143$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5hQUT.default)({
        matchPatterns: $97e121a824295143$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $97e121a824295143$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5hQUT.default)({
        matchPatterns: $97e121a824295143$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $97e121a824295143$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $5hQUT.default)({
        matchPatterns: $97e121a824295143$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $97e121a824295143$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5hQUT.default)({
        matchPatterns: $97e121a824295143$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $97e121a824295143$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5hQUT.default)({
        matchPatterns: $97e121a824295143$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $97e121a824295143$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $97e121a824295143$export$2e2bcd8739ae039 = $97e121a824295143$var$match;

});


parcelRegister("lFy5x", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $fc67de87b49b2a8a$export$2e2bcd8739ae039);

var $4VnSl = parcelRequire("4VnSl");

var $fvrlR = parcelRequire("fvrlR");

var $gBgZJ = parcelRequire("gBgZJ");

var $4MxHp = parcelRequire("4MxHp");

var $kMKbp = parcelRequire("kMKbp");
/**
 * @type {Locale}
 * @category Locales
 * @summary German locale.
 * @language German
 * @iso-639-2 deu
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Asia [@asia-t]{@link https://github.com/asia-t}
 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
 * @author RomanErnst [@pex]{@link https://github.com/pex}
 * @author Philipp Keck [@Philipp91]{@link https://github.com/Philipp91}
 */ var $fc67de87b49b2a8a$var$locale = {
    code: 'de',
    formatDistance: (0, $4VnSl.default),
    formatLong: (0, $fvrlR.default),
    formatRelative: (0, $gBgZJ.default),
    localize: (0, $4MxHp.default),
    match: (0, $kMKbp.default),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
    }
};
var $fc67de87b49b2a8a$export$2e2bcd8739ae039 = $fc67de87b49b2a8a$var$locale;

});
parcelRegister("4VnSl", function(module, exports) {
$parcel$export(module.exports, "default", () => $395f017dd0bba881$export$2e2bcd8739ae039);
var $395f017dd0bba881$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: 'weniger als eine Sekunde',
            other: 'weniger als {{count}} Sekunden'
        },
        withPreposition: {
            one: 'weniger als einer Sekunde',
            other: 'weniger als {{count}} Sekunden'
        }
    },
    xSeconds: {
        standalone: {
            one: 'eine Sekunde',
            other: '{{count}} Sekunden'
        },
        withPreposition: {
            one: 'einer Sekunde',
            other: '{{count}} Sekunden'
        }
    },
    halfAMinute: {
        standalone: 'eine halbe Minute',
        withPreposition: 'einer halben Minute'
    },
    lessThanXMinutes: {
        standalone: {
            one: 'weniger als eine Minute',
            other: 'weniger als {{count}} Minuten'
        },
        withPreposition: {
            one: 'weniger als einer Minute',
            other: 'weniger als {{count}} Minuten'
        }
    },
    xMinutes: {
        standalone: {
            one: 'eine Minute',
            other: '{{count}} Minuten'
        },
        withPreposition: {
            one: 'einer Minute',
            other: '{{count}} Minuten'
        }
    },
    aboutXHours: {
        standalone: {
            one: 'etwa eine Stunde',
            other: 'etwa {{count}} Stunden'
        },
        withPreposition: {
            one: 'etwa einer Stunde',
            other: 'etwa {{count}} Stunden'
        }
    },
    xHours: {
        standalone: {
            one: 'eine Stunde',
            other: '{{count}} Stunden'
        },
        withPreposition: {
            one: 'einer Stunde',
            other: '{{count}} Stunden'
        }
    },
    xDays: {
        standalone: {
            one: 'ein Tag',
            other: '{{count}} Tage'
        },
        withPreposition: {
            one: 'einem Tag',
            other: '{{count}} Tagen'
        }
    },
    aboutXWeeks: {
        standalone: {
            one: 'etwa ein Woche',
            other: 'etwa {{count}} Wochen'
        },
        withPreposition: {
            one: 'etwa einem Woche',
            other: 'etwa {{count}} Wochen'
        }
    },
    xWeeks: {
        standalone: {
            one: 'ein Woche',
            other: '{{count}} Wochen'
        },
        withPreposition: {
            one: 'einem Woche',
            other: '{{count}} Wochen'
        }
    },
    aboutXMonths: {
        standalone: {
            one: 'etwa ein Monat',
            other: 'etwa {{count}} Monate'
        },
        withPreposition: {
            one: 'etwa einem Monat',
            other: 'etwa {{count}} Monaten'
        }
    },
    xMonths: {
        standalone: {
            one: 'ein Monat',
            other: '{{count}} Monate'
        },
        withPreposition: {
            one: 'einem Monat',
            other: '{{count}} Monaten'
        }
    },
    aboutXYears: {
        standalone: {
            one: 'etwa ein Jahr',
            other: 'etwa {{count}} Jahre'
        },
        withPreposition: {
            one: 'etwa einem Jahr',
            other: 'etwa {{count}} Jahren'
        }
    },
    xYears: {
        standalone: {
            one: 'ein Jahr',
            other: '{{count}} Jahre'
        },
        withPreposition: {
            one: 'einem Jahr',
            other: '{{count}} Jahren'
        }
    },
    overXYears: {
        standalone: {
            one: 'mehr als ein Jahr',
            other: 'mehr als {{count}} Jahre'
        },
        withPreposition: {
            one: 'mehr als einem Jahr',
            other: 'mehr als {{count}} Jahren'
        }
    },
    almostXYears: {
        standalone: {
            one: 'fast ein Jahr',
            other: 'fast {{count}} Jahre'
        },
        withPreposition: {
            one: 'fast einem Jahr',
            other: 'fast {{count}} Jahren'
        }
    }
};
var $395f017dd0bba881$var$formatDistance = function(token, count, options) {
    options = options || {};
    var usageGroup = options.addSuffix ? $395f017dd0bba881$var$formatDistanceLocale[token].withPreposition : $395f017dd0bba881$var$formatDistanceLocale[token].standalone;
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return 'vor ' + result;
    }
    return result;
};
var $395f017dd0bba881$export$2e2bcd8739ae039 = $395f017dd0bba881$var$formatDistance;

});

parcelRegister("fvrlR", function(module, exports) {
$parcel$export(module.exports, "default", () => $b49ef7b4841cac0b$export$2e2bcd8739ae039);

var $8D7sK = parcelRequire("8D7sK");
// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
var $b49ef7b4841cac0b$var$dateFormats = {
    full: 'EEEE, do MMMM y',
    // Montag, 7. Januar 2018
    long: 'do MMMM y',
    // 7. Januar 2018
    medium: 'do MMM y',
    // 7. Jan. 2018
    short: 'dd.MM.y' // 07.01.2018
};
var $b49ef7b4841cac0b$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $b49ef7b4841cac0b$var$dateTimeFormats = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $b49ef7b4841cac0b$var$formatLong = {
    date: (0, $8D7sK.default)({
        formats: $b49ef7b4841cac0b$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $8D7sK.default)({
        formats: $b49ef7b4841cac0b$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $8D7sK.default)({
        formats: $b49ef7b4841cac0b$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $b49ef7b4841cac0b$export$2e2bcd8739ae039 = $b49ef7b4841cac0b$var$formatLong;

});

parcelRegister("gBgZJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $c15d48d2bc03e946$export$2e2bcd8739ae039);
var $c15d48d2bc03e946$var$formatRelativeLocale = {
    lastWeek: "'letzten' eeee 'um' p",
    yesterday: "'gestern um' p",
    today: "'heute um' p",
    tomorrow: "'morgen um' p",
    nextWeek: "eeee 'um' p",
    other: 'P'
};
var $c15d48d2bc03e946$var$formatRelative = function(token, _date, _baseDate, _options) {
    return $c15d48d2bc03e946$var$formatRelativeLocale[token];
};
var $c15d48d2bc03e946$export$2e2bcd8739ae039 = $c15d48d2bc03e946$var$formatRelative;

});

parcelRegister("4MxHp", function(module, exports) {
$parcel$export(module.exports, "default", () => $37b5c90eeadf53ba$export$2e2bcd8739ae039);

var $7juaq = parcelRequire("7juaq");
var $37b5c90eeadf53ba$var$eraValues = {
    narrow: [
        'v.Chr.',
        'n.Chr.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'vor Christus',
        'nach Christus'
    ]
};
var $37b5c90eeadf53ba$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. Quartal',
        '2. Quartal',
        '3. Quartal',
        '4. Quartal'
    ]
}; // Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $37b5c90eeadf53ba$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan.',
        'Feb.',
        "M\xe4rz",
        'Apr.',
        'Mai',
        'Juni',
        'Juli',
        'Aug.',
        'Sep.',
        'Okt.',
        'Nov.',
        'Dez.'
    ],
    wide: [
        'Januar',
        'Februar',
        "M\xe4rz",
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
    ]
};
var $37b5c90eeadf53ba$var$dayValues = {
    narrow: [
        'S',
        'M',
        'D',
        'M',
        'D',
        'F',
        'S'
    ],
    short: [
        'So',
        'Mo',
        'Di',
        'Mi',
        'Do',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'So.',
        'Mo.',
        'Di.',
        'Mi.',
        'Do.',
        'Fr.',
        'Sa.'
    ],
    wide: [
        'Sonntag',
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
        'Samstag'
    ]
}; // https://www.unicode.org/cldr/charts/32/summary/de.html#1881
var $37b5c90eeadf53ba$var$dayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachm.',
        evening: 'Abend',
        night: 'Nacht'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    }
};
var $37b5c90eeadf53ba$var$formattingDayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachm.',
        evening: 'abends',
        night: 'nachts'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    }
};
var $37b5c90eeadf53ba$var$ordinalNumber = function(dirtyNumber, _dirtyOptions) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $37b5c90eeadf53ba$var$localize = {
    ordinalNumber: $37b5c90eeadf53ba$var$ordinalNumber,
    era: (0, $7juaq.default)({
        values: $37b5c90eeadf53ba$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $7juaq.default)({
        values: $37b5c90eeadf53ba$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $7juaq.default)({
        values: $37b5c90eeadf53ba$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $7juaq.default)({
        values: $37b5c90eeadf53ba$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $7juaq.default)({
        values: $37b5c90eeadf53ba$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $37b5c90eeadf53ba$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $37b5c90eeadf53ba$export$2e2bcd8739ae039 = $37b5c90eeadf53ba$var$localize;

});

parcelRegister("kMKbp", function(module, exports) {
$parcel$export(module.exports, "default", () => $f21c1d548d1f3f07$export$2e2bcd8739ae039);

var $bFSku = parcelRequire("bFSku");

var $5hQUT = parcelRequire("5hQUT");
var $f21c1d548d1f3f07$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $f21c1d548d1f3f07$var$parseOrdinalNumberPattern = /\d+/i;
var $f21c1d548d1f3f07$var$matchEraPatterns = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
};
var $f21c1d548d1f3f07$var$parseEraPatterns = {
    any: [
        /^v/i,
        /^n/i
    ]
};
var $f21c1d548d1f3f07$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
};
var $f21c1d548d1f3f07$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $f21c1d548d1f3f07$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mär|apr|mai|jun|jul|aug|sep|okt|nov|dez)/i,
    wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
};
var $f21c1d548d1f3f07$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $f21c1d548d1f3f07$var$matchDayPatterns = {
    narrow: /^[smdmf]/i,
    short: /^(so|mo|di|mi|do|fr|sa)/i,
    abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
    wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
};
var $f21c1d548d1f3f07$var$parseDayPatterns = {
    any: [
        /^so/i,
        /^mo/i,
        /^di/i,
        /^mi/i,
        /^do/i,
        /^f/i,
        /^sa/i
    ]
};
var $f21c1d548d1f3f07$var$matchDayPeriodPatterns = {
    narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
};
var $f21c1d548d1f3f07$var$parseDayPeriodPatterns = {
    any: {
        am: /^v/i,
        pm: /^n/i,
        midnight: /^Mitte/i,
        noon: /^Mitta/i,
        morning: /morgens/i,
        afternoon: /nachmittags/i,
        // will never be matched. Afternoon is matched by `pm`
        evening: /abends/i,
        night: /nachts/i // will never be matched. Night is matched by `pm`
    }
};
var $f21c1d548d1f3f07$var$match = {
    ordinalNumber: (0, $bFSku.default)({
        matchPattern: $f21c1d548d1f3f07$var$matchOrdinalNumberPattern,
        parsePattern: $f21c1d548d1f3f07$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value);
        }
    }),
    era: (0, $5hQUT.default)({
        matchPatterns: $f21c1d548d1f3f07$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f21c1d548d1f3f07$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5hQUT.default)({
        matchPatterns: $f21c1d548d1f3f07$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f21c1d548d1f3f07$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $5hQUT.default)({
        matchPatterns: $f21c1d548d1f3f07$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f21c1d548d1f3f07$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5hQUT.default)({
        matchPatterns: $f21c1d548d1f3f07$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f21c1d548d1f3f07$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5hQUT.default)({
        matchPatterns: $f21c1d548d1f3f07$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f21c1d548d1f3f07$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $f21c1d548d1f3f07$export$2e2bcd8739ae039 = $f21c1d548d1f3f07$var$match;

});


parcelRegister("8cBti", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $5f8c82c70620f1ae$export$2e2bcd8739ae039);

var $lwg0B = parcelRequire("lwg0B");

var $fwMHp = parcelRequire("fwMHp");

var $3dUWB = parcelRequire("3dUWB");

var $1R1PY = parcelRequire("1R1PY");

var $hC5J3 = parcelRequire("hC5J3");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Australia).
 * @language English
 * @iso-639-2 eng
 * @author Julien Malige [@JulienMalige]{@link https://github.com/JulienMalige}
 */ var $5f8c82c70620f1ae$var$locale = {
    code: 'en-AU',
    formatDistance: (0, $lwg0B.default),
    formatLong: (0, $fwMHp.default),
    formatRelative: (0, $3dUWB.default),
    localize: (0, $1R1PY.default),
    match: (0, $hC5J3.default),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
    }
};
var $5f8c82c70620f1ae$export$2e2bcd8739ae039 = $5f8c82c70620f1ae$var$locale;

});
parcelRegister("fwMHp", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4df9ed26475a78e$export$2e2bcd8739ae039);

var $8D7sK = parcelRequire("8D7sK");
var $b4df9ed26475a78e$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $b4df9ed26475a78e$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $b4df9ed26475a78e$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $b4df9ed26475a78e$var$formatLong = {
    date: (0, $8D7sK.default)({
        formats: $b4df9ed26475a78e$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $8D7sK.default)({
        formats: $b4df9ed26475a78e$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $8D7sK.default)({
        formats: $b4df9ed26475a78e$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $b4df9ed26475a78e$export$2e2bcd8739ae039 = $b4df9ed26475a78e$var$formatLong;

});


parcelRegister("8JLm6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $65c7427eec5f0ce0$export$2e2bcd8739ae039);

var $lwg0B = parcelRequire("lwg0B");

var $32Rku = parcelRequire("32Rku");

var $3dUWB = parcelRequire("3dUWB");

var $1R1PY = parcelRequire("1R1PY");

var $hC5J3 = parcelRequire("hC5J3");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United Kingdom).
 * @language English
 * @iso-639-2 eng
 * @author Alex [@glintik]{@link https://github.com/glintik}
 */ var $65c7427eec5f0ce0$var$locale = {
    code: 'en-GB',
    formatDistance: (0, $lwg0B.default),
    formatLong: (0, $32Rku.default),
    formatRelative: (0, $3dUWB.default),
    localize: (0, $1R1PY.default),
    match: (0, $hC5J3.default),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
    }
};
var $65c7427eec5f0ce0$export$2e2bcd8739ae039 = $65c7427eec5f0ce0$var$locale;

});
parcelRegister("32Rku", function(module, exports) {
$parcel$export(module.exports, "default", () => $237aed20867afaed$export$2e2bcd8739ae039);

var $8D7sK = parcelRequire("8D7sK");
var $237aed20867afaed$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $237aed20867afaed$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $237aed20867afaed$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $237aed20867afaed$var$formatLong = {
    date: (0, $8D7sK.default)({
        formats: $237aed20867afaed$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $8D7sK.default)({
        formats: $237aed20867afaed$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $8D7sK.default)({
        formats: $237aed20867afaed$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $237aed20867afaed$export$2e2bcd8739ae039 = $237aed20867afaed$var$formatLong;

});


parcelRegister("gqB2k", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $bf5bcdba50996a33$export$2e2bcd8739ae039);

var $4PJ7W = parcelRequire("4PJ7W");

var $a75gh = parcelRequire("a75gh");

var $44ffK = parcelRequire("44ffK");

var $c7MJo = parcelRequire("c7MJo");

var $8syE8 = parcelRequire("8syE8");
/**
 * @type {Locale}
 * @category Locales
 * @summary Spanish locale.
 * @language Spanish
 * @iso-639-2 spa
 * @author Juan Angosto [@juanangosto]{@link https://github.com/juanangosto}
 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
 * @author Fernando Agüero [@fjaguero]{@link https://github.com/fjaguero}
 * @author Gastón Haro [@harogaston]{@link https://github.com/harogaston}
 * @author Yago Carballo [@YagoCarballo]{@link https://github.com/YagoCarballo}
 */ var $bf5bcdba50996a33$var$locale = {
    code: 'es',
    formatDistance: (0, $4PJ7W.default),
    formatLong: (0, $a75gh.default),
    formatRelative: (0, $44ffK.default),
    localize: (0, $c7MJo.default),
    match: (0, $8syE8.default),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
    }
};
var $bf5bcdba50996a33$export$2e2bcd8739ae039 = $bf5bcdba50996a33$var$locale;

});
parcelRegister("4PJ7W", function(module, exports) {
$parcel$export(module.exports, "default", () => $384eee2a9e8f5844$export$2e2bcd8739ae039);
var $384eee2a9e8f5844$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos de un segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'medio minuto',
    lessThanXMinutes: {
        one: 'menos de un minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'alrededor de 1 hora',
        other: 'alrededor de {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: "1 d\xeda",
        other: "{{count}} d\xedas"
    },
    aboutXWeeks: {
        one: 'alrededor de 1 semana',
        other: 'alrededor de {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: 'alrededor de 1 mes',
        other: 'alrededor de {{count}} meses'
    },
    xMonths: {
        one: '1 mes',
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: "alrededor de 1 a\xf1o",
        other: "alrededor de {{count}} a\xf1os"
    },
    xYears: {
        one: "1 a\xf1o",
        other: "{{count}} a\xf1os"
    },
    overXYears: {
        one: "m\xe1s de 1 a\xf1o",
        other: "m\xe1s de {{count}} a\xf1os"
    },
    almostXYears: {
        one: "casi 1 a\xf1o",
        other: "casi {{count}} a\xf1os"
    }
};
function $384eee2a9e8f5844$export$2e2bcd8739ae039(token, count, options) {
    options = options || {};
    var result;
    if (typeof $384eee2a9e8f5844$var$formatDistanceLocale[token] === 'string') result = $384eee2a9e8f5844$var$formatDistanceLocale[token];
    else if (count === 1) result = $384eee2a9e8f5844$var$formatDistanceLocale[token].one;
    else result = $384eee2a9e8f5844$var$formatDistanceLocale[token].other.replace('{{count}}', count);
    if (options.addSuffix) {
        if (options.comparison > 0) return 'en ' + result;
        else return 'hace ' + result;
    }
    return result;
}

});

parcelRegister("a75gh", function(module, exports) {
$parcel$export(module.exports, "default", () => $75cea3a7427c4bce$export$2e2bcd8739ae039);

var $8D7sK = parcelRequire("8D7sK");
var $75cea3a7427c4bce$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $75cea3a7427c4bce$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $75cea3a7427c4bce$var$dateTimeFormats = {
    full: "{{date}} 'a las' {{time}}",
    long: "{{date}} 'a las' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $75cea3a7427c4bce$var$formatLong = {
    date: (0, $8D7sK.default)({
        formats: $75cea3a7427c4bce$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $8D7sK.default)({
        formats: $75cea3a7427c4bce$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $8D7sK.default)({
        formats: $75cea3a7427c4bce$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $75cea3a7427c4bce$export$2e2bcd8739ae039 = $75cea3a7427c4bce$var$formatLong;

});

parcelRegister("44ffK", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f635e152d80d3ff$export$2e2bcd8739ae039);
var $2f635e152d80d3ff$var$formatRelativeLocale = {
    lastWeek: "'el' eeee 'pasado a la' LT",
    yesterday: "'ayer a la' p",
    today: "'hoy a la' p",
    tomorrow: "'ma\xf1ana a la' p",
    nextWeek: "eeee 'a la' p",
    other: 'P'
};
var $2f635e152d80d3ff$var$formatRelativeLocalePlural = {
    lastWeek: "'el' eeee 'pasado a las' p",
    yesterday: "'ayer a las' p",
    today: "'hoy a las' p",
    tomorrow: "'ma\xf1ana a las' p",
    nextWeek: "eeee 'a las' p",
    other: 'P'
};
function $2f635e152d80d3ff$export$2e2bcd8739ae039(token, date, _baseDate, _options) {
    if (date.getUTCHours() !== 1) return $2f635e152d80d3ff$var$formatRelativeLocalePlural[token];
    return $2f635e152d80d3ff$var$formatRelativeLocale[token];
}

});

parcelRegister("c7MJo", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d3bf0732ba83e6d$export$2e2bcd8739ae039);

var $7juaq = parcelRequire("7juaq");
var $8d3bf0732ba83e6d$var$eraValues = {
    narrow: [
        'AC',
        'DC'
    ],
    abbreviated: [
        'AC',
        'DC'
    ],
    wide: [
        'antes de cristo',
        "despu\xe9s de cristo"
    ]
};
var $8d3bf0732ba83e6d$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $8d3bf0732ba83e6d$var$monthValues = {
    narrow: [
        'e',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'ene',
        'feb',
        'mar',
        'abr',
        'may',
        'jun',
        'jul',
        'ago',
        'sep',
        'oct',
        'nov',
        'dic'
    ],
    wide: [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre'
    ]
};
var $8d3bf0732ba83e6d$var$dayValues = {
    narrow: [
        'd',
        'l',
        'm',
        'm',
        'j',
        'v',
        's'
    ],
    short: [
        'do',
        'lu',
        'ma',
        'mi',
        'ju',
        'vi',
        'sa'
    ],
    abbreviated: [
        'dom',
        'lun',
        'mar',
        "mi\xe9",
        'jue',
        'vie',
        "s\xe1b"
    ],
    wide: [
        'domingo',
        'lunes',
        'martes',
        "mi\xe9rcoles",
        'jueves',
        'viernes',
        "s\xe1bado"
    ]
};
var $8d3bf0732ba83e6d$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "ma\xf1ana",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noche'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "ma\xf1ana",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noche'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "ma\xf1ana",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noche'
    }
};
var $8d3bf0732ba83e6d$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "de la ma\xf1ana",
        afternoon: 'de la tarde',
        evening: 'de la tarde',
        night: 'de la noche'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "de la ma\xf1ana",
        afternoon: 'de la tarde',
        evening: 'de la tarde',
        night: 'de la noche'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "de la ma\xf1ana",
        afternoon: 'de la tarde',
        evening: 'de la tarde',
        night: 'de la noche'
    }
};
function $8d3bf0732ba83e6d$var$ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + "\xba";
}
var $8d3bf0732ba83e6d$var$localize = {
    ordinalNumber: $8d3bf0732ba83e6d$var$ordinalNumber,
    era: (0, $7juaq.default)({
        values: $8d3bf0732ba83e6d$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $7juaq.default)({
        values: $8d3bf0732ba83e6d$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $7juaq.default)({
        values: $8d3bf0732ba83e6d$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $7juaq.default)({
        values: $8d3bf0732ba83e6d$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $7juaq.default)({
        values: $8d3bf0732ba83e6d$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $8d3bf0732ba83e6d$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $8d3bf0732ba83e6d$export$2e2bcd8739ae039 = $8d3bf0732ba83e6d$var$localize;

});

parcelRegister("8syE8", function(module, exports) {
$parcel$export(module.exports, "default", () => $628bd045c68f6b3c$export$2e2bcd8739ae039);

var $bFSku = parcelRequire("bFSku");

var $5hQUT = parcelRequire("5hQUT");
var $628bd045c68f6b3c$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var $628bd045c68f6b3c$var$parseOrdinalNumberPattern = /\d+/i;
var $628bd045c68f6b3c$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
};
var $628bd045c68f6b3c$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes de la era com[uú]n)/i,
        /^(despu[eé]s de cristo|era com[uú]n)/i
    ]
};
var $628bd045c68f6b3c$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $628bd045c68f6b3c$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $628bd045c68f6b3c$var$matchMonthPatterns = {
    narrow: /^[efmajsond]/i,
    abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
    wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
};
var $628bd045c68f6b3c$var$parseMonthPatterns = {
    narrow: [
        /^e/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^en/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i
    ]
};
var $628bd045c68f6b3c$var$matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(do|lu|ma|mi|ju|vi|sa)/i,
    abbreviated: /^(dom|lun|mar|mie|jue|vie|sab)/i,
    wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
};
var $628bd045c68f6b3c$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^do/i,
        /^lu/i,
        /^ma/i,
        /^mi/i,
        /^ju/i,
        /^vi/i,
        /^sa/i
    ]
};
var $628bd045c68f6b3c$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
    any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
};
var $628bd045c68f6b3c$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañana/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noche/i
    }
};
var $628bd045c68f6b3c$var$match = {
    ordinalNumber: (0, $bFSku.default)({
        matchPattern: $628bd045c68f6b3c$var$matchOrdinalNumberPattern,
        parsePattern: $628bd045c68f6b3c$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5hQUT.default)({
        matchPatterns: $628bd045c68f6b3c$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $628bd045c68f6b3c$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5hQUT.default)({
        matchPatterns: $628bd045c68f6b3c$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $628bd045c68f6b3c$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $5hQUT.default)({
        matchPatterns: $628bd045c68f6b3c$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $628bd045c68f6b3c$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5hQUT.default)({
        matchPatterns: $628bd045c68f6b3c$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $628bd045c68f6b3c$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5hQUT.default)({
        matchPatterns: $628bd045c68f6b3c$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $628bd045c68f6b3c$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $628bd045c68f6b3c$export$2e2bcd8739ae039 = $628bd045c68f6b3c$var$match;

});


parcelRegister("7eJKK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $544d54d041cd80a4$export$2e2bcd8739ae039);

var $iQuqd = parcelRequire("iQuqd");

var $8A11F = parcelRequire("8A11F");

var $9GBcU = parcelRequire("9GBcU");

var $5hewB = parcelRequire("5hewB");

var $fCzU5 = parcelRequire("fCzU5");
/**
 * @type {Locale}
 * @category Locales
 * @summary Finnish locale.
 * @language Finnish
 * @iso-639-2 fin
 * @author Pyry-Samuli Lahti [@Pyppe]{@link https://github.com/Pyppe}
 * @author Edo Rivai [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Samu Juvonen [@sjuvonen]{@link https://github.com/sjuvonen}
 */ var $544d54d041cd80a4$var$locale = {
    code: 'fi',
    formatDistance: (0, $iQuqd.default),
    formatLong: (0, $8A11F.default),
    formatRelative: (0, $9GBcU.default),
    localize: (0, $5hewB.default),
    match: (0, $fCzU5.default),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
    }
};
var $544d54d041cd80a4$export$2e2bcd8739ae039 = $544d54d041cd80a4$var$locale;

});
parcelRegister("iQuqd", function(module, exports) {
$parcel$export(module.exports, "default", () => $db84ae7c0eec9d1c$export$2e2bcd8739ae039);
function $db84ae7c0eec9d1c$var$futureSeconds(text) {
    return text.replace(/sekuntia?/, 'sekunnin');
}
function $db84ae7c0eec9d1c$var$futureMinutes(text) {
    return text.replace(/minuuttia?/, 'minuutin');
}
function $db84ae7c0eec9d1c$var$futureHours(text) {
    return text.replace(/tuntia?/, 'tunnin');
}
function $db84ae7c0eec9d1c$var$futureDays(text) {
    return text.replace(/päivää?/, "p\xe4iv\xe4n");
}
function $db84ae7c0eec9d1c$var$futureWeeks(text) {
    return text.replace(/(viikko|viikkoa)/, 'viikon');
}
function $db84ae7c0eec9d1c$var$futureMonths(text) {
    return text.replace(/(kuukausi|kuukautta)/, 'kuukauden');
}
function $db84ae7c0eec9d1c$var$futureYears(text) {
    return text.replace(/(vuosi|vuotta)/, 'vuoden');
}
var $db84ae7c0eec9d1c$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'alle sekunti',
        other: 'alle {{count}} sekuntia',
        futureTense: $db84ae7c0eec9d1c$var$futureSeconds
    },
    xSeconds: {
        one: 'sekunti',
        other: '{{count}} sekuntia',
        futureTense: $db84ae7c0eec9d1c$var$futureSeconds
    },
    halfAMinute: {
        one: 'puoli minuuttia',
        other: 'puoli minuuttia',
        futureTense: function(_text) {
            return 'puolen minuutin';
        }
    },
    lessThanXMinutes: {
        one: 'alle minuutti',
        other: 'alle {{count}} minuuttia',
        futureTense: $db84ae7c0eec9d1c$var$futureMinutes
    },
    xMinutes: {
        one: 'minuutti',
        other: '{{count}} minuuttia',
        futureTense: $db84ae7c0eec9d1c$var$futureMinutes
    },
    aboutXHours: {
        one: 'noin tunti',
        other: 'noin {{count}} tuntia',
        futureTense: $db84ae7c0eec9d1c$var$futureHours
    },
    xHours: {
        one: 'tunti',
        other: '{{count}} tuntia',
        futureTense: $db84ae7c0eec9d1c$var$futureHours
    },
    xDays: {
        one: "p\xe4iv\xe4",
        other: "{{count}} p\xe4iv\xe4\xe4",
        futureTense: $db84ae7c0eec9d1c$var$futureDays
    },
    aboutXWeeks: {
        one: 'noin viikko',
        other: 'noin {{count}} viikkoa',
        futureTense: $db84ae7c0eec9d1c$var$futureWeeks
    },
    xWeeks: {
        one: 'viikko',
        other: '{{count}} viikkoa',
        futureTense: $db84ae7c0eec9d1c$var$futureWeeks
    },
    aboutXMonths: {
        one: 'noin kuukausi',
        other: 'noin {{count}} kuukautta',
        futureTense: $db84ae7c0eec9d1c$var$futureMonths
    },
    xMonths: {
        one: 'kuukausi',
        other: '{{count}} kuukautta',
        futureTense: $db84ae7c0eec9d1c$var$futureMonths
    },
    aboutXYears: {
        one: 'noin vuosi',
        other: 'noin {{count}} vuotta',
        futureTense: $db84ae7c0eec9d1c$var$futureYears
    },
    xYears: {
        one: 'vuosi',
        other: '{{count}} vuotta',
        futureTense: $db84ae7c0eec9d1c$var$futureYears
    },
    overXYears: {
        one: 'yli vuosi',
        other: 'yli {{count}} vuotta',
        futureTense: $db84ae7c0eec9d1c$var$futureYears
    },
    almostXYears: {
        one: "l\xe4hes vuosi",
        other: "l\xe4hes {{count}} vuotta",
        futureTense: $db84ae7c0eec9d1c$var$futureYears
    }
};
function $db84ae7c0eec9d1c$export$2e2bcd8739ae039(token, count, options) {
    options = options || {};
    var distance = $db84ae7c0eec9d1c$var$formatDistanceLocale[token];
    var result = count === 1 ? distance.one : distance.other.replace('{{count}}', count);
    if (options.addSuffix) {
        if (options.comparison > 0) return distance.futureTense(result) + ' kuluttua';
        else return result + ' sitten';
    }
    return result;
}

});

parcelRegister("8A11F", function(module, exports) {
$parcel$export(module.exports, "default", () => $63f27b3c38997dbe$export$2e2bcd8739ae039);

var $8D7sK = parcelRequire("8D7sK");
var $63f27b3c38997dbe$var$dateFormats = {
    full: 'eeee d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'd.M.y'
};
var $63f27b3c38997dbe$var$timeFormats = {
    full: 'HH.mm.ss zzzz',
    long: 'HH.mm.ss z',
    medium: 'HH.mm.ss',
    short: 'HH.mm'
};
var $63f27b3c38997dbe$var$dateTimeFormats = {
    full: "{{date}} 'klo' {{time}}",
    long: "{{date}} 'klo' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $63f27b3c38997dbe$var$formatLong = {
    date: (0, $8D7sK.default)({
        formats: $63f27b3c38997dbe$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $8D7sK.default)({
        formats: $63f27b3c38997dbe$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $8D7sK.default)({
        formats: $63f27b3c38997dbe$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $63f27b3c38997dbe$export$2e2bcd8739ae039 = $63f27b3c38997dbe$var$formatLong;

});

parcelRegister("9GBcU", function(module, exports) {
$parcel$export(module.exports, "default", () => $70d4e5e4bc5dd385$export$2e2bcd8739ae039);
var $70d4e5e4bc5dd385$var$formatRelativeLocale = {
    lastWeek: "'viime' eeee 'klo' p",
    yesterday: "'eilen klo' p",
    today: "'t\xe4n\xe4\xe4n klo' p",
    tomorrow: "'huomenna klo' p",
    nextWeek: "'ensi' eeee 'klo' p",
    other: 'P'
};
function $70d4e5e4bc5dd385$export$2e2bcd8739ae039(token, _date, _baseDate, _options) {
    return $70d4e5e4bc5dd385$var$formatRelativeLocale[token];
}

});

parcelRegister("5hewB", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d79cea0815c3c76$export$2e2bcd8739ae039);

var $7juaq = parcelRequire("7juaq");
var $3d79cea0815c3c76$var$eraValues = {
    narrow: [
        'eaa.',
        'jaa.'
    ],
    abbreviated: [
        'eaa.',
        'jaa.'
    ],
    wide: [
        'ennen ajanlaskun alkua',
        "j\xe4lkeen ajanlaskun alun"
    ]
};
var $3d79cea0815c3c76$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. kvartaali',
        '2. kvartaali',
        '3. kvartaali',
        '4. kvartaali'
    ]
};
var $3d79cea0815c3c76$var$monthValues = {
    narrow: [
        'T',
        'H',
        'M',
        'H',
        'T',
        'K',
        'H',
        'E',
        'S',
        'L',
        'M',
        'J'
    ],
    abbreviated: [
        'tammi',
        'helmi',
        'maalis',
        'huhti',
        'touko',
        "kes\xe4",
        "hein\xe4",
        'elo',
        'syys',
        'loka',
        'marras',
        'joulu'
    ],
    wide: [
        'tammikuu',
        'helmikuu',
        'maaliskuu',
        'huhtikuu',
        'toukokuu',
        "kes\xe4kuu",
        "hein\xe4kuu",
        'elokuu',
        'syyskuu',
        'lokakuu',
        'marraskuu',
        'joulukuu'
    ]
};
var $3d79cea0815c3c76$var$formattingMonthValues = {
    narrow: $3d79cea0815c3c76$var$monthValues.narrow,
    abbreviated: $3d79cea0815c3c76$var$monthValues.abbreviated,
    wide: $3d79cea0815c3c76$var$monthValues.wide.map(function(name) {
        return name + 'ta';
    })
};
var $3d79cea0815c3c76$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'K',
        'T',
        'P',
        'L'
    ],
    short: [
        'su',
        'ma',
        'ti',
        'ke',
        'to',
        'pe',
        'la'
    ],
    abbreviated: [
        'sunn.',
        'maan.',
        'tiis.',
        'kesk.',
        'torst.',
        'perj.',
        'la'
    ],
    wide: [
        'sunnuntai',
        'maanantai',
        'tiistai',
        'keskiviikko',
        'torstai',
        'perjantai',
        'lauantai'
    ]
};
var $3d79cea0815c3c76$var$formattingDayValues = {
    narrow: $3d79cea0815c3c76$var$dayValues.narrow,
    short: $3d79cea0815c3c76$var$dayValues.short,
    abbreviated: $3d79cea0815c3c76$var$dayValues.abbreviated,
    wide: $3d79cea0815c3c76$var$dayValues.wide.map(function(name) {
        return name + 'na';
    })
};
var $3d79cea0815c3c76$var$dayPeriodValues = {
    narrow: {
        am: 'ap',
        pm: 'ip',
        midnight: "keskiy\xf6",
        noon: "keskip\xe4iv\xe4",
        morning: 'ap',
        afternoon: 'ip',
        evening: 'illalla',
        night: "y\xf6ll\xe4"
    },
    abbreviated: {
        am: 'ap',
        pm: 'ip',
        midnight: "keskiy\xf6",
        noon: "keskip\xe4iv\xe4",
        morning: 'ap',
        afternoon: 'ip',
        evening: 'illalla',
        night: "y\xf6ll\xe4"
    },
    wide: {
        am: 'ap',
        pm: 'ip',
        midnight: "keskiy\xf6ll\xe4",
        noon: "keskip\xe4iv\xe4ll\xe4",
        morning: "aamup\xe4iv\xe4ll\xe4",
        afternoon: "iltap\xe4iv\xe4ll\xe4",
        evening: 'illalla',
        night: "y\xf6ll\xe4"
    }
};
function $3d79cea0815c3c76$var$ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + '.';
}
var $3d79cea0815c3c76$var$localize = {
    ordinalNumber: $3d79cea0815c3c76$var$ordinalNumber,
    era: (0, $7juaq.default)({
        values: $3d79cea0815c3c76$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $7juaq.default)({
        values: $3d79cea0815c3c76$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $7juaq.default)({
        values: $3d79cea0815c3c76$var$monthValues,
        formattingValues: $3d79cea0815c3c76$var$formattingMonthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $7juaq.default)({
        values: $3d79cea0815c3c76$var$dayValues,
        formattingValues: $3d79cea0815c3c76$var$formattingDayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $7juaq.default)({
        values: $3d79cea0815c3c76$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $3d79cea0815c3c76$export$2e2bcd8739ae039 = $3d79cea0815c3c76$var$localize;

});

parcelRegister("fCzU5", function(module, exports) {
$parcel$export(module.exports, "default", () => $b5f64151a46aff88$export$2e2bcd8739ae039);

var $bFSku = parcelRequire("bFSku");

var $5hQUT = parcelRequire("5hQUT");
var $b5f64151a46aff88$var$matchOrdinalNumberPattern = /^(\d+)(\.)/i;
var $b5f64151a46aff88$var$parseOrdinalNumberPattern = /\d+/i;
var $b5f64151a46aff88$var$matchEraPatterns = {
    narrow: /^(e|j)/i,
    abbreviated: /^(eaa.|jaa.)/i,
    wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
};
var $b5f64151a46aff88$var$parseEraPatterns = {
    any: [
        /^e/i,
        /^j/i
    ]
};
var $b5f64151a46aff88$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]\.? kvartaali/i
};
var $b5f64151a46aff88$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $b5f64151a46aff88$var$matchMonthPatterns = {
    narrow: /^[thmkeslj]/i,
    abbreviated: /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
    wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
};
var $b5f64151a46aff88$var$parseMonthPatterns = {
    narrow: [
        /^t/i,
        /^h/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^k/i,
        /^h/i,
        /^e/i,
        /^s/i,
        /^l/i,
        /^m/i,
        /^j/i
    ],
    any: [
        /^ta/i,
        /^hel/i,
        /^maa/i,
        /^hu/i,
        /^to/i,
        /^k/i,
        /^hei/i,
        /^e/i,
        /^s/i,
        /^l/i,
        /^mar/i,
        /^j/i
    ]
};
var $b5f64151a46aff88$var$matchDayPatterns = {
    narrow: /^[smtkpl]/i,
    short: /^(su|ma|ti|ke|to|pe|la)/i,
    abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
    wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
};
var $b5f64151a46aff88$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^k/i,
        /^t/i,
        /^p/i,
        /^l/i
    ],
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^k/i,
        /^to/i,
        /^p/i,
        /^l/i
    ]
};
var $b5f64151a46aff88$var$matchDayPeriodPatterns = {
    narrow: /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
    any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
};
var $b5f64151a46aff88$var$parseDayPeriodPatterns = {
    any: {
        am: /^ap/i,
        pm: /^ip/i,
        midnight: /^keskiyö/i,
        noon: /^keskipäivä/i,
        morning: /aamupäivällä/i,
        afternoon: /iltapäivällä/i,
        evening: /illalla/i,
        night: /yöllä/i
    }
};
var $b5f64151a46aff88$var$match = {
    ordinalNumber: (0, $bFSku.default)({
        matchPattern: $b5f64151a46aff88$var$matchOrdinalNumberPattern,
        parsePattern: $b5f64151a46aff88$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5hQUT.default)({
        matchPatterns: $b5f64151a46aff88$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b5f64151a46aff88$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5hQUT.default)({
        matchPatterns: $b5f64151a46aff88$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b5f64151a46aff88$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $5hQUT.default)({
        matchPatterns: $b5f64151a46aff88$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b5f64151a46aff88$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5hQUT.default)({
        matchPatterns: $b5f64151a46aff88$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b5f64151a46aff88$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5hQUT.default)({
        matchPatterns: $b5f64151a46aff88$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $b5f64151a46aff88$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $b5f64151a46aff88$export$2e2bcd8739ae039 = $b5f64151a46aff88$var$match;

});


parcelRegister("2Fw99", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $1f1858bbe329a093$export$2e2bcd8739ae039);

var $gyVnT = parcelRequire("gyVnT");

var $8HStY = parcelRequire("8HStY");

var $1T6XB = parcelRequire("1T6XB");

var $8iCEX = parcelRequire("8iCEX");

var $1aACr = parcelRequire("1aACr");
/**
 * @type {Locale}
 * @category Locales
 * @summary French locale.
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 */ var $1f1858bbe329a093$var$locale = {
    code: 'fr',
    formatDistance: (0, $gyVnT.default),
    formatLong: (0, $8HStY.default),
    formatRelative: (0, $1T6XB.default),
    localize: (0, $8iCEX.default),
    match: (0, $1aACr.default),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
    }
};
var $1f1858bbe329a093$export$2e2bcd8739ae039 = $1f1858bbe329a093$var$locale;

});
parcelRegister("gyVnT", function(module, exports) {
$parcel$export(module.exports, "default", () => $c0ec55a2c300935d$export$2e2bcd8739ae039);
var $c0ec55a2c300935d$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "moins d\u2019une seconde",
        other: 'moins de {{count}} secondes'
    },
    xSeconds: {
        one: '1 seconde',
        other: '{{count}} secondes'
    },
    halfAMinute: '30 secondes',
    lessThanXMinutes: {
        one: "moins d\u2019une minute",
        other: 'moins de {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'environ 1 heure',
        other: 'environ {{count}} heures'
    },
    xHours: {
        one: '1 heure',
        other: '{{count}} heures'
    },
    xDays: {
        one: '1 jour',
        other: '{{count}} jours'
    },
    aboutXWeeks: {
        one: 'environ 1 semaine',
        other: 'environ {{count}} semaines'
    },
    xWeeks: {
        one: '1 semaine',
        other: '{{count}} semaines'
    },
    aboutXMonths: {
        one: 'environ 1 mois',
        other: 'environ {{count}} mois'
    },
    xMonths: {
        one: '1 mois',
        other: '{{count}} mois'
    },
    aboutXYears: {
        one: 'environ 1 an',
        other: 'environ {{count}} ans'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} ans'
    },
    overXYears: {
        one: "plus d\u2019un an",
        other: 'plus de {{count}} ans'
    },
    almostXYears: {
        one: "presqu\u2019un an",
        other: 'presque {{count}} ans'
    }
};
function $c0ec55a2c300935d$export$2e2bcd8739ae039(token, count, options) {
    options = options || {};
    var result;
    if (typeof $c0ec55a2c300935d$var$formatDistanceLocale[token] === 'string') result = $c0ec55a2c300935d$var$formatDistanceLocale[token];
    else if (count === 1) result = $c0ec55a2c300935d$var$formatDistanceLocale[token].one;
    else result = $c0ec55a2c300935d$var$formatDistanceLocale[token].other.replace('{{count}}', count);
    if (options.addSuffix) {
        if (options.comparison > 0) return 'dans ' + result;
        else return 'il y a ' + result;
    }
    return result;
}

});

parcelRegister("8HStY", function(module, exports) {
$parcel$export(module.exports, "default", () => $656c99ef96cf021d$export$2e2bcd8739ae039);

var $8D7sK = parcelRequire("8D7sK");
var $656c99ef96cf021d$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $656c99ef96cf021d$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $656c99ef96cf021d$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $656c99ef96cf021d$var$formatLong = {
    date: (0, $8D7sK.default)({
        formats: $656c99ef96cf021d$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $8D7sK.default)({
        formats: $656c99ef96cf021d$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $8D7sK.default)({
        formats: $656c99ef96cf021d$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $656c99ef96cf021d$export$2e2bcd8739ae039 = $656c99ef96cf021d$var$formatLong;

});

parcelRegister("1T6XB", function(module, exports) {
$parcel$export(module.exports, "default", () => $160053af7237fe8e$export$2e2bcd8739ae039);
var $160053af7237fe8e$var$formatRelativeLocale = {
    lastWeek: "eeee 'dernier \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'prochain \xe0' p",
    other: 'P'
};
function $160053af7237fe8e$export$2e2bcd8739ae039(token, _date, _baseDate, _options) {
    return $160053af7237fe8e$var$formatRelativeLocale[token];
}

});

parcelRegister("8iCEX", function(module, exports) {
$parcel$export(module.exports, "default", () => $60adfe23f4faae19$export$2e2bcd8739ae039);

var $7juaq = parcelRequire("7juaq");
var $60adfe23f4faae19$var$eraValues = {
    narrow: [
        'av. J.-C',
        'ap. J.-C'
    ],
    abbreviated: [
        'av. J.-C',
        'ap. J.-C'
    ],
    wide: [
        "avant J\xe9sus-Christ",
        "apr\xe8s J\xe9sus-Christ"
    ]
};
var $60adfe23f4faae19$var$quarterValues = {
    narrow: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    abbreviated: [
        '1er trim.',
        "2\xe8me trim.",
        "3\xe8me trim.",
        "4\xe8me trim."
    ],
    wide: [
        '1er trimestre',
        "2\xe8me trimestre",
        "3\xe8me trimestre",
        "4\xe8me trimestre"
    ]
};
var $60adfe23f4faae19$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        "f\xe9vr.",
        'mars',
        'avr.',
        'mai',
        'juin',
        'juil.',
        "ao\xfbt",
        'sept.',
        'oct.',
        'nov.',
        "d\xe9c."
    ],
    wide: [
        'janvier',
        "f\xe9vrier",
        'mars',
        'avril',
        'mai',
        'juin',
        'juillet',
        "ao\xfbt",
        'septembre',
        'octobre',
        'novembre',
        "d\xe9cembre"
    ]
};
var $60adfe23f4faae19$var$dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        'J',
        'V',
        'S'
    ],
    short: [
        'di',
        'lu',
        'ma',
        'me',
        'je',
        've',
        'sa'
    ],
    abbreviated: [
        'dim.',
        'lun.',
        'mar.',
        'mer.',
        'jeu.',
        'ven.',
        'sam.'
    ],
    wide: [
        'dimanche',
        'lundi',
        'mardi',
        'mercredi',
        'jeudi',
        'vendredi',
        'samedi'
    ]
};
var $60adfe23f4faae19$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'mat.',
        afternoon: 'ap.m.',
        evening: 'soir',
        night: 'mat.'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'matin',
        afternoon: "apr\xe8s-midi",
        evening: 'soir',
        night: 'matin'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'du matin',
        afternoon: "de l\u2019apr\xe8s-midi",
        evening: 'du soir',
        night: 'du matin'
    }
};
function $60adfe23f4faae19$var$ordinalNumber(dirtyNumber, dirtyOptions) {
    var number = Number(dirtyNumber);
    var options = dirtyOptions || {};
    var unit = String(options.unit);
    var suffix;
    if (number === 0) return number;
    if (unit === 'year' || unit === 'hour' || unit === 'week') {
        if (number === 1) suffix = "\xe8re";
        else suffix = "\xe8me";
    } else if (number === 1) suffix = 'er';
    else suffix = "\xe8me";
    return number + suffix;
}
var $60adfe23f4faae19$var$localize = {
    ordinalNumber: $60adfe23f4faae19$var$ordinalNumber,
    era: (0, $7juaq.default)({
        values: $60adfe23f4faae19$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $7juaq.default)({
        values: $60adfe23f4faae19$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $7juaq.default)({
        values: $60adfe23f4faae19$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $7juaq.default)({
        values: $60adfe23f4faae19$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $7juaq.default)({
        values: $60adfe23f4faae19$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $60adfe23f4faae19$export$2e2bcd8739ae039 = $60adfe23f4faae19$var$localize;

});

parcelRegister("1aACr", function(module, exports) {
$parcel$export(module.exports, "default", () => $0da32164af4ef8dd$export$2e2bcd8739ae039);

var $bFSku = parcelRequire("bFSku");

var $5hQUT = parcelRequire("5hQUT");
var $0da32164af4ef8dd$var$matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
var $0da32164af4ef8dd$var$parseOrdinalNumberPattern = /\d+/i;
var $0da32164af4ef8dd$var$matchEraPatterns = {
    narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
    abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
var $0da32164af4ef8dd$var$parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
var $0da32164af4ef8dd$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](er|ème|e)? trimestre/i
};
var $0da32164af4ef8dd$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $0da32164af4ef8dd$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
    wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
var $0da32164af4ef8dd$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^av/i,
        /^ma/i,
        /^juin/i,
        /^juil/i,
        /^ao/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $0da32164af4ef8dd$var$matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|lu|ma|me|je|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
    wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
var $0da32164af4ef8dd$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^je/i,
        /^ve/i,
        /^sa/i
    ]
};
var $0da32164af4ef8dd$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
    any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
var $0da32164af4ef8dd$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /soir/i,
        night: /nuit/i
    }
};
var $0da32164af4ef8dd$var$match = {
    ordinalNumber: (0, $bFSku.default)({
        matchPattern: $0da32164af4ef8dd$var$matchOrdinalNumberPattern,
        parsePattern: $0da32164af4ef8dd$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5hQUT.default)({
        matchPatterns: $0da32164af4ef8dd$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0da32164af4ef8dd$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5hQUT.default)({
        matchPatterns: $0da32164af4ef8dd$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0da32164af4ef8dd$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $5hQUT.default)({
        matchPatterns: $0da32164af4ef8dd$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0da32164af4ef8dd$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5hQUT.default)({
        matchPatterns: $0da32164af4ef8dd$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0da32164af4ef8dd$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5hQUT.default)({
        matchPatterns: $0da32164af4ef8dd$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $0da32164af4ef8dd$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $0da32164af4ef8dd$export$2e2bcd8739ae039 = $0da32164af4ef8dd$var$match;

});


parcelRegister("eeShq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $02acd8af17d770d4$export$2e2bcd8739ae039);

var $ddZie = parcelRequire("ddZie");

var $ixsLS = parcelRequire("ixsLS");

var $btdJu = parcelRequire("btdJu");

var $cxtm7 = parcelRequire("cxtm7");

var $4MIqb = parcelRequire("4MIqb");
/**
 * @type {Locale}
 * @category Locales
 *
 * @summary Hungarian locale.
 * @language Hungarian
 *
 * @iso-639-2 hun
 *
 * @author Pavlo Shpak [@pshpak]{@link https://github.com/pshpak}
 * @author Eduardo Pardo [@eduardopsll]{@link https://github.com/eduardopsll}
 * @author Zoltan Szepesi [@twodcube]{@link https://github.com/twodcube}
 */ var $02acd8af17d770d4$var$locale = {
    code: 'hu',
    formatDistance: (0, $ddZie.default),
    formatLong: (0, $ixsLS.default),
    formatRelative: (0, $btdJu.default),
    localize: (0, $cxtm7.default),
    match: (0, $4MIqb.default),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
    }
};
var $02acd8af17d770d4$export$2e2bcd8739ae039 = $02acd8af17d770d4$var$locale;

});
parcelRegister("ddZie", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a0c08c92e5a4a17$export$2e2bcd8739ae039);
var $9a0c08c92e5a4a17$var$translations = {
    about: "k\xf6r\xfclbel\xfcl",
    over: "t\xf6bb mint",
    almost: 'majdnem',
    lessthan: 'kevesebb mint'
};
var $9a0c08c92e5a4a17$var$withoutSuffixes = {
    xseconds: " m\xe1sodperc",
    halfaminute: "f\xe9l perc",
    xminutes: ' perc',
    xhours: " \xf3ra",
    xdays: ' nap',
    xweeks: " h\xe9t",
    xmonths: " h\xf3nap",
    xyears: " \xe9v"
};
var $9a0c08c92e5a4a17$var$withSuffixes = {
    xseconds: {
        '-1': " m\xe1sodperccel ezel\u0151tt",
        '1': " m\xe1sodperc m\xfalva",
        '0': " m\xe1sodperce"
    },
    halfaminute: {
        '-1': "f\xe9l perccel ezel\u0151tt",
        '1': "f\xe9l perc m\xfalva",
        '0': "f\xe9l perce"
    },
    xminutes: {
        '-1': " perccel ezel\u0151tt",
        '1': " perc m\xfalva",
        '0': ' perce'
    },
    xhours: {
        '-1': " \xf3r\xe1val ezel\u0151tt",
        '1': " \xf3ra m\xfalva",
        '0': " \xf3r\xe1ja"
    },
    xdays: {
        '-1': " nappal ezel\u0151tt",
        '1': " nap m\xfalva",
        '0': ' napja'
    },
    xweeks: {
        '-1': " h\xe9ttel ezel\u0151tt",
        '1': " h\xe9t m\xfalva",
        '0': ' hete'
    },
    xmonths: {
        '-1': " h\xf3nappal ezel\u0151tt",
        '1': " h\xf3nap m\xfalva",
        '0': " h\xf3napja"
    },
    xyears: {
        '-1': " \xe9vvel ezel\u0151tt",
        '1': " \xe9v m\xfalva",
        '0': " \xe9ve"
    }
};
function $9a0c08c92e5a4a17$var$translate(number, addSuffix, key, comparison) {
    var translated = addSuffix ? $9a0c08c92e5a4a17$var$withSuffixes[key][comparison] : $9a0c08c92e5a4a17$var$withoutSuffixes[key];
    if (key === 'halfaminute') return translated;
    return number + translated;
}
function $9a0c08c92e5a4a17$export$2e2bcd8739ae039(token, count, options) {
    options = options || {};
    var adverb = token.match(/about|over|almost|lessthan/i);
    var unit = token.replace(adverb, '');
    var result;
    result = $9a0c08c92e5a4a17$var$translate(count, options.addSuffix, unit.toLowerCase(), options.comparison);
    if (adverb) result = $9a0c08c92e5a4a17$var$translations[adverb[0].toLowerCase()] + ' ' + result;
    return result;
}

});

parcelRegister("ixsLS", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7f1a07328bfe850$export$2e2bcd8739ae039);

var $8D7sK = parcelRequire("8D7sK");
var $d7f1a07328bfe850$var$dateFormats = {
    full: 'y. MMMM d., EEEE',
    long: 'y. MMMM d.',
    medium: 'y. MMM d.',
    short: 'y. MM. dd.'
};
var $d7f1a07328bfe850$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $d7f1a07328bfe850$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $d7f1a07328bfe850$var$formatLong = {
    date: (0, $8D7sK.default)({
        formats: $d7f1a07328bfe850$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $8D7sK.default)({
        formats: $d7f1a07328bfe850$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $8D7sK.default)({
        formats: $d7f1a07328bfe850$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $d7f1a07328bfe850$export$2e2bcd8739ae039 = $d7f1a07328bfe850$var$formatLong;

});

parcelRegister("btdJu", function(module, exports) {
$parcel$export(module.exports, "default", () => $859d0e2847a6da96$export$2e2bcd8739ae039);
var $859d0e2847a6da96$var$accusativeWeekdays = [
    "vas\xe1rnap",
    "h\xe9tf\u0151n",
    'kedden',
    "szerd\xe1n",
    "cs\xfct\xf6rt\xf6k\xf6n",
    "p\xe9nteken",
    'szombaton'
];
function $859d0e2847a6da96$var$week(isFuture) {
    return function(date, _baseDate, _options) {
        var day = date.getUTCDay();
        return (isFuture ? '' : "'m\xfalt' ") + "'" + $859d0e2847a6da96$var$accusativeWeekdays[day] + "'" + " p'-kor'";
    };
}
var $859d0e2847a6da96$var$formatRelativeLocale = {
    lastWeek: $859d0e2847a6da96$var$week(false),
    yesterday: "'tegnap' p'-kor'",
    today: "'ma' p'-kor'",
    tomorrow: "'holnap' p'-kor'",
    nextWeek: $859d0e2847a6da96$var$week(true),
    other: 'P'
};
function $859d0e2847a6da96$export$2e2bcd8739ae039(token, date, baseDate, options) {
    var format = $859d0e2847a6da96$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
}

});

parcelRegister("cxtm7", function(module, exports) {
$parcel$export(module.exports, "default", () => $920f5687857adb2d$export$2e2bcd8739ae039);

var $7juaq = parcelRequire("7juaq");
var $920f5687857adb2d$var$eraValues = {
    narrow: [
        'ie.',
        'isz.'
    ],
    abbreviated: [
        'i. e.',
        'i. sz.'
    ],
    wide: [
        "Krisztus el\u0151tt",
        "id\u0151sz\xe1m\xedt\xe1sunk szerint"
    ]
};
var $920f5687857adb2d$var$quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        "1. n.\xe9v",
        "2. n.\xe9v",
        "3. n.\xe9v",
        "4. n.\xe9v"
    ],
    wide: [
        "1. negyed\xe9v",
        "2. negyed\xe9v",
        "3. negyed\xe9v",
        "4. negyed\xe9v"
    ]
};
var $920f5687857adb2d$var$formattingQuarterValues = {
    narrow: [
        'I.',
        'II.',
        'III.',
        'IV.'
    ],
    abbreviated: [
        "I. n.\xe9v",
        "II. n.\xe9v",
        "III. n.\xe9v",
        "IV. n.\xe9v"
    ],
    wide: [
        "I. negyed\xe9v",
        "II. negyed\xe9v",
        "III. negyed\xe9v",
        "IV. negyed\xe9v"
    ]
};
var $920f5687857adb2d$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        "\xc1",
        'M',
        'J',
        'J',
        'A',
        'Sz',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'febr.',
        "m\xe1rc.",
        "\xe1pr.",
        "m\xe1j.",
        "j\xfan.",
        "j\xfal.",
        'aug.',
        'szept.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        "janu\xe1r",
        "febru\xe1r",
        "m\xe1rcius",
        "\xe1prilis",
        "m\xe1jus",
        "j\xfanius",
        "j\xfalius",
        'augusztus',
        'szeptember',
        "okt\xf3ber",
        'november',
        'december'
    ]
};
var $920f5687857adb2d$var$dayValues = {
    narrow: [
        'V',
        'H',
        'K',
        'Sz',
        'Cs',
        'P',
        'Sz'
    ],
    short: [
        'V',
        'H',
        'K',
        'Sze',
        'Cs',
        'P',
        'Szo'
    ],
    abbreviated: [
        'V',
        'H',
        'K',
        'Sze',
        'Cs',
        'P',
        'Szo'
    ],
    wide: [
        "vas\xe1rnap",
        "h\xe9tf\u0151",
        'kedd',
        'szerda',
        "cs\xfct\xf6rt\xf6k",
        "p\xe9ntek",
        'szombat'
    ]
};
var $920f5687857adb2d$var$dayPeriodValues = {
    narrow: {
        am: 'de.',
        pm: 'du.',
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: 'reggel',
        afternoon: 'du.',
        evening: 'este',
        night: "\xe9jjel"
    },
    abbreviated: {
        am: 'de.',
        pm: 'du.',
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: 'reggel',
        afternoon: 'du.',
        evening: 'este',
        night: "\xe9jjel"
    },
    wide: {
        am: 'de.',
        pm: 'du.',
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: 'reggel',
        afternoon: "d\xe9lut\xe1n",
        evening: 'este',
        night: "\xe9jjel"
    }
};
function $920f5687857adb2d$var$ordinalNumber(dirtyNumber, _dirtyOptions) {
    var number = Number(dirtyNumber);
    return number + '.';
}
var $920f5687857adb2d$var$localize = {
    ordinalNumber: $920f5687857adb2d$var$ordinalNumber,
    era: (0, $7juaq.default)({
        values: $920f5687857adb2d$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $7juaq.default)({
        values: $920f5687857adb2d$var$quarterValues,
        defaultWidth: 'wide',
        formattingValues: $920f5687857adb2d$var$formattingQuarterValues,
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $7juaq.default)({
        values: $920f5687857adb2d$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $7juaq.default)({
        values: $920f5687857adb2d$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $7juaq.default)({
        values: $920f5687857adb2d$var$dayPeriodValues,
        defaultWidth: 'wide',
        defaultFormattingWidth: 'wide'
    })
};
var $920f5687857adb2d$export$2e2bcd8739ae039 = $920f5687857adb2d$var$localize;

});

parcelRegister("4MIqb", function(module, exports) {
$parcel$export(module.exports, "default", () => $37be1a481d3a8b1e$export$2e2bcd8739ae039);

var $bFSku = parcelRequire("bFSku");

var $5hQUT = parcelRequire("5hQUT");
var $37be1a481d3a8b1e$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $37be1a481d3a8b1e$var$parseOrdinalNumberPattern = /\d+/i;
var $37be1a481d3a8b1e$var$matchEraPatterns = {
    narrow: /^(ie\.|isz\.)/i,
    abbreviated: /^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
    wide: /^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i
};
var $37be1a481d3a8b1e$var$parseEraPatterns = {
    narrow: [
        /ie/i,
        /isz/i
    ],
    abbreviated: [
        /^(i\.?\s?e\.?|b\s?ce)/i,
        /^(i\.?\s?sz\.?|c\s?e)/i
    ],
    any: [
        /előtt/i,
        /(szerint|i. sz.)/i
    ]
};
var $37be1a481d3a8b1e$var$matchQuarterPatterns = {
    narrow: /^[1234]\.?/i,
    abbreviated: /^[1234]?\.?\s?n\.év/i,
    wide: /^([1234]|I|II|III|IV)?\.?\s?negyedév/i
};
var $37be1a481d3a8b1e$var$parseQuarterPatterns = {
    any: [
        /1|I$/i,
        /2|II$/i,
        /3|III/i,
        /4|IV/i
    ]
};
var $37be1a481d3a8b1e$var$matchMonthPatterns = {
    narrow: /^[jfmaásond]|sz/i,
    abbreviated: /^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
    wide: /^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i
};
var $37be1a481d3a8b1e$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a|á/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s|sz/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^már/i,
        /^áp/i,
        /^máj/i,
        /^jún/i,
        /^júl/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $37be1a481d3a8b1e$var$matchDayPatterns = {
    narrow: /^([vhkpc]|sz|cs|sz)/i,
    short: /^([vhkp]|sze|cs|szo)/i,
    abbreviated: /^([vhkp]|sze|cs|szo)/i,
    wide: /^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i
};
var $37be1a481d3a8b1e$var$parseDayPatterns = {
    narrow: [
        /^v/i,
        /^h/i,
        /^k/i,
        /^sz/i,
        /^c/i,
        /^p/i,
        /^sz/i
    ],
    any: [
        /^v/i,
        /^h/i,
        /^k/i,
        /^sze/i,
        /^c/i,
        /^p/i,
        /^szo/i
    ]
};
var $37be1a481d3a8b1e$var$matchDayPeriodPatterns = {
    any: /^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i
};
var $37be1a481d3a8b1e$var$parseDayPeriodPatterns = {
    any: {
        am: /^de\.?/i,
        pm: /^du\.?/i,
        midnight: /^éjf/i,
        noon: /^dé/i,
        morning: /reg/i,
        afternoon: /^délu\.?/i,
        evening: /es/i,
        night: /éjj/i
    }
};
var $37be1a481d3a8b1e$var$match = {
    ordinalNumber: (0, $bFSku.default)({
        matchPattern: $37be1a481d3a8b1e$var$matchOrdinalNumberPattern,
        parsePattern: $37be1a481d3a8b1e$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5hQUT.default)({
        matchPatterns: $37be1a481d3a8b1e$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $37be1a481d3a8b1e$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5hQUT.default)({
        matchPatterns: $37be1a481d3a8b1e$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $37be1a481d3a8b1e$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $5hQUT.default)({
        matchPatterns: $37be1a481d3a8b1e$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $37be1a481d3a8b1e$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5hQUT.default)({
        matchPatterns: $37be1a481d3a8b1e$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $37be1a481d3a8b1e$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5hQUT.default)({
        matchPatterns: $37be1a481d3a8b1e$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $37be1a481d3a8b1e$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $37be1a481d3a8b1e$export$2e2bcd8739ae039 = $37be1a481d3a8b1e$var$match;

});


parcelRegister("6609g", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $47036b142276188e$export$2e2bcd8739ae039);

var $3tQBC = parcelRequire("3tQBC");

var $gWMvr = parcelRequire("gWMvr");

var $dabkz = parcelRequire("dabkz");

var $56o2L = parcelRequire("56o2L");

var $33zcT = parcelRequire("33zcT");
/**
 * @type {Locale}
 * @category Locales
 * @summary Italian locale.
 * @language Italian
 * @iso-639-2 ita
 * @author Alberto Restifo [@albertorestifo]{@link https://github.com/albertorestifo}
 * @author Giovanni Polimeni [@giofilo]{@link https://github.com/giofilo}
 * @author Vincenzo Carrese [@vin-car]{@link https://github.com/vin-car}
 */ var $47036b142276188e$var$locale = {
    code: 'it',
    formatDistance: (0, $3tQBC.default),
    formatLong: (0, $gWMvr.default),
    formatRelative: (0, $dabkz.default),
    localize: (0, $56o2L.default),
    match: (0, $33zcT.default),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
    }
};
var $47036b142276188e$export$2e2bcd8739ae039 = $47036b142276188e$var$locale;

});
parcelRegister("3tQBC", function(module, exports) {
$parcel$export(module.exports, "default", () => $288ce2ee7aca37f8$export$2e2bcd8739ae039);
var $288ce2ee7aca37f8$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'meno di un secondo',
        other: 'meno di {{count}} secondi'
    },
    xSeconds: {
        one: 'un secondo',
        other: '{{count}} secondi'
    },
    halfAMinute: 'alcuni secondi',
    lessThanXMinutes: {
        one: 'meno di un minuto',
        other: 'meno di {{count}} minuti'
    },
    xMinutes: {
        one: 'un minuto',
        other: '{{count}} minuti'
    },
    aboutXHours: {
        one: "circa un'ora",
        other: 'circa {{count}} ore'
    },
    xHours: {
        one: "un'ora",
        other: '{{count}} ore'
    },
    xDays: {
        one: 'un giorno',
        other: '{{count}} giorni'
    },
    aboutXWeeks: {
        one: 'circa una settimana',
        other: 'circa {{count}} settimane'
    },
    xWeeks: {
        one: 'una settimana',
        other: '{{count}} settimane'
    },
    aboutXMonths: {
        one: 'circa un mese',
        other: 'circa {{count}} mesi'
    },
    xMonths: {
        one: 'un mese',
        other: '{{count}} mesi'
    },
    aboutXYears: {
        one: 'circa un anno',
        other: 'circa {{count}} anni'
    },
    xYears: {
        one: 'un anno',
        other: '{{count}} anni'
    },
    overXYears: {
        one: "pi\xf9 di un anno",
        other: "pi\xf9 di {{count}} anni"
    },
    almostXYears: {
        one: 'quasi un anno',
        other: 'quasi {{count}} anni'
    }
};
function $288ce2ee7aca37f8$export$2e2bcd8739ae039(token, count, options) {
    options = options || {};
    var result;
    if (typeof $288ce2ee7aca37f8$var$formatDistanceLocale[token] === 'string') result = $288ce2ee7aca37f8$var$formatDistanceLocale[token];
    else if (count === 1) result = $288ce2ee7aca37f8$var$formatDistanceLocale[token].one;
    else result = $288ce2ee7aca37f8$var$formatDistanceLocale[token].other.replace('{{count}}', count);
    if (options.addSuffix) {
        if (options.comparison > 0) return 'tra ' + result;
        else return result + ' fa';
    }
    return result;
}

});

parcelRegister("gWMvr", function(module, exports) {
$parcel$export(module.exports, "default", () => $c567b06d02ca1318$export$2e2bcd8739ae039);

var $8D7sK = parcelRequire("8D7sK");
var $c567b06d02ca1318$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $c567b06d02ca1318$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $c567b06d02ca1318$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $c567b06d02ca1318$var$formatLong = {
    date: (0, $8D7sK.default)({
        formats: $c567b06d02ca1318$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $8D7sK.default)({
        formats: $c567b06d02ca1318$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $8D7sK.default)({
        formats: $c567b06d02ca1318$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $c567b06d02ca1318$export$2e2bcd8739ae039 = $c567b06d02ca1318$var$formatLong;

});

parcelRegister("dabkz", function(module, exports) {
$parcel$export(module.exports, "default", () => $9954ff9aceb7f3e0$export$2e2bcd8739ae039);

var $2q0eX = parcelRequire("2q0eX");
var $9954ff9aceb7f3e0$var$weekdays = [
    'domenica',
    "luned\xec",
    "marted\xec",
    "mercoled\xec",
    "gioved\xec",
    "venerd\xec",
    'sabato'
];
function $9954ff9aceb7f3e0$var$lastWeek(day) {
    switch(day){
        case 0:
            return "'domenica scorsa alle' p";
        default:
            return "'" + $9954ff9aceb7f3e0$var$weekdays[day] + " scorso alle' p";
    }
}
function $9954ff9aceb7f3e0$var$thisWeek(day) {
    return "'" + $9954ff9aceb7f3e0$var$weekdays[day] + " alle' p";
}
function $9954ff9aceb7f3e0$var$nextWeek(day) {
    switch(day){
        case 0:
            return "'domenica prossima alle' p";
        default:
            return "'" + $9954ff9aceb7f3e0$var$weekdays[day] + " prossimo alle' p";
    }
}
var $9954ff9aceb7f3e0$var$formatRelativeLocale = {
    lastWeek: function(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $2q0eX.default)(date, baseDate, options)) return $9954ff9aceb7f3e0$var$thisWeek(day);
        else return $9954ff9aceb7f3e0$var$lastWeek(day);
    },
    yesterday: "'ieri alle' p",
    today: "'oggi alle' p",
    tomorrow: "'domani alle' p",
    nextWeek: function(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $2q0eX.default)(date, baseDate, options)) return $9954ff9aceb7f3e0$var$thisWeek(day);
        else return $9954ff9aceb7f3e0$var$nextWeek(day);
    },
    other: 'P'
};
function $9954ff9aceb7f3e0$export$2e2bcd8739ae039(token, date, baseDate, options) {
    var format = $9954ff9aceb7f3e0$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
}

});
parcelRegister("2q0eX", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c2e322d38e53fc7$export$2e2bcd8739ae039);

var $1u71N = parcelRequire("1u71N");

var $dwylK = parcelRequire("dwylK");
function $1c2e322d38e53fc7$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight, options) {
    (0, $dwylK.default)(2, arguments);
    var dateLeftStartOfWeek = (0, $1u71N.default)(dirtyDateLeft, options);
    var dateRightStartOfWeek = (0, $1u71N.default)(dirtyDateRight, options);
    return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}

});


parcelRegister("56o2L", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b7029dc63a95a92$export$2e2bcd8739ae039);

var $7juaq = parcelRequire("7juaq");
var $3b7029dc63a95a92$var$eraValues = {
    narrow: [
        'aC',
        'dC'
    ],
    abbreviated: [
        'a.C.',
        'd.C.'
    ],
    wide: [
        'avanti Cristo',
        'dopo Cristo'
    ]
};
var $3b7029dc63a95a92$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $3b7029dc63a95a92$var$monthValues = {
    narrow: [
        'G',
        'F',
        'M',
        'A',
        'M',
        'G',
        'L',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'gen',
        'feb',
        'mar',
        'apr',
        'mag',
        'giu',
        'lug',
        'ago',
        'set',
        'ott',
        'nov',
        'dic'
    ],
    wide: [
        'gennaio',
        'febbraio',
        'marzo',
        'aprile',
        'maggio',
        'giugno',
        'luglio',
        'agosto',
        'settembre',
        'ottobre',
        'novembre',
        'dicembre'
    ]
};
var $3b7029dc63a95a92$var$dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        'G',
        'V',
        'S'
    ],
    short: [
        'dom',
        'lun',
        'mar',
        'mer',
        'gio',
        'ven',
        'sab'
    ],
    abbreviated: [
        'dom',
        'lun',
        'mar',
        'mer',
        'gio',
        'ven',
        'sab'
    ],
    wide: [
        'domenica',
        "luned\xec",
        "marted\xec",
        "mercoled\xec",
        "gioved\xec",
        "venerd\xec",
        'sabato'
    ]
};
var $3b7029dc63a95a92$var$dayPeriodValues = {
    narrow: {
        am: 'm.',
        pm: 'p.',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'mattina',
        afternoon: 'pomeriggio',
        evening: 'sera',
        night: 'notte'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'mattina',
        afternoon: 'pomeriggio',
        evening: 'sera',
        night: 'notte'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'mattina',
        afternoon: 'pomeriggio',
        evening: 'sera',
        night: 'notte'
    }
};
var $3b7029dc63a95a92$var$formattingDayPeriodValues = {
    narrow: {
        am: 'm.',
        pm: 'p.',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'di mattina',
        afternoon: 'del pomeriggio',
        evening: 'di sera',
        night: 'di notte'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'di mattina',
        afternoon: 'del pomeriggio',
        evening: 'di sera',
        night: 'di notte'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'di mattina',
        afternoon: 'del pomeriggio',
        evening: 'di sera',
        night: 'di notte'
    }
};
function $3b7029dc63a95a92$var$ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + "\xba";
}
var $3b7029dc63a95a92$var$localize = {
    ordinalNumber: $3b7029dc63a95a92$var$ordinalNumber,
    era: (0, $7juaq.default)({
        values: $3b7029dc63a95a92$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $7juaq.default)({
        values: $3b7029dc63a95a92$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $7juaq.default)({
        values: $3b7029dc63a95a92$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $7juaq.default)({
        values: $3b7029dc63a95a92$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $7juaq.default)({
        values: $3b7029dc63a95a92$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $3b7029dc63a95a92$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $3b7029dc63a95a92$export$2e2bcd8739ae039 = $3b7029dc63a95a92$var$localize;

});

parcelRegister("33zcT", function(module, exports) {
$parcel$export(module.exports, "default", () => $239cf643c6d4d223$export$2e2bcd8739ae039);

var $bFSku = parcelRequire("bFSku");

var $5hQUT = parcelRequire("5hQUT");
var $239cf643c6d4d223$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var $239cf643c6d4d223$var$parseOrdinalNumberPattern = /\d+/i;
var $239cf643c6d4d223$var$matchEraPatterns = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
    wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
};
var $239cf643c6d4d223$var$parseEraPatterns = {
    any: [
        /^a/i,
        /^(d|e)/i
    ]
};
var $239cf643c6d4d223$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $239cf643c6d4d223$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $239cf643c6d4d223$var$matchMonthPatterns = {
    narrow: /^[gfmalsond]/i,
    abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
    wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
};
var $239cf643c6d4d223$var$parseMonthPatterns = {
    narrow: [
        /^g/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^g/i,
        /^l/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ge/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mag/i,
        /^gi/i,
        /^l/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $239cf643c6d4d223$var$matchDayPatterns = {
    narrow: /^[dlmgvs]/i,
    short: /^(do|lu|ma|me|gi|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
    wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
};
var $239cf643c6d4d223$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^g/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^me/i,
        /^g/i,
        /^v/i,
        /^s/i
    ]
};
var $239cf643c6d4d223$var$matchDayPeriodPatterns = {
    narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
    any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
};
var $239cf643c6d4d223$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mezza/i,
        noon: /^mezzo/i,
        morning: /mattina/i,
        afternoon: /pomeriggio/i,
        evening: /sera/i,
        night: /notte/i
    }
};
var $239cf643c6d4d223$var$match = {
    ordinalNumber: (0, $bFSku.default)({
        matchPattern: $239cf643c6d4d223$var$matchOrdinalNumberPattern,
        parsePattern: $239cf643c6d4d223$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5hQUT.default)({
        matchPatterns: $239cf643c6d4d223$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $239cf643c6d4d223$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5hQUT.default)({
        matchPatterns: $239cf643c6d4d223$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $239cf643c6d4d223$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $5hQUT.default)({
        matchPatterns: $239cf643c6d4d223$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $239cf643c6d4d223$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5hQUT.default)({
        matchPatterns: $239cf643c6d4d223$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $239cf643c6d4d223$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5hQUT.default)({
        matchPatterns: $239cf643c6d4d223$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $239cf643c6d4d223$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $239cf643c6d4d223$export$2e2bcd8739ae039 = $239cf643c6d4d223$var$match;

});


parcelRegister("akAFq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $785836fad9f839b4$export$2e2bcd8739ae039);

var $6qW9G = parcelRequire("6qW9G");

var $7wtoq = parcelRequire("7wtoq");

var $3nea5 = parcelRequire("3nea5");

var $53YMo = parcelRequire("53YMo");

var $ic4CJ = parcelRequire("ic4CJ");
/**
 * @type {Locale}
 * @category Locales
 * @summary Japanese locale.
 * @language Japanese
 * @iso-639-2 jpn
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Yamagishi Kazutoshi [@ykzts]{@link https://github.com/ykzts}
 * @author Luca Ban [@mesqueeb]{@link https://github.com/mesqueeb}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
 */ var $785836fad9f839b4$var$locale = {
    code: 'ja',
    formatDistance: (0, $6qW9G.default),
    formatLong: (0, $7wtoq.default),
    formatRelative: (0, $3nea5.default),
    localize: (0, $53YMo.default),
    match: (0, $ic4CJ.default),
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
var $785836fad9f839b4$export$2e2bcd8739ae039 = $785836fad9f839b4$var$locale;

});
parcelRegister("6qW9G", function(module, exports) {
$parcel$export(module.exports, "default", () => $4af2483716ae7b22$export$2e2bcd8739ae039);
var $4af2483716ae7b22$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\u79D2\u672A\u6E80",
        other: "{{count}}\u79D2\u672A\u6E80",
        oneWithSuffix: "\u7D041\u79D2",
        otherWithSuffix: "\u7D04{{count}}\u79D2"
    },
    xSeconds: {
        one: "1\u79D2",
        other: "{{count}}\u79D2"
    },
    halfAMinute: "30\u79D2",
    lessThanXMinutes: {
        one: "1\u5206\u672A\u6E80",
        other: "{{count}}\u5206\u672A\u6E80",
        oneWithSuffix: "\u7D041\u5206",
        otherWithSuffix: "\u7D04{{count}}\u5206"
    },
    xMinutes: {
        one: "1\u5206",
        other: "{{count}}\u5206"
    },
    aboutXHours: {
        one: "\u7D041\u6642\u9593",
        other: "\u7D04{{count}}\u6642\u9593"
    },
    xHours: {
        one: "1\u6642\u9593",
        other: "{{count}}\u6642\u9593"
    },
    xDays: {
        one: "1\u65E5",
        other: "{{count}}\u65E5"
    },
    aboutXWeeks: {
        one: "\u7D041\u9031\u9593",
        other: "\u7D04{{count}}\u9031\u9593"
    },
    xWeeks: {
        one: "1\u9031\u9593",
        other: "{{count}}\u9031\u9593"
    },
    aboutXMonths: {
        one: "\u7D041\u304B\u6708",
        other: "\u7D04{{count}}\u304B\u6708"
    },
    xMonths: {
        one: "1\u304B\u6708",
        other: "{{count}}\u304B\u6708"
    },
    aboutXYears: {
        one: "\u7D041\u5E74",
        other: "\u7D04{{count}}\u5E74"
    },
    xYears: {
        one: "1\u5E74",
        other: "{{count}}\u5E74"
    },
    overXYears: {
        one: "1\u5E74\u4EE5\u4E0A",
        other: "{{count}}\u5E74\u4EE5\u4E0A"
    },
    almostXYears: {
        one: "1\u5E74\u8FD1\u304F",
        other: "{{count}}\u5E74\u8FD1\u304F"
    }
};
function $4af2483716ae7b22$export$2e2bcd8739ae039(token, count, options) {
    options = options || {};
    var result;
    if (typeof $4af2483716ae7b22$var$formatDistanceLocale[token] === 'string') result = $4af2483716ae7b22$var$formatDistanceLocale[token];
    else if (count === 1) {
        if (options.addSuffix && $4af2483716ae7b22$var$formatDistanceLocale[token].oneWithSuffix) result = $4af2483716ae7b22$var$formatDistanceLocale[token].oneWithSuffix;
        else result = $4af2483716ae7b22$var$formatDistanceLocale[token].one;
    } else if (options.addSuffix && $4af2483716ae7b22$var$formatDistanceLocale[token].otherWithSuffix) result = $4af2483716ae7b22$var$formatDistanceLocale[token].otherWithSuffix.replace('{{count}}', count);
    else result = $4af2483716ae7b22$var$formatDistanceLocale[token].other.replace('{{count}}', count);
    if (options.addSuffix) {
        if (options.comparison > 0) return result + "\u5F8C";
        else return result + "\u524D";
    }
    return result;
}

});

parcelRegister("7wtoq", function(module, exports) {
$parcel$export(module.exports, "default", () => $57a25269855f3866$export$2e2bcd8739ae039);

var $8D7sK = parcelRequire("8D7sK");
var $57a25269855f3866$var$dateFormats = {
    full: "y\u5E74M\u6708d\u65E5EEEE",
    long: "y\u5E74M\u6708d\u65E5",
    medium: 'y/MM/dd',
    short: 'y/MM/dd'
};
var $57a25269855f3866$var$timeFormats = {
    full: "H\u6642mm\u5206ss\u79D2 zzzz",
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $57a25269855f3866$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $57a25269855f3866$var$formatLong = {
    date: (0, $8D7sK.default)({
        formats: $57a25269855f3866$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $8D7sK.default)({
        formats: $57a25269855f3866$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $8D7sK.default)({
        formats: $57a25269855f3866$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $57a25269855f3866$export$2e2bcd8739ae039 = $57a25269855f3866$var$formatLong;

});

parcelRegister("3nea5", function(module, exports) {
$parcel$export(module.exports, "default", () => $274e81510b8080db$export$2e2bcd8739ae039);
var $274e81510b8080db$var$formatRelativeLocale = {
    lastWeek: "\u5148\u9031\u306Eeeee\u306Ep",
    yesterday: "\u6628\u65E5\u306Ep",
    today: "\u4ECA\u65E5\u306Ep",
    tomorrow: "\u660E\u65E5\u306Ep",
    nextWeek: "\u7FCC\u9031\u306Eeeee\u306Ep",
    other: 'P'
};
function $274e81510b8080db$export$2e2bcd8739ae039(token, _date, _baseDate, _options) {
    return $274e81510b8080db$var$formatRelativeLocale[token];
}

});

parcelRegister("53YMo", function(module, exports) {
$parcel$export(module.exports, "default", () => $3afc611c5a98a3b7$export$2e2bcd8739ae039);

var $7juaq = parcelRequire("7juaq");
var $3afc611c5a98a3b7$var$eraValues = {
    narrow: [
        'BC',
        'AC'
    ],
    abbreviated: [
        "\u7D00\u5143\u524D",
        "\u897F\u66A6"
    ],
    wide: [
        "\u7D00\u5143\u524D",
        "\u897F\u66A6"
    ]
};
var $3afc611c5a98a3b7$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u7B2C1\u56DB\u534A\u671F",
        "\u7B2C2\u56DB\u534A\u671F",
        "\u7B2C3\u56DB\u534A\u671F",
        "\u7B2C4\u56DB\u534A\u671F"
    ]
};
var $3afc611c5a98a3b7$var$monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ]
};
var $3afc611c5a98a3b7$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    short: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    abbreviated: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    wide: [
        "\u65E5\u66DC\u65E5",
        "\u6708\u66DC\u65E5",
        "\u706B\u66DC\u65E5",
        "\u6C34\u66DC\u65E5",
        "\u6728\u66DC\u65E5",
        "\u91D1\u66DC\u65E5",
        "\u571F\u66DC\u65E5"
    ]
};
var $3afc611c5a98a3b7$var$dayPeriodValues = {
    narrow: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    abbreviated: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    wide: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    }
};
var $3afc611c5a98a3b7$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    abbreviated: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    wide: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    }
};
function $3afc611c5a98a3b7$var$ordinalNumber(dirtyNumber, dirtyOptions) {
    var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`:
    //
    //   var options = dirtyOptions || {}
    //   var unit = String(options.unit)
    //
    // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'
    var options = dirtyOptions || {};
    var unit = String(options.unit);
    switch(unit){
        case 'year':
            return "".concat(number, "\u5E74");
        case 'quarter':
            return "\u7B2C".concat(number, "\u56DB\u534A\u671F");
        case 'month':
            return "".concat(number, "\u6708");
        case 'week':
            return "\u7B2C".concat(number, "\u9031");
        case 'date':
            return "".concat(number, "\u65E5");
        case 'hour':
            return "".concat(number, "\u6642");
        case 'minute':
            return "".concat(number, "\u5206");
        case 'second':
            return "".concat(number, "\u79D2");
        default:
            return "".concat(number);
    }
}
var $3afc611c5a98a3b7$var$localize = {
    ordinalNumber: $3afc611c5a98a3b7$var$ordinalNumber,
    era: (0, $7juaq.default)({
        values: $3afc611c5a98a3b7$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $7juaq.default)({
        values: $3afc611c5a98a3b7$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $7juaq.default)({
        values: $3afc611c5a98a3b7$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $7juaq.default)({
        values: $3afc611c5a98a3b7$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $7juaq.default)({
        values: $3afc611c5a98a3b7$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $3afc611c5a98a3b7$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $3afc611c5a98a3b7$export$2e2bcd8739ae039 = $3afc611c5a98a3b7$var$localize;

});

parcelRegister("ic4CJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3ecef219fbd1420$export$2e2bcd8739ae039);

var $bFSku = parcelRequire("bFSku");

var $5hQUT = parcelRequire("5hQUT");
var $d3ecef219fbd1420$var$matchOrdinalNumberPattern = /^第?\d+(年|四半期|月|週|日|時|分|秒)?/i;
var $d3ecef219fbd1420$var$parseOrdinalNumberPattern = /\d+/i;
var $d3ecef219fbd1420$var$matchEraPatterns = {
    narrow: /^(B\.?C\.?|A\.?D\.?)/i,
    abbreviated: /^(紀元[前後]|西暦)/i,
    wide: /^(紀元[前後]|西暦)/i
};
var $d3ecef219fbd1420$var$parseEraPatterns = {
    narrow: [
        /^B/i,
        /^A/i
    ],
    any: [
        /^(紀元前)/i,
        /^(西暦|紀元後)/i
    ]
};
var $d3ecef219fbd1420$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^Q[1234]/i,
    wide: /^第[1234一二三四１２３４]四半期/i
};
var $d3ecef219fbd1420$var$parseQuarterPatterns = {
    any: [
        /(1|一|１)/i,
        /(2|二|２)/i,
        /(3|三|３)/i,
        /(4|四|４)/i
    ]
};
var $d3ecef219fbd1420$var$matchMonthPatterns = {
    narrow: /^([123456789]|1[012])/,
    abbreviated: /^([123456789]|1[012])月/i,
    wide: /^([123456789]|1[012])月/i
};
var $d3ecef219fbd1420$var$parseMonthPatterns = {
    any: [
        /^1\D/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
var $d3ecef219fbd1420$var$matchDayPatterns = {
    narrow: /^[日月火水木金土]/,
    short: /^[日月火水木金土]/,
    abbreviated: /^[日月火水木金土]/,
    wide: /^[日月火水木金土]曜日/
};
var $d3ecef219fbd1420$var$parseDayPatterns = {
    any: [
        /^日/,
        /^月/,
        /^火/,
        /^水/,
        /^木/,
        /^金/,
        /^土/
    ]
};
var $d3ecef219fbd1420$var$matchDayPeriodPatterns = {
    any: /^(AM|PM|午前|午後|正午|深夜|真夜中|夜|朝)/i
};
var $d3ecef219fbd1420$var$parseDayPeriodPatterns = {
    any: {
        am: /^(A|午前)/i,
        pm: /^(P|午後)/i,
        midnight: /^深夜|真夜中/i,
        noon: /^正午/i,
        morning: /^朝/i,
        afternoon: /^午後/i,
        evening: /^夜/i,
        night: /^深夜/i
    }
};
var $d3ecef219fbd1420$var$match = {
    ordinalNumber: (0, $bFSku.default)({
        matchPattern: $d3ecef219fbd1420$var$matchOrdinalNumberPattern,
        parsePattern: $d3ecef219fbd1420$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5hQUT.default)({
        matchPatterns: $d3ecef219fbd1420$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d3ecef219fbd1420$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5hQUT.default)({
        matchPatterns: $d3ecef219fbd1420$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d3ecef219fbd1420$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $5hQUT.default)({
        matchPatterns: $d3ecef219fbd1420$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d3ecef219fbd1420$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5hQUT.default)({
        matchPatterns: $d3ecef219fbd1420$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d3ecef219fbd1420$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5hQUT.default)({
        matchPatterns: $d3ecef219fbd1420$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $d3ecef219fbd1420$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $d3ecef219fbd1420$export$2e2bcd8739ae039 = $d3ecef219fbd1420$var$match;

});


parcelRegister("gFFcU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $c230708b9290808b$export$2e2bcd8739ae039);

var $2Df24 = parcelRequire("2Df24");

var $f6Rtv = parcelRequire("f6Rtv");

var $jSXSd = parcelRequire("jSXSd");

var $67Xnm = parcelRequire("67Xnm");

var $4pBuv = parcelRequire("4pBuv");
/**
 * @type {Locale}
 * @category Locales
 * @summary Korean locale.
 * @language Korean
 * @iso-639-2 kor
 * @author Hong Chulju [@angdev]{@link https://github.com/angdev}
 * @author Lee Seoyoen [@iamssen]{@link https://github.com/iamssen}
 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
 */ var $c230708b9290808b$var$locale = {
    code: 'ko',
    formatDistance: (0, $2Df24.default),
    formatLong: (0, $f6Rtv.default),
    formatRelative: (0, $jSXSd.default),
    localize: (0, $67Xnm.default),
    match: (0, $4pBuv.default),
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
var $c230708b9290808b$export$2e2bcd8739ae039 = $c230708b9290808b$var$locale;

});
parcelRegister("2Df24", function(module, exports) {
$parcel$export(module.exports, "default", () => $1eaae26de06cc47a$export$2e2bcd8739ae039);
var $1eaae26de06cc47a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\uCD08 \uBBF8\uB9CC",
        other: "{{count}}\uCD08 \uBBF8\uB9CC"
    },
    xSeconds: {
        one: "1\uCD08",
        other: "{{count}}\uCD08"
    },
    halfAMinute: "30\uCD08",
    lessThanXMinutes: {
        one: "1\uBD84 \uBBF8\uB9CC",
        other: "{{count}}\uBD84 \uBBF8\uB9CC"
    },
    xMinutes: {
        one: "1\uBD84",
        other: "{{count}}\uBD84"
    },
    aboutXHours: {
        one: "\uC57D 1\uC2DC\uAC04",
        other: "\uC57D {{count}}\uC2DC\uAC04"
    },
    xHours: {
        one: "1\uC2DC\uAC04",
        other: "{{count}}\uC2DC\uAC04"
    },
    xDays: {
        one: "1\uC77C",
        other: "{{count}}\uC77C"
    },
    aboutXWeeks: {
        one: "\uC57D 1\uC8FC",
        other: "\uC57D {{count}}\uC8FC"
    },
    xWeeks: {
        one: "1\uC8FC",
        other: "{{count}}\uC8FC"
    },
    aboutXMonths: {
        one: "\uC57D 1\uAC1C\uC6D4",
        other: "\uC57D {{count}}\uAC1C\uC6D4"
    },
    xMonths: {
        one: "1\uAC1C\uC6D4",
        other: "{{count}}\uAC1C\uC6D4"
    },
    aboutXYears: {
        one: "\uC57D 1\uB144",
        other: "\uC57D {{count}}\uB144"
    },
    xYears: {
        one: "1\uB144",
        other: "{{count}}\uB144"
    },
    overXYears: {
        one: "1\uB144 \uC774\uC0C1",
        other: "{{count}}\uB144 \uC774\uC0C1"
    },
    almostXYears: {
        one: "\uAC70\uC758 1\uB144",
        other: "\uAC70\uC758 {{count}}\uB144"
    }
};
function $1eaae26de06cc47a$export$2e2bcd8739ae039(token, count, options) {
    options = options || {};
    var result;
    if (typeof $1eaae26de06cc47a$var$formatDistanceLocale[token] === 'string') result = $1eaae26de06cc47a$var$formatDistanceLocale[token];
    else if (count === 1) result = $1eaae26de06cc47a$var$formatDistanceLocale[token].one;
    else result = $1eaae26de06cc47a$var$formatDistanceLocale[token].other.replace('{{count}}', count);
    if (options.addSuffix) {
        if (options.comparison > 0) return result + " \uD6C4";
        else return result + " \uC804";
    }
    return result;
}

});

parcelRegister("f6Rtv", function(module, exports) {
$parcel$export(module.exports, "default", () => $b000e58cd77207d4$export$2e2bcd8739ae039);

var $8D7sK = parcelRequire("8D7sK");
var $b000e58cd77207d4$var$dateFormats = {
    full: "y\uB144 M\uC6D4 d\uC77C EEEE",
    long: "y\uB144 M\uC6D4 d\uC77C",
    medium: 'y.MM.dd',
    short: 'y.MM.dd'
};
var $b000e58cd77207d4$var$timeFormats = {
    full: "a H\uC2DC mm\uBD84 ss\uCD08 zzzz",
    long: 'a H:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $b000e58cd77207d4$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $b000e58cd77207d4$var$formatLong = {
    date: (0, $8D7sK.default)({
        formats: $b000e58cd77207d4$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $8D7sK.default)({
        formats: $b000e58cd77207d4$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $8D7sK.default)({
        formats: $b000e58cd77207d4$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $b000e58cd77207d4$export$2e2bcd8739ae039 = $b000e58cd77207d4$var$formatLong;

});

parcelRegister("jSXSd", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7a1811496277a31$export$2e2bcd8739ae039);
var $e7a1811496277a31$var$formatRelativeLocale = {
    lastWeek: "'\uC9C0\uB09C' eeee p",
    yesterday: "'\uC5B4\uC81C' p",
    today: "'\uC624\uB298' p",
    tomorrow: "'\uB0B4\uC77C' p",
    nextWeek: "'\uB2E4\uC74C' eeee p",
    other: 'P'
};
function $e7a1811496277a31$export$2e2bcd8739ae039(token, _date, _baseDate, _options) {
    return $e7a1811496277a31$var$formatRelativeLocale[token];
}

});

parcelRegister("67Xnm", function(module, exports) {
$parcel$export(module.exports, "default", () => $4761744c4f94f20c$export$2e2bcd8739ae039);

var $7juaq = parcelRequire("7juaq");
var $4761744c4f94f20c$var$eraValues = {
    narrow: [
        'BC',
        'AD'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        "\uAE30\uC6D0\uC804",
        "\uC11C\uAE30"
    ]
};
var $4761744c4f94f20c$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "1\uBD84\uAE30",
        "2\uBD84\uAE30",
        "3\uBD84\uAE30",
        "4\uBD84\uAE30"
    ]
};
var $4761744c4f94f20c$var$monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "1\uC6D4",
        "2\uC6D4",
        "3\uC6D4",
        "4\uC6D4",
        "5\uC6D4",
        "6\uC6D4",
        "7\uC6D4",
        "8\uC6D4",
        "9\uC6D4",
        "10\uC6D4",
        "11\uC6D4",
        "12\uC6D4"
    ],
    wide: [
        "1\uC6D4",
        "2\uC6D4",
        "3\uC6D4",
        "4\uC6D4",
        "5\uC6D4",
        "6\uC6D4",
        "7\uC6D4",
        "8\uC6D4",
        "9\uC6D4",
        "10\uC6D4",
        "11\uC6D4",
        "12\uC6D4"
    ]
};
var $4761744c4f94f20c$var$dayValues = {
    narrow: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    short: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    abbreviated: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    wide: [
        "\uC77C\uC694\uC77C",
        "\uC6D4\uC694\uC77C",
        "\uD654\uC694\uC77C",
        "\uC218\uC694\uC77C",
        "\uBAA9\uC694\uC77C",
        "\uAE08\uC694\uC77C",
        "\uD1A0\uC694\uC77C"
    ]
};
var $4761744c4f94f20c$var$dayPeriodValues = {
    narrow: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    abbreviated: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    wide: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    }
};
var $4761744c4f94f20c$var$formattingDayPeriodValues = {
    narrow: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    abbreviated: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    wide: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    }
};
function $4761744c4f94f20c$var$ordinalNumber(dirtyNumber, dirtyOptions) {
    var number = Number(dirtyNumber);
    var options = dirtyOptions || {};
    var unit = String(options.unit);
    switch(unit){
        case 'minute':
        case 'second':
            return number;
        case 'date':
            return number + "\uC77C";
        default:
            return number + "\uBC88\uC9F8";
    }
}
var $4761744c4f94f20c$var$localize = {
    ordinalNumber: $4761744c4f94f20c$var$ordinalNumber,
    era: (0, $7juaq.default)({
        values: $4761744c4f94f20c$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $7juaq.default)({
        values: $4761744c4f94f20c$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $7juaq.default)({
        values: $4761744c4f94f20c$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $7juaq.default)({
        values: $4761744c4f94f20c$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $7juaq.default)({
        values: $4761744c4f94f20c$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $4761744c4f94f20c$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $4761744c4f94f20c$export$2e2bcd8739ae039 = $4761744c4f94f20c$var$localize;

});

parcelRegister("4pBuv", function(module, exports) {
$parcel$export(module.exports, "default", () => $3366942a55762a11$export$2e2bcd8739ae039);

var $bFSku = parcelRequire("bFSku");

var $5hQUT = parcelRequire("5hQUT");
var $3366942a55762a11$var$matchOrdinalNumberPattern = /^(\d+)(일|번째)?/i;
var $3366942a55762a11$var$parseOrdinalNumberPattern = /\d+/i;
var $3366942a55762a11$var$matchEraPatterns = {
    narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(기원전|서기)/i
};
var $3366942a55762a11$var$parseEraPatterns = {
    any: [
        /^(bc|기원전)/i,
        /^(ad|서기)/i
    ]
};
var $3366942a55762a11$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]사?분기/i
};
var $3366942a55762a11$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $3366942a55762a11$var$matchMonthPatterns = {
    narrow: /^(1[012]|[123456789])/,
    abbreviated: /^(1[012]|[123456789])월/i,
    wide: /^(1[012]|[123456789])월/i
};
var $3366942a55762a11$var$parseMonthPatterns = {
    any: [
        /^1월?$/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
var $3366942a55762a11$var$matchDayPatterns = {
    narrow: /^[일월화수목금토]/,
    short: /^[일월화수목금토]/,
    abbreviated: /^[일월화수목금토]/,
    wide: /^[일월화수목금토]요일/
};
var $3366942a55762a11$var$parseDayPatterns = {
    any: [
        /^일/,
        /^월/,
        /^화/,
        /^수/,
        /^목/,
        /^금/,
        /^토/
    ]
};
var $3366942a55762a11$var$matchDayPeriodPatterns = {
    any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
};
var $3366942a55762a11$var$parseDayPeriodPatterns = {
    any: {
        am: /^(am|오전)/i,
        pm: /^(pm|오후)/i,
        midnight: /^자정/i,
        noon: /^정오/i,
        morning: /^아침/i,
        afternoon: /^오후/i,
        evening: /^저녁/i,
        night: /^밤/i
    }
};
var $3366942a55762a11$var$match = {
    ordinalNumber: (0, $bFSku.default)({
        matchPattern: $3366942a55762a11$var$matchOrdinalNumberPattern,
        parsePattern: $3366942a55762a11$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5hQUT.default)({
        matchPatterns: $3366942a55762a11$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3366942a55762a11$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5hQUT.default)({
        matchPatterns: $3366942a55762a11$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3366942a55762a11$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $5hQUT.default)({
        matchPatterns: $3366942a55762a11$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3366942a55762a11$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5hQUT.default)({
        matchPatterns: $3366942a55762a11$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3366942a55762a11$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5hQUT.default)({
        matchPatterns: $3366942a55762a11$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $3366942a55762a11$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $3366942a55762a11$export$2e2bcd8739ae039 = $3366942a55762a11$var$match;

});


parcelRegister("9VIdj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $73abbbd8b21d183c$export$2e2bcd8739ae039);

var $jH7kx = parcelRequire("jH7kx");

var $8utAv = parcelRequire("8utAv");

var $jQsT8 = parcelRequire("jQsT8");

var $jgG7y = parcelRequire("jgG7y");

var $4jngI = parcelRequire("4jngI");
/**
 * @type {Locale}
 * @category Locales
 * @summary Norwegian Bokmål locale.
 * @language Norwegian Bokmål
 * @iso-639-2 nob
 * @author Hans-Kristian Koren [@Hanse]{@link https://github.com/Hanse}
 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Dag Stuan [@dagstuan]{@link https://github.com/dagstuan}
 */ var $73abbbd8b21d183c$var$locale = {
    code: 'nb',
    formatDistance: (0, $jH7kx.default),
    formatLong: (0, $8utAv.default),
    formatRelative: (0, $jQsT8.default),
    localize: (0, $jgG7y.default),
    match: (0, $4jngI.default),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
    }
};
var $73abbbd8b21d183c$export$2e2bcd8739ae039 = $73abbbd8b21d183c$var$locale;

});
parcelRegister("jH7kx", function(module, exports) {
$parcel$export(module.exports, "default", () => $e567b81cad8cd0d8$export$2e2bcd8739ae039);
var $e567b81cad8cd0d8$var$formatDistanceLocale = {
    lessThanXSeconds: {
        singular: 'mindre enn ett sekund',
        plural: 'mindre enn {{count}} sekunder'
    },
    xSeconds: {
        singular: 'ett sekund',
        plural: '{{count}} sekunder'
    },
    halfAMinute: 'et halvt minutt',
    lessThanXMinutes: {
        singular: 'mindre enn ett minutt',
        plural: 'mindre enn {{count}} minutter'
    },
    xMinutes: {
        singular: 'ett minutt',
        plural: '{{count}} minutter'
    },
    aboutXHours: {
        singular: 'omtrent en time',
        plural: 'omtrent {{count}} timer'
    },
    xHours: {
        singular: 'en time',
        plural: '{{count}} timer'
    },
    xDays: {
        singular: 'en dag',
        plural: '{{count}} dager'
    },
    aboutXWeeks: {
        singular: 'omtrent en uke',
        plural: 'omtrent {{count}} uker'
    },
    xWeeks: {
        singular: 'en uke',
        plural: '{{count}} uker'
    },
    aboutXMonths: {
        singular: "omtrent en m\xe5ned",
        plural: "omtrent {{count}} m\xe5neder"
    },
    xMonths: {
        singular: "en m\xe5ned",
        plural: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        singular: "omtrent ett \xe5r",
        plural: "omtrent {{count}} \xe5r"
    },
    xYears: {
        singular: "ett \xe5r",
        plural: "{{count}} \xe5r"
    },
    overXYears: {
        singular: "over ett \xe5r",
        plural: "over {{count}} \xe5r"
    },
    almostXYears: {
        singular: "nesten ett \xe5r",
        plural: "nesten {{count}} \xe5r"
    }
};
var $e567b81cad8cd0d8$var$wordMapping = [
    'null',
    'en',
    'to',
    'tre',
    'fire',
    'fem',
    'seks',
    'sju',
    "\xe5tte",
    'ni',
    'ti',
    'elleve',
    'tolv'
];
function $e567b81cad8cd0d8$export$2e2bcd8739ae039(token, count, options) {
    options = options || {
        onlyNumeric: false
    };
    var translation = $e567b81cad8cd0d8$var$formatDistanceLocale[token];
    var result;
    if (typeof translation === 'string') result = translation;
    else if (count === 0 || count > 1) {
        if (options.onlyNumeric) result = translation.plural.replace('{{count}}', count);
        else result = translation.plural.replace('{{count}}', count < 13 ? $e567b81cad8cd0d8$var$wordMapping[count] : count);
    } else result = translation.singular;
    if (options.addSuffix) {
        if (options.comparison > 0) return 'om ' + result;
        else return result + ' siden';
    }
    return result;
}

});

parcelRegister("8utAv", function(module, exports) {
$parcel$export(module.exports, "default", () => $62e8139ae8319be1$export$2e2bcd8739ae039);

var $8D7sK = parcelRequire("8D7sK");
var $62e8139ae8319be1$var$dateFormats = {
    full: 'EEEE d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd.MM.y'
};
var $62e8139ae8319be1$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $62e8139ae8319be1$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $62e8139ae8319be1$var$formatLong = {
    date: (0, $8D7sK.default)({
        formats: $62e8139ae8319be1$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $8D7sK.default)({
        formats: $62e8139ae8319be1$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $8D7sK.default)({
        formats: $62e8139ae8319be1$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $62e8139ae8319be1$export$2e2bcd8739ae039 = $62e8139ae8319be1$var$formatLong;

});

parcelRegister("jQsT8", function(module, exports) {
$parcel$export(module.exports, "default", () => $e729483cc026b028$export$2e2bcd8739ae039);
var $e729483cc026b028$var$formatRelativeLocale = {
    lastWeek: "'forrige' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: 'P'
};
function $e729483cc026b028$export$2e2bcd8739ae039(token, _date, _baseDate, _options) {
    return $e729483cc026b028$var$formatRelativeLocale[token];
}

});

parcelRegister("jgG7y", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0702f4464be7314$export$2e2bcd8739ae039);

var $7juaq = parcelRequire("7juaq");
var $e0702f4464be7314$var$eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        "f\xf8r Kristus",
        'etter Kristus'
    ]
};
var $e0702f4464be7314$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $e0702f4464be7314$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        'apr.',
        'mai',
        'juni',
        'juli',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'des.'
    ],
    wide: [
        'januar',
        'februar',
        'mars',
        'april',
        'mai',
        'juni',
        'juli',
        'august',
        'september',
        'oktober',
        'november',
        'desember'
    ]
};
var $e0702f4464be7314$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        "s\xf8",
        'ma',
        'ti',
        'on',
        'to',
        'fr',
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n",
        'man',
        'tir',
        'ons',
        'tor',
        'fre',
        "l\xf8r"
    ],
    wide: [
        "s\xf8ndag",
        'mandag',
        'tirsdag',
        'onsdag',
        'torsdag',
        'fredag',
        "l\xf8rdag"
    ]
};
var $e0702f4464be7314$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morgenen",
        afternoon: "p\xe5 ettermiddagen",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    }
};
function $e0702f4464be7314$var$ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + '.';
}
var $e0702f4464be7314$var$localize = {
    ordinalNumber: $e0702f4464be7314$var$ordinalNumber,
    era: (0, $7juaq.default)({
        values: $e0702f4464be7314$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $7juaq.default)({
        values: $e0702f4464be7314$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $7juaq.default)({
        values: $e0702f4464be7314$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $7juaq.default)({
        values: $e0702f4464be7314$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $7juaq.default)({
        values: $e0702f4464be7314$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $e0702f4464be7314$export$2e2bcd8739ae039 = $e0702f4464be7314$var$localize;

});

parcelRegister("4jngI", function(module, exports) {
$parcel$export(module.exports, "default", () => $323afc6882cbcc80$export$2e2bcd8739ae039);

var $bFSku = parcelRequire("bFSku");

var $5hQUT = parcelRequire("5hQUT");
var $323afc6882cbcc80$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $323afc6882cbcc80$var$parseOrdinalNumberPattern = /\d+/i;
var $323afc6882cbcc80$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
var $323afc6882cbcc80$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^e/i
    ]
};
var $323afc6882cbcc80$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var $323afc6882cbcc80$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $323afc6882cbcc80$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
    wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
var $323afc6882cbcc80$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $323afc6882cbcc80$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sø|ma|ti|on|to|fr|lø)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
var $323afc6882cbcc80$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $323afc6882cbcc80$var$matchDayPeriodPatterns = {
    narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
};
var $323afc6882cbcc80$var$parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgen/i,
        afternoon: /ettermiddag/i,
        evening: /kveld/i,
        night: /natt/i
    }
};
var $323afc6882cbcc80$var$match = {
    ordinalNumber: (0, $bFSku.default)({
        matchPattern: $323afc6882cbcc80$var$matchOrdinalNumberPattern,
        parsePattern: $323afc6882cbcc80$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5hQUT.default)({
        matchPatterns: $323afc6882cbcc80$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $323afc6882cbcc80$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5hQUT.default)({
        matchPatterns: $323afc6882cbcc80$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $323afc6882cbcc80$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $5hQUT.default)({
        matchPatterns: $323afc6882cbcc80$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $323afc6882cbcc80$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5hQUT.default)({
        matchPatterns: $323afc6882cbcc80$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $323afc6882cbcc80$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5hQUT.default)({
        matchPatterns: $323afc6882cbcc80$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $323afc6882cbcc80$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $323afc6882cbcc80$export$2e2bcd8739ae039 = $323afc6882cbcc80$var$match;

});


parcelRegister("bmEYw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $8461889b4e1edc91$export$2e2bcd8739ae039);

var $4oan0 = parcelRequire("4oan0");

var $cRcOP = parcelRequire("cRcOP");

var $ai4cN = parcelRequire("ai4cN");

var $f8u1u = parcelRequire("f8u1u");

var $jbGLf = parcelRequire("jbGLf");
/**
 * @type {Locale}
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
 * @author Edo Rivai [@edorivai]{@link https://github.com/edorivai}
 * @author Niels Keurentjes [@curry684]{@link https://github.com/curry684}
 * @author Stefan Vermaas [@stefanvermaas]{@link https://github.com/stefanvermaas}
 */ var $8461889b4e1edc91$var$locale = {
    code: 'nl',
    formatDistance: (0, $4oan0.default),
    formatLong: (0, $cRcOP.default),
    formatRelative: (0, $ai4cN.default),
    localize: (0, $f8u1u.default),
    match: (0, $jbGLf.default),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
    }
};
var $8461889b4e1edc91$export$2e2bcd8739ae039 = $8461889b4e1edc91$var$locale;

});
parcelRegister("4oan0", function(module, exports) {
$parcel$export(module.exports, "default", () => $3321729a211b39f5$export$2e2bcd8739ae039);
var $3321729a211b39f5$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'minder dan een seconde',
        other: 'minder dan {{count}} seconden'
    },
    xSeconds: {
        one: '1 seconde',
        other: '{{count}} seconden'
    },
    halfAMinute: 'een halve minuut',
    lessThanXMinutes: {
        one: 'minder dan een minuut',
        other: 'minder dan {{count}} minuten'
    },
    xMinutes: {
        one: 'een minuut',
        other: '{{count}} minuten'
    },
    aboutXHours: {
        one: 'ongeveer 1 uur',
        other: 'ongeveer {{count}} uur'
    },
    xHours: {
        one: '1 uur',
        other: '{{count}} uur'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dagen'
    },
    aboutXWeeks: {
        one: 'ongeveer 1 week',
        other: 'ongeveer {{count}} weken'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weken'
    },
    aboutXMonths: {
        one: 'ongeveer 1 maand',
        other: 'ongeveer {{count}} maanden'
    },
    xMonths: {
        one: '1 maand',
        other: '{{count}} maanden'
    },
    aboutXYears: {
        one: 'ongeveer 1 jaar',
        other: 'ongeveer {{count}} jaar'
    },
    xYears: {
        one: '1 jaar',
        other: '{{count}} jaar'
    },
    overXYears: {
        one: 'meer dan 1 jaar',
        other: 'meer dan {{count}} jaar'
    },
    almostXYears: {
        one: 'bijna 1 jaar',
        other: 'bijna {{count}} jaar'
    }
};
function $3321729a211b39f5$export$2e2bcd8739ae039(token, count, options) {
    options = options || {};
    var result;
    if (typeof $3321729a211b39f5$var$formatDistanceLocale[token] === 'string') result = $3321729a211b39f5$var$formatDistanceLocale[token];
    else if (count === 1) result = $3321729a211b39f5$var$formatDistanceLocale[token].one;
    else result = $3321729a211b39f5$var$formatDistanceLocale[token].other.replace('{{count}}', count);
    if (options.addSuffix) {
        if (options.comparison > 0) return 'over ' + result;
        else return result + ' geleden';
    }
    return result;
}

});

parcelRegister("cRcOP", function(module, exports) {
$parcel$export(module.exports, "default", () => $95c460d2f890f9ca$export$2e2bcd8739ae039);

var $8D7sK = parcelRequire("8D7sK");
var $95c460d2f890f9ca$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd-MM-y'
};
var $95c460d2f890f9ca$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $95c460d2f890f9ca$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $95c460d2f890f9ca$var$formatLong = {
    date: (0, $8D7sK.default)({
        formats: $95c460d2f890f9ca$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $8D7sK.default)({
        formats: $95c460d2f890f9ca$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $8D7sK.default)({
        formats: $95c460d2f890f9ca$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $95c460d2f890f9ca$export$2e2bcd8739ae039 = $95c460d2f890f9ca$var$formatLong;

});

parcelRegister("ai4cN", function(module, exports) {
$parcel$export(module.exports, "default", () => $77ded8e6b46040db$export$2e2bcd8739ae039);
var $77ded8e6b46040db$var$formatRelativeLocale = {
    lastWeek: "'afgelopen' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: 'P'
};
function $77ded8e6b46040db$export$2e2bcd8739ae039(token, _date, _baseDate, _options) {
    return $77ded8e6b46040db$var$formatRelativeLocale[token];
}

});

parcelRegister("f8u1u", function(module, exports) {
$parcel$export(module.exports, "default", () => $b04ee455f275e4ae$export$2e2bcd8739ae039);

var $7juaq = parcelRequire("7juaq");
var $b04ee455f275e4ae$var$eraValues = {
    narrow: [
        'v.C.',
        'n.C.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'voor Christus',
        'na Christus'
    ]
};
var $b04ee455f275e4ae$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1e kwartaal',
        '2e kwartaal',
        '3e kwartaal',
        '4e kwartaal'
    ]
};
var $b04ee455f275e4ae$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mrt.',
        'apr.',
        'mei',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januari',
        'februari',
        'maart',
        'april',
        'mei',
        'juni',
        'juli',
        'augustus',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var $b04ee455f275e4ae$var$dayValues = {
    narrow: [
        'Z',
        'M',
        'D',
        'W',
        'D',
        'V',
        'Z'
    ],
    short: [
        'zo',
        'ma',
        'di',
        'wo',
        'do',
        'vr',
        'za'
    ],
    abbreviated: [
        'zon',
        'maa',
        'din',
        'woe',
        'don',
        'vri',
        'zat'
    ],
    wide: [
        'zondag',
        'maandag',
        'dinsdag',
        'woensdag',
        'donderdag',
        'vrijdag',
        'zaterdag'
    ]
};
var $b04ee455f275e4ae$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middaguur',
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middaguur',
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middaguur',
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    }
};
function $b04ee455f275e4ae$var$ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + 'e';
}
var $b04ee455f275e4ae$var$localize = {
    ordinalNumber: $b04ee455f275e4ae$var$ordinalNumber,
    era: (0, $7juaq.default)({
        values: $b04ee455f275e4ae$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $7juaq.default)({
        values: $b04ee455f275e4ae$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $7juaq.default)({
        values: $b04ee455f275e4ae$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $7juaq.default)({
        values: $b04ee455f275e4ae$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $7juaq.default)({
        values: $b04ee455f275e4ae$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $b04ee455f275e4ae$export$2e2bcd8739ae039 = $b04ee455f275e4ae$var$localize;

});

parcelRegister("jbGLf", function(module, exports) {
$parcel$export(module.exports, "default", () => $df8036ddc7c73841$export$2e2bcd8739ae039);

var $bFSku = parcelRequire("bFSku");

var $5hQUT = parcelRequire("5hQUT");
var $df8036ddc7c73841$var$matchOrdinalNumberPattern = /^(\d+)e?/i;
var $df8036ddc7c73841$var$parseOrdinalNumberPattern = /\d+/i;
var $df8036ddc7c73841$var$matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
};
var $df8036ddc7c73841$var$parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
var $df8036ddc7c73841$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
};
var $df8036ddc7c73841$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $df8036ddc7c73841$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
var $df8036ddc7c73841$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mei/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ]
};
var $df8036ddc7c73841$var$matchDayPatterns = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
var $df8036ddc7c73841$var$parseDayPatterns = {
    narrow: [
        /^z/i,
        /^m/i,
        /^d/i,
        /^w/i,
        /^d/i,
        /^v/i,
        /^z/i
    ],
    any: [
        /^zo/i,
        /^ma/i,
        /^di/i,
        /^wo/i,
        /^do/i,
        /^vr/i,
        /^za/i
    ]
};
var $df8036ddc7c73841$var$matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
var $df8036ddc7c73841$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^het middaguur/i,
        morning: /ochtend/i,
        afternoon: /middag/i,
        evening: /avond/i,
        night: /nacht/i
    }
};
var $df8036ddc7c73841$var$match = {
    ordinalNumber: (0, $bFSku.default)({
        matchPattern: $df8036ddc7c73841$var$matchOrdinalNumberPattern,
        parsePattern: $df8036ddc7c73841$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5hQUT.default)({
        matchPatterns: $df8036ddc7c73841$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $df8036ddc7c73841$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5hQUT.default)({
        matchPatterns: $df8036ddc7c73841$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $df8036ddc7c73841$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $5hQUT.default)({
        matchPatterns: $df8036ddc7c73841$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $df8036ddc7c73841$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5hQUT.default)({
        matchPatterns: $df8036ddc7c73841$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $df8036ddc7c73841$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5hQUT.default)({
        matchPatterns: $df8036ddc7c73841$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $df8036ddc7c73841$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $df8036ddc7c73841$export$2e2bcd8739ae039 = $df8036ddc7c73841$var$match;

});


parcelRegister("9yEMq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $6f56ec204249b451$export$2e2bcd8739ae039);

var $iANtg = parcelRequire("iANtg");

var $G1bO4 = parcelRequire("G1bO4");

var $cVEiC = parcelRequire("cVEiC");

var $db9L9 = parcelRequire("db9L9");

var $6Ncuj = parcelRequire("6Ncuj");
/**
 * @type {Locale}
 * @category Locales
 * @summary Polish locale.
 * @language Polish
 * @iso-639-2 pol
 * @author Mateusz Derks [@ertrzyiks]{@link https://github.com/ertrzyiks}
 * @author Just RAG [@justrag]{@link https://github.com/justrag}
 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Mateusz Tokarski [@mutisz]{@link https://github.com/mutisz}
 */ var $6f56ec204249b451$var$locale = {
    code: 'pl',
    formatDistance: (0, $iANtg.default),
    formatLong: (0, $G1bO4.default),
    formatRelative: (0, $cVEiC.default),
    localize: (0, $db9L9.default),
    match: (0, $6Ncuj.default),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
    }
};
var $6f56ec204249b451$export$2e2bcd8739ae039 = $6f56ec204249b451$var$locale;

});
parcelRegister("iANtg", function(module, exports) {
$parcel$export(module.exports, "default", () => $d891f6b28439d91d$export$2e2bcd8739ae039);
function $d891f6b28439d91d$var$declensionGroup(scheme, count) {
    if (count === 1) return scheme.one;
    var rem100 = count % 100; // ends with 11-20
    if (rem100 <= 20 && rem100 > 10) return scheme.other;
    var rem10 = rem100 % 10; // ends with 2, 3, 4
    if (rem10 >= 2 && rem10 <= 4) return scheme.twoFour;
    return scheme.other;
}
function $d891f6b28439d91d$var$declension(scheme, count, time) {
    time = time || 'regular';
    var group = $d891f6b28439d91d$var$declensionGroup(scheme, count);
    var finalText = group[time] || group;
    return finalText.replace('{{count}}', count);
}
var $d891f6b28439d91d$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            regular: "mniej ni\u017C sekunda",
            past: "mniej ni\u017C sekund\u0119",
            future: "mniej ni\u017C sekund\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} sekundy",
        other: "mniej ni\u017C {{count}} sekund"
    },
    xSeconds: {
        one: {
            regular: 'sekunda',
            past: "sekund\u0119",
            future: "sekund\u0119"
        },
        twoFour: '{{count}} sekundy',
        other: '{{count}} sekund'
    },
    halfAMinute: {
        one: "p\xf3\u0142 minuty",
        twoFour: "p\xf3\u0142 minuty",
        other: "p\xf3\u0142 minuty"
    },
    lessThanXMinutes: {
        one: {
            regular: "mniej ni\u017C minuta",
            past: "mniej ni\u017C minut\u0119",
            future: "mniej ni\u017C minut\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} minuty",
        other: "mniej ni\u017C {{count}} minut"
    },
    xMinutes: {
        one: {
            regular: 'minuta',
            past: "minut\u0119",
            future: "minut\u0119"
        },
        twoFour: '{{count}} minuty',
        other: '{{count}} minut'
    },
    aboutXHours: {
        one: {
            regular: "oko\u0142o godziny",
            past: "oko\u0142o godziny",
            future: "oko\u0142o godzin\u0119"
        },
        twoFour: "oko\u0142o {{count}} godziny",
        other: "oko\u0142o {{count}} godzin"
    },
    xHours: {
        one: {
            regular: 'godzina',
            past: "godzin\u0119",
            future: "godzin\u0119"
        },
        twoFour: '{{count}} godziny',
        other: '{{count}} godzin'
    },
    xDays: {
        one: {
            regular: "dzie\u0144",
            past: "dzie\u0144",
            future: "1 dzie\u0144"
        },
        twoFour: '{{count}} dni',
        other: '{{count}} dni'
    },
    aboutXWeeks: {
        one: "oko\u0142o tygodnia",
        twoFour: "oko\u0142o {{count}} tygodni",
        other: "oko\u0142o {{count}} tygodni"
    },
    xWeeks: {
        one: "tydzie\u0144",
        twoFour: '{{count}} tygodnie',
        other: '{{count}} tygodni'
    },
    aboutXMonths: {
        one: "oko\u0142o miesi\u0105c",
        twoFour: "oko\u0142o {{count}} miesi\u0105ce",
        other: "oko\u0142o {{count}} miesi\u0119cy"
    },
    xMonths: {
        one: "miesi\u0105c",
        twoFour: "{{count}} miesi\u0105ce",
        other: "{{count}} miesi\u0119cy"
    },
    aboutXYears: {
        one: "oko\u0142o rok",
        twoFour: "oko\u0142o {{count}} lata",
        other: "oko\u0142o {{count}} lat"
    },
    xYears: {
        one: 'rok',
        twoFour: '{{count}} lata',
        other: '{{count}} lat'
    },
    overXYears: {
        one: 'ponad rok',
        twoFour: 'ponad {{count}} lata',
        other: 'ponad {{count}} lat'
    },
    almostXYears: {
        one: 'prawie rok',
        twoFour: 'prawie {{count}} lata',
        other: 'prawie {{count}} lat'
    }
};
function $d891f6b28439d91d$export$2e2bcd8739ae039(token, count, options) {
    options = options || {};
    var scheme = $d891f6b28439d91d$var$formatDistanceLocale[token];
    if (!options.addSuffix) return $d891f6b28439d91d$var$declension(scheme, count);
    if (options.comparison > 0) return 'za ' + $d891f6b28439d91d$var$declension(scheme, count, 'future');
    else return $d891f6b28439d91d$var$declension(scheme, count, 'past') + ' temu';
}

});

parcelRegister("G1bO4", function(module, exports) {
$parcel$export(module.exports, "default", () => $07e4d88df9374f8f$export$2e2bcd8739ae039);

var $8D7sK = parcelRequire("8D7sK");
var $07e4d88df9374f8f$var$dateFormats = {
    full: 'EEEE, do MMMM y',
    long: 'do MMMM y',
    medium: 'do MMM y',
    short: 'dd.MM.y'
};
var $07e4d88df9374f8f$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $07e4d88df9374f8f$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $07e4d88df9374f8f$var$formatLong = {
    date: (0, $8D7sK.default)({
        formats: $07e4d88df9374f8f$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $8D7sK.default)({
        formats: $07e4d88df9374f8f$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $8D7sK.default)({
        formats: $07e4d88df9374f8f$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $07e4d88df9374f8f$export$2e2bcd8739ae039 = $07e4d88df9374f8f$var$formatLong;

});

parcelRegister("cVEiC", function(module, exports) {
$parcel$export(module.exports, "default", () => $969a118494136865$export$2e2bcd8739ae039);

var $2q0eX = parcelRequire("2q0eX");
var $969a118494136865$var$adjectivesLastWeek = {
    masculine: 'ostatni',
    feminine: 'ostatnia'
};
var $969a118494136865$var$adjectivesThisWeek = {
    masculine: 'ten',
    feminine: 'ta'
};
var $969a118494136865$var$adjectivesNextWeek = {
    masculine: "nast\u0119pny",
    feminine: "nast\u0119pna"
};
var $969a118494136865$var$dayGrammaticalGender = {
    0: 'feminine',
    1: 'masculine',
    2: 'masculine',
    3: 'feminine',
    4: 'masculine',
    5: 'masculine',
    6: 'feminine'
};
function $969a118494136865$var$getAdjectives(token, date, baseDate, options) {
    if ((0, $2q0eX.default)(date, baseDate, options)) return $969a118494136865$var$adjectivesThisWeek;
    else if (token === 'lastWeek') return $969a118494136865$var$adjectivesLastWeek;
    else if (token === 'nextWeek') return $969a118494136865$var$adjectivesNextWeek;
    else throw new Error("Cannot determine adjectives for token ".concat(token));
}
function $969a118494136865$var$getAdjective(token, date, baseDate, options) {
    var day = date.getUTCDay();
    var adjectives = $969a118494136865$var$getAdjectives(token, date, baseDate, options);
    var grammaticalGender = $969a118494136865$var$dayGrammaticalGender[day];
    return adjectives[grammaticalGender];
}
function $969a118494136865$var$dayAndTimeWithAdjective(token, date, baseDate, options) {
    var adjective = $969a118494136865$var$getAdjective(token, date, baseDate, options);
    return "'".concat(adjective, "' eeee 'o' p");
}
var $969a118494136865$var$formatRelativeLocale = {
    lastWeek: $969a118494136865$var$dayAndTimeWithAdjective,
    yesterday: "'wczoraj o' p",
    today: "'dzisiaj o' p",
    tomorrow: "'jutro o' p",
    nextWeek: $969a118494136865$var$dayAndTimeWithAdjective,
    other: 'P'
};
function $969a118494136865$export$2e2bcd8739ae039(token, date, baseDate, options) {
    var format = $969a118494136865$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(token, date, baseDate, options);
    return format;
}

});

parcelRegister("db9L9", function(module, exports) {
$parcel$export(module.exports, "default", () => $9983df75020dfd2e$export$2e2bcd8739ae039);

var $7juaq = parcelRequire("7juaq");
function $9983df75020dfd2e$var$ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return String(number);
}
var $9983df75020dfd2e$var$eraValues = {
    narrow: [
        'p.n.e.',
        'n.e.'
    ],
    abbreviated: [
        'p.n.e.',
        'n.e.'
    ],
    wide: [
        "przed nasz\u0105 er\u0105",
        'naszej ery'
    ]
};
var $9983df75020dfd2e$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'I kw.',
        'II kw.',
        'III kw.',
        'IV kw.'
    ],
    wide: [
        "I kwarta\u0142",
        "II kwarta\u0142",
        "III kwarta\u0142",
        "IV kwarta\u0142"
    ]
};
var $9983df75020dfd2e$var$monthValues = {
    narrow: [
        'S',
        'L',
        'M',
        'K',
        'M',
        'C',
        'L',
        'S',
        'W',
        'P',
        'L',
        'G'
    ],
    abbreviated: [
        'sty',
        'lut',
        'mar',
        'kwi',
        'maj',
        'cze',
        'lip',
        'sie',
        'wrz',
        "pa\u017A",
        'lis',
        'gru'
    ],
    wide: [
        "stycze\u0144",
        'luty',
        'marzec',
        "kwiecie\u0144",
        'maj',
        'czerwiec',
        'lipiec',
        "sierpie\u0144",
        "wrzesie\u0144",
        "pa\u017Adziernik",
        'listopad',
        "grudzie\u0144"
    ]
};
var $9983df75020dfd2e$var$monthFormattingValues = {
    narrow: [
        's',
        'l',
        'm',
        'k',
        'm',
        'c',
        'l',
        's',
        'w',
        'p',
        'l',
        'g'
    ],
    abbreviated: [
        'sty',
        'lut',
        'mar',
        'kwi',
        'maj',
        'cze',
        'lip',
        'sie',
        'wrz',
        "pa\u017A",
        'lis',
        'gru'
    ],
    wide: [
        'stycznia',
        'lutego',
        'marca',
        'kwietnia',
        'maja',
        'czerwca',
        'lipca',
        'sierpnia',
        "wrze\u015Bnia",
        "pa\u017Adziernika",
        'listopada',
        'grudnia'
    ]
};
var $9983df75020dfd2e$var$dayValues = {
    narrow: [
        'N',
        'P',
        'W',
        "\u015A",
        'C',
        'P',
        'S'
    ],
    short: [
        'nie',
        'pon',
        'wto',
        "\u015Bro",
        'czw',
        "pi\u0105",
        'sob'
    ],
    abbreviated: [
        'niedz.',
        'pon.',
        'wt.',
        "\u015Br.",
        'czw.',
        'pt.',
        'sob.'
    ],
    wide: [
        'niedziela',
        "poniedzia\u0142ek",
        'wtorek',
        "\u015Broda",
        'czwartek',
        "pi\u0105tek",
        'sobota'
    ]
};
var $9983df75020dfd2e$var$dayFormattingValues = {
    narrow: [
        'n',
        'p',
        'w',
        "\u015B",
        'c',
        'p',
        's'
    ],
    short: [
        'nie',
        'pon',
        'wto',
        "\u015Bro",
        'czw',
        "pi\u0105",
        'sob'
    ],
    abbreviated: [
        'niedz.',
        'pon.',
        'wt.',
        "\u015Br.",
        'czw.',
        'pt.',
        'sob.'
    ],
    wide: [
        'niedziela',
        "poniedzia\u0142ek",
        'wtorek',
        "\u015Broda",
        'czwartek',
        "pi\u0105tek",
        'sobota'
    ]
};
var $9983df75020dfd2e$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "p\xf3\u0142n.",
        noon: "po\u0142",
        morning: 'rano',
        afternoon: "popo\u0142.",
        evening: 'wiecz.',
        night: 'noc'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "p\xf3\u0142noc",
        noon: "po\u0142udnie",
        morning: 'rano',
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xf3r",
        night: 'noc'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "p\xf3\u0142noc",
        noon: "po\u0142udnie",
        morning: 'rano',
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xf3r",
        night: 'noc'
    }
};
var $9983df75020dfd2e$var$dayPeriodFormattingValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "o p\xf3\u0142n.",
        noon: "w po\u0142.",
        morning: 'rano',
        afternoon: "po po\u0142.",
        evening: 'wiecz.',
        night: 'w nocy'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "o p\xf3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: 'rano',
        afternoon: "po po\u0142udniu",
        evening: 'wieczorem',
        night: 'w nocy'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "o p\xf3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: 'rano',
        afternoon: "po po\u0142udniu",
        evening: 'wieczorem',
        night: 'w nocy'
    }
};
var $9983df75020dfd2e$var$localize = {
    ordinalNumber: $9983df75020dfd2e$var$ordinalNumber,
    era: (0, $7juaq.default)({
        values: $9983df75020dfd2e$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $7juaq.default)({
        values: $9983df75020dfd2e$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $7juaq.default)({
        values: $9983df75020dfd2e$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $9983df75020dfd2e$var$monthFormattingValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $7juaq.default)({
        values: $9983df75020dfd2e$var$dayValues,
        defaultWidth: 'wide',
        formattingValues: $9983df75020dfd2e$var$dayFormattingValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, $7juaq.default)({
        values: $9983df75020dfd2e$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $9983df75020dfd2e$var$dayPeriodFormattingValues,
        defaultFormattingWidth: 'wide'
    })
};
var $9983df75020dfd2e$export$2e2bcd8739ae039 = $9983df75020dfd2e$var$localize;

});

parcelRegister("6Ncuj", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f21018b56b15ca5$export$2e2bcd8739ae039);

var $bFSku = parcelRequire("bFSku");

var $5hQUT = parcelRequire("5hQUT");
var $4f21018b56b15ca5$var$matchOrdinalNumberPattern = /^(\d+)?/i;
var $4f21018b56b15ca5$var$parseOrdinalNumberPattern = /\d+/i;
var $4f21018b56b15ca5$var$matchEraPatterns = {
    narrow: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    abbreviated: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    wide: /^(przed\s*nasz(ą|a)\s*er(ą|a)|naszej\s*ery)/i
};
var $4f21018b56b15ca5$var$parseEraPatterns = {
    any: [
        /^p/i,
        /^n/i
    ]
};
var $4f21018b56b15ca5$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^(I|II|III|IV)\s*kw\.?/i,
    wide: /^(I|II|III|IV)\s*kwarta(ł|l)/i
};
var $4f21018b56b15ca5$var$parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /^I kw/i,
        /^II kw/i,
        /^III kw/i,
        /^IV kw/i
    ]
};
var $4f21018b56b15ca5$var$matchMonthPatterns = {
    narrow: /^[slmkcwpg]/i,
    abbreviated: /^(sty|lut|mar|kwi|maj|cze|lip|sie|wrz|pa(ź|z)|lis|gru)/i,
    wide: /^(stycznia|stycze(ń|n)|lutego|luty|marca|marzec|kwietnia|kwiecie(ń|n)|maja|maj|czerwca|czerwiec|lipca|lipiec|sierpnia|sierpie(ń|n)|wrze(ś|s)nia|wrzesie(ń|n)|pa(ź|z)dziernika|pa(ź|z)dziernik|listopada|listopad|grudnia|grudzie(ń|n))/i
};
var $4f21018b56b15ca5$var$parseMonthPatterns = {
    narrow: [
        /^s/i,
        /^l/i,
        /^m/i,
        /^k/i,
        /^m/i,
        /^c/i,
        /^l/i,
        /^s/i,
        /^w/i,
        /^p/i,
        /^l/i,
        /^g/i
    ],
    any: [
        /^st/i,
        /^lu/i,
        /^mar/i,
        /^k/i,
        /^maj/i,
        /^c/i,
        /^lip/i,
        /^si/i,
        /^w/i,
        /^p/i,
        /^lis/i,
        /^g/i
    ]
};
var $4f21018b56b15ca5$var$matchDayPatterns = {
    narrow: /^[npwścs]/i,
    short: /^(nie|pon|wto|(ś|s)ro|czw|pi(ą|a)|sob)/i,
    abbreviated: /^(niedz|pon|wt|(ś|s)r|czw|pt|sob)\.?/i,
    wide: /^(niedziela|poniedzia(ł|l)ek|wtorek|(ś|s)roda|czwartek|pi(ą|a)tek|sobota)/i
};
var $4f21018b56b15ca5$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^w/i,
        /^ś/i,
        /^c/i,
        /^p/i,
        /^s/i
    ],
    abbreviated: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pt/i,
        /^so/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pi/i,
        /^so/i
    ]
};
var $4f21018b56b15ca5$var$matchDayPeriodPatterns = {
    narrow: /^(^a$|^p$|pó(ł|l)n\.?|o\s*pó(ł|l)n\.?|po(ł|l)\.?|w\s*po(ł|l)\.?|po\s*po(ł|l)\.?|rano|wiecz\.?|noc|w\s*nocy)/i,
    any: /^(am|pm|pó(ł|l)noc|o\s*pó(ł|l)nocy|po(ł|l)udnie|w\s*po(ł|l)udnie|popo(ł|l)udnie|po\s*po(ł|l)udniu|rano|wieczór|wieczorem|noc|w\s*nocy)/i
};
var $4f21018b56b15ca5$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^a$/i,
        pm: /^p$/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    },
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    }
};
var $4f21018b56b15ca5$var$match = {
    ordinalNumber: (0, $bFSku.default)({
        matchPattern: $4f21018b56b15ca5$var$matchOrdinalNumberPattern,
        parsePattern: $4f21018b56b15ca5$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5hQUT.default)({
        matchPatterns: $4f21018b56b15ca5$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4f21018b56b15ca5$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5hQUT.default)({
        matchPatterns: $4f21018b56b15ca5$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4f21018b56b15ca5$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $5hQUT.default)({
        matchPatterns: $4f21018b56b15ca5$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4f21018b56b15ca5$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5hQUT.default)({
        matchPatterns: $4f21018b56b15ca5$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4f21018b56b15ca5$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5hQUT.default)({
        matchPatterns: $4f21018b56b15ca5$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $4f21018b56b15ca5$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $4f21018b56b15ca5$export$2e2bcd8739ae039 = $4f21018b56b15ca5$var$match;

});


parcelRegister("2juPt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $1af5452381935ea0$export$2e2bcd8739ae039);

var $bUsjB = parcelRequire("bUsjB");

var $iS345 = parcelRequire("iS345");

var $kuENd = parcelRequire("kuENd");

var $8lw0V = parcelRequire("8lw0V");

var $9pixS = parcelRequire("9pixS");
/**
 * @type {Locale}
 * @category Locales
 * @summary Portuguese locale.
 * @language Portuguese
 * @iso-639-2 por
 * @author Dário Freire [@dfreire]{@link https://github.com/dfreire}
 * @author Adrián de la Rosa [@adrm]{@link https://github.com/adrm}
 */ var $1af5452381935ea0$var$locale = {
    code: 'pt',
    formatDistance: (0, $bUsjB.default),
    formatLong: (0, $iS345.default),
    formatRelative: (0, $kuENd.default),
    localize: (0, $8lw0V.default),
    match: (0, $9pixS.default),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
    }
};
var $1af5452381935ea0$export$2e2bcd8739ae039 = $1af5452381935ea0$var$locale;

});
parcelRegister("bUsjB", function(module, exports) {
$parcel$export(module.exports, "default", () => $8abae373daf3ae99$export$2e2bcd8739ae039);
var $8abae373daf3ae99$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos de um segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'meio minuto',
    lessThanXMinutes: {
        one: 'menos de um minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'aproximadamente 1 hora',
        other: 'aproximadamente {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: '1 dia',
        other: '{{count}} dias'
    },
    aboutXWeeks: {
        one: 'aproximadamente 1 semana',
        other: 'aproximadamente {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: "aproximadamente 1 m\xeas",
        other: 'aproximadamente {{count}} meses'
    },
    xMonths: {
        one: "1 m\xeas",
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'aproximadamente 1 ano',
        other: 'aproximadamente {{count}} anos'
    },
    xYears: {
        one: '1 ano',
        other: '{{count}} anos'
    },
    overXYears: {
        one: 'mais de 1 ano',
        other: 'mais de {{count}} anos'
    },
    almostXYears: {
        one: 'quase 1 ano',
        other: 'quase {{count}} anos'
    }
};
function $8abae373daf3ae99$export$2e2bcd8739ae039(token, count, options) {
    options = options || {};
    var result;
    if (typeof $8abae373daf3ae99$var$formatDistanceLocale[token] === 'string') result = $8abae373daf3ae99$var$formatDistanceLocale[token];
    else if (count === 1) result = $8abae373daf3ae99$var$formatDistanceLocale[token].one;
    else result = $8abae373daf3ae99$var$formatDistanceLocale[token].other.replace('{{count}}', count);
    if (options.addSuffix) {
        if (options.comparison > 0) return 'daqui a ' + result;
        else return "h\xe1 " + result;
    }
    return result;
}

});

parcelRegister("iS345", function(module, exports) {
$parcel$export(module.exports, "default", () => $dbcfa5c5125cb3d4$export$2e2bcd8739ae039);

var $8D7sK = parcelRequire("8D7sK");
var $dbcfa5c5125cb3d4$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d 'de' MMM 'de' y",
    short: 'dd/MM/y'
};
var $dbcfa5c5125cb3d4$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $dbcfa5c5125cb3d4$var$dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $dbcfa5c5125cb3d4$var$formatLong = {
    date: (0, $8D7sK.default)({
        formats: $dbcfa5c5125cb3d4$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $8D7sK.default)({
        formats: $dbcfa5c5125cb3d4$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $8D7sK.default)({
        formats: $dbcfa5c5125cb3d4$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $dbcfa5c5125cb3d4$export$2e2bcd8739ae039 = $dbcfa5c5125cb3d4$var$formatLong;

});

parcelRegister("kuENd", function(module, exports) {
$parcel$export(module.exports, "default", () => $eeb6409bf56ff63d$export$2e2bcd8739ae039);
var $eeb6409bf56ff63d$var$formatRelativeLocale = {
    lastWeek: "'na \xfaltima' eeee '\xe0s' p",
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: 'P'
};
function $eeb6409bf56ff63d$export$2e2bcd8739ae039(token, _date, _baseDate, _options) {
    return $eeb6409bf56ff63d$var$formatRelativeLocale[token];
}

});

parcelRegister("8lw0V", function(module, exports) {
$parcel$export(module.exports, "default", () => $61391e3134a5a682$export$2e2bcd8739ae039);

var $7juaq = parcelRequire("7juaq");
function $61391e3134a5a682$var$ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + "\xba";
}
var $61391e3134a5a682$var$eraValues = {
    narrow: [
        'aC',
        'dC'
    ],
    abbreviated: [
        'a.C.',
        'd.C.'
    ],
    wide: [
        'antes de Cristo',
        'depois de Cristo'
    ]
};
var $61391e3134a5a682$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $61391e3134a5a682$var$monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'fev',
        'mar',
        'abr',
        'mai',
        'jun',
        'jul',
        'ago',
        'set',
        'out',
        'nov',
        'dez'
    ],
    wide: [
        'janeiro',
        'fevereiro',
        "mar\xe7o",
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro'
    ]
};
var $61391e3134a5a682$var$dayValues = {
    narrow: [
        'd',
        's',
        't',
        'q',
        'q',
        's',
        's'
    ],
    short: [
        'dom',
        'seg',
        'ter',
        'qua',
        'qui',
        'sex',
        "s\xe1b"
    ],
    abbreviated: [
        'dom',
        'seg',
        'ter',
        'qua',
        'qui',
        'sex',
        "s\xe1b"
    ],
    wide: [
        'domingo',
        'segunda-feira',
        "ter\xe7a-feira",
        'quarta-feira',
        'quinta-feira',
        'sexta-feira',
        "s\xe1bado"
    ]
};
var $61391e3134a5a682$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'noite',
        night: 'madrugada'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'noite',
        night: 'madrugada'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'noite',
        night: 'madrugada'
    }
};
var $61391e3134a5a682$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da noite',
        night: 'da madrugada'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da noite',
        night: 'da madrugada'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da noite',
        night: 'da madrugada'
    }
};
var $61391e3134a5a682$var$localize = {
    ordinalNumber: $61391e3134a5a682$var$ordinalNumber,
    era: (0, $7juaq.default)({
        values: $61391e3134a5a682$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $7juaq.default)({
        values: $61391e3134a5a682$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $7juaq.default)({
        values: $61391e3134a5a682$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $7juaq.default)({
        values: $61391e3134a5a682$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $7juaq.default)({
        values: $61391e3134a5a682$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $61391e3134a5a682$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $61391e3134a5a682$export$2e2bcd8739ae039 = $61391e3134a5a682$var$localize;

});

parcelRegister("9pixS", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d94d59649fed04a$export$2e2bcd8739ae039);

var $bFSku = parcelRequire("bFSku");

var $5hQUT = parcelRequire("5hQUT");
var $6d94d59649fed04a$var$matchOrdinalNumberPattern = /^(\d+)(º|ª)?/i;
var $6d94d59649fed04a$var$parseOrdinalNumberPattern = /\d+/i;
var $6d94d59649fed04a$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
};
var $6d94d59649fed04a$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes da era comum)/i,
        /^(depois de cristo|era comum)/i
    ]
};
var $6d94d59649fed04a$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º|ª)? trimestre/i
};
var $6d94d59649fed04a$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $6d94d59649fed04a$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var $6d94d59649fed04a$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ab/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $6d94d59649fed04a$var$matchDayPatterns = {
    narrow: /^[dstq]/i,
    short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
};
var $6d94d59649fed04a$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^s/i,
        /^t/i,
        /^q/i,
        /^q/i,
        /^s/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[áa]/i
    ]
};
var $6d94d59649fed04a$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
    any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
};
var $6d94d59649fed04a$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^meia/i,
        noon: /^meio/i,
        morning: /manh[ãa]/i,
        afternoon: /tarde/i,
        evening: /noite/i,
        night: /madrugada/i
    }
};
var $6d94d59649fed04a$var$match = {
    ordinalNumber: (0, $bFSku.default)({
        matchPattern: $6d94d59649fed04a$var$matchOrdinalNumberPattern,
        parsePattern: $6d94d59649fed04a$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5hQUT.default)({
        matchPatterns: $6d94d59649fed04a$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6d94d59649fed04a$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5hQUT.default)({
        matchPatterns: $6d94d59649fed04a$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6d94d59649fed04a$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $5hQUT.default)({
        matchPatterns: $6d94d59649fed04a$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6d94d59649fed04a$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5hQUT.default)({
        matchPatterns: $6d94d59649fed04a$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6d94d59649fed04a$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5hQUT.default)({
        matchPatterns: $6d94d59649fed04a$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $6d94d59649fed04a$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $6d94d59649fed04a$export$2e2bcd8739ae039 = $6d94d59649fed04a$var$match;

});


parcelRegister("bZFHe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $8bb5bc3d0e5ad30a$export$2e2bcd8739ae039);

var $7ZN3x = parcelRequire("7ZN3x");

var $8QZWF = parcelRequire("8QZWF");

var $3pxdT = parcelRequire("3pxdT");

var $C0F8N = parcelRequire("C0F8N");

var $h8DiG = parcelRequire("h8DiG");
/**
 * @type {Locale}
 * @category Locales
 * @summary Russian locale.
 * @language Russian
 * @iso-639-2 rus
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $8bb5bc3d0e5ad30a$var$locale = {
    code: 'ru',
    formatDistance: (0, $7ZN3x.default),
    formatLong: (0, $8QZWF.default),
    formatRelative: (0, $3pxdT.default),
    localize: (0, $C0F8N.default),
    match: (0, $h8DiG.default),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
    }
};
var $8bb5bc3d0e5ad30a$export$2e2bcd8739ae039 = $8bb5bc3d0e5ad30a$var$locale;

});
parcelRegister("7ZN3x", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d24486af58d6208$export$2e2bcd8739ae039);
function $5d24486af58d6208$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100; // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', count); // 2, 3, 4, 22, 23, 24, 32 ...
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', count); // 5, 6, 7, 8, 9, 10, 11, ...
    else return scheme.pluralGenitive.replace('{{count}}', count);
}
function $5d24486af58d6208$var$buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options.addSuffix) {
            if (options.comparison > 0) {
                if (scheme.future) return $5d24486af58d6208$var$declension(scheme.future, count);
                else return "\u0447\u0435\u0440\u0435\u0437 " + $5d24486af58d6208$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $5d24486af58d6208$var$declension(scheme.past, count);
                else return $5d24486af58d6208$var$declension(scheme.regular, count) + " \u043D\u0430\u0437\u0430\u0434";
            }
        } else return $5d24486af58d6208$var$declension(scheme.regular, count);
    };
}
var $5d24486af58d6208$var$formatDistanceLocale = {
    lessThanXSeconds: $5d24486af58d6208$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $5d24486af58d6208$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: function(_, options) {
        if (options.addSuffix) {
            if (options.comparison > 0) return "\u0447\u0435\u0440\u0435\u0437 \u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
            else return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434";
        }
        return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
    },
    lessThanXMinutes: $5d24486af58d6208$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u043C\u0438\u043D\u0443\u0442\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u043C\u0438\u043D\u0443\u0442\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
    }),
    xMinutes: $5d24486af58d6208$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0430",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        past: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
    }),
    aboutXHours: $5d24486af58d6208$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u043E\u0432"
        }
    }),
    xHours: $5d24486af58d6208$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0447\u0430\u0441",
            singularGenitive: "{{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "{{count}} \u0447\u0430\u0441\u043E\u0432"
        }
    }),
    xDays: $5d24486af58d6208$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u044F",
            pluralGenitive: "{{count}} \u0434\u043D\u0435\u0439"
        }
    }),
    aboutXWeeks: $5d24486af58d6208$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044E",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
    }),
    xWeeks: $5d24486af58d6208$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044F",
            singularGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
    }),
    aboutXMonths: $5d24486af58d6208$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
    }),
    xMonths: $5d24486af58d6208$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
    }),
    aboutXYears: $5d24486af58d6208$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    }),
    xYears: $5d24486af58d6208$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "{{count}} \u043B\u0435\u0442"
        }
    }),
    overXYears: $5d24486af58d6208$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    }),
    almostXYears: $5d24486af58d6208$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    })
};
function $5d24486af58d6208$export$2e2bcd8739ae039(token, count, options) {
    options = options || {};
    return $5d24486af58d6208$var$formatDistanceLocale[token](count, options);
}

});

parcelRegister("8QZWF", function(module, exports) {
$parcel$export(module.exports, "default", () => $67233b11fc51df5e$export$2e2bcd8739ae039);

var $8D7sK = parcelRequire("8D7sK");
var $67233b11fc51df5e$var$dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: 'dd.MM.y'
};
var $67233b11fc51df5e$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $67233b11fc51df5e$var$dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var $67233b11fc51df5e$var$formatLong = {
    date: (0, $8D7sK.default)({
        formats: $67233b11fc51df5e$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $8D7sK.default)({
        formats: $67233b11fc51df5e$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $8D7sK.default)({
        formats: $67233b11fc51df5e$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $67233b11fc51df5e$export$2e2bcd8739ae039 = $67233b11fc51df5e$var$formatLong;

});

parcelRegister("3pxdT", function(module, exports) {
$parcel$export(module.exports, "default", () => $27bd7a529030bd18$export$2e2bcd8739ae039);

var $2q0eX = parcelRequire("2q0eX");
var $27bd7a529030bd18$var$accusativeWeekdays = [
    "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u0435\u0434\u0443",
    "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
    "\u043F\u044F\u0442\u043D\u0438\u0446\u0443",
    "\u0441\u0443\u0431\u0431\u043E\u0442\u0443"
];
function $27bd7a529030bd18$var$lastWeek(day) {
    var weekday = $27bd7a529030bd18$var$accusativeWeekdays[day];
    switch(day){
        case 0:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u043E\u0435 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u044B\u0439 " + weekday + " \u0432' p";
        case 3:
        case 5:
        case 6:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u0443\u044E " + weekday + " \u0432' p";
    }
}
function $27bd7a529030bd18$var$thisWeek(day) {
    var weekday = $27bd7a529030bd18$var$accusativeWeekdays[day];
    if (day === 2) return "'\u0432\u043E " + weekday + " \u0432' p";
    else return "'\u0432 " + weekday + " \u0432' p";
}
function $27bd7a529030bd18$var$nextWeek(day) {
    var weekday = $27bd7a529030bd18$var$accusativeWeekdays[day];
    switch(day){
        case 0:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 " + weekday + " \u0432' p";
        case 3:
        case 5:
        case 6:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E " + weekday + " \u0432' p";
    }
}
var $27bd7a529030bd18$var$formatRelativeLocale = {
    lastWeek: function(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $2q0eX.default)(date, baseDate, options)) return $27bd7a529030bd18$var$thisWeek(day);
        else return $27bd7a529030bd18$var$lastWeek(day);
    },
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
    today: "'\u0441\u0435\u0433\u043E\u0434\u043D\u044F \u0432' p",
    tomorrow: "'\u0437\u0430\u0432\u0442\u0440\u0430 \u0432' p",
    nextWeek: function(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $2q0eX.default)(date, baseDate, options)) return $27bd7a529030bd18$var$thisWeek(day);
        else return $27bd7a529030bd18$var$nextWeek(day);
    },
    other: 'P'
};
function $27bd7a529030bd18$export$2e2bcd8739ae039(token, date, baseDate, options) {
    var format = $27bd7a529030bd18$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
}

});

parcelRegister("C0F8N", function(module, exports) {
$parcel$export(module.exports, "default", () => $0724104bc4a9e259$export$2e2bcd8739ae039);

var $7juaq = parcelRequire("7juaq");
var $0724104bc4a9e259$var$eraValues = {
    narrow: [
        "\u0434\u043E \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u043E \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u043E \u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B"
    ]
};
var $0724104bc4a9e259$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0439 \u043A\u0432.",
        "2-\u0439 \u043A\u0432.",
        "3-\u0439 \u043A\u0432.",
        "4-\u0439 \u043A\u0432."
    ],
    wide: [
        "1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $0724104bc4a9e259$var$monthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432.",
        "\u0444\u0435\u0432.",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440.",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D\u044C",
        "\u0438\u044E\u043B\u044C",
        "\u0430\u0432\u0433.",
        "\u0441\u0435\u043D\u0442.",
        "\u043E\u043A\u0442.",
        "\u043D\u043E\u044F\u0431.",
        "\u0434\u0435\u043A."
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440\u044C",
        "\u0444\u0435\u0432\u0440\u0430\u043B\u044C",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0435\u043B\u044C",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D\u044C",
        "\u0438\u044E\u043B\u044C",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C",
        "\u043E\u043A\u0442\u044F\u0431\u0440\u044C",
        "\u043D\u043E\u044F\u0431\u0440\u044C",
        "\u0434\u0435\u043A\u0430\u0431\u0440\u044C"
    ]
};
var $0724104bc4a9e259$var$formattingMonthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432.",
        "\u0444\u0435\u0432.",
        "\u043C\u0430\u0440.",
        "\u0430\u043F\u0440.",
        "\u043C\u0430\u044F",
        "\u0438\u044E\u043D.",
        "\u0438\u044E\u043B.",
        "\u0430\u0432\u0433.",
        "\u0441\u0435\u043D\u0442.",
        "\u043E\u043A\u0442.",
        "\u043D\u043E\u044F\u0431.",
        "\u0434\u0435\u043A."
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440\u044F",
        "\u0444\u0435\u0432\u0440\u0430\u043B\u044F",
        "\u043C\u0430\u0440\u0442\u0430",
        "\u0430\u043F\u0440\u0435\u043B\u044F",
        "\u043C\u0430\u044F",
        "\u0438\u044E\u043D\u044F",
        "\u0438\u044E\u043B\u044F",
        "\u0430\u0432\u0433\u0443\u0441\u0442\u0430",
        "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F",
        "\u043E\u043A\u0442\u044F\u0431\u0440\u044F",
        "\u043D\u043E\u044F\u0431\u0440\u044F",
        "\u0434\u0435\u043A\u0430\u0431\u0440\u044F"
    ]
};
var $0724104bc4a9e259$var$dayValues = {
    narrow: [
        "\u0412",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u0432\u0441",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u0432\u0441\u043A",
        "\u043F\u043D\u0434",
        "\u0432\u0442\u0440",
        "\u0441\u0440\u0434",
        "\u0447\u0442\u0432",
        "\u043F\u0442\u043D",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
        "\u043F\u044F\u0442\u043D\u0438\u0446\u0430",
        "\u0441\u0443\u0431\u0431\u043E\u0442\u0430"
    ]
};
var $0724104bc4a9e259$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0435\u0440",
        night: "\u043D\u043E\u0447\u044C"
    }
};
var $0724104bc4a9e259$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0435\u0440\u0430",
        night: "\u043D\u043E\u0447\u0438"
    }
};
function $0724104bc4a9e259$var$ordinalNumber(dirtyNumber, dirtyOptions) {
    var options = dirtyOptions || {};
    var unit = String(options.unit);
    var suffix;
    if (unit === 'date') suffix = "-\u0435";
    else if (unit === 'week' || unit === 'minute' || unit === 'second') suffix = "-\u044F";
    else suffix = "-\u0439";
    return dirtyNumber + suffix;
}
var $0724104bc4a9e259$var$localize = {
    ordinalNumber: $0724104bc4a9e259$var$ordinalNumber,
    era: (0, $7juaq.default)({
        values: $0724104bc4a9e259$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $7juaq.default)({
        values: $0724104bc4a9e259$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $7juaq.default)({
        values: $0724104bc4a9e259$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $0724104bc4a9e259$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $7juaq.default)({
        values: $0724104bc4a9e259$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $7juaq.default)({
        values: $0724104bc4a9e259$var$dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: $0724104bc4a9e259$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $0724104bc4a9e259$export$2e2bcd8739ae039 = $0724104bc4a9e259$var$localize;

});

parcelRegister("h8DiG", function(module, exports) {
$parcel$export(module.exports, "default", () => $c7a1ab4598b92363$export$2e2bcd8739ae039);

var $bFSku = parcelRequire("bFSku");

var $5hQUT = parcelRequire("5hQUT");
var $c7a1ab4598b92363$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i;
var $c7a1ab4598b92363$var$parseOrdinalNumberPattern = /\d+/i;
var $c7a1ab4598b92363$var$matchEraPatterns = {
    narrow: /^((до )?н\.?\s?э\.?)/i,
    abbreviated: /^((до )?н\.?\s?э\.?)/i,
    wide: /^(до нашей эры|нашей эры|наша эра)/i
};
var $c7a1ab4598b92363$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var $c7a1ab4598b92363$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
    wide: /^[1234](-?[ыои]?й?)? квартал/i
};
var $c7a1ab4598b92363$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $c7a1ab4598b92363$var$matchMonthPatterns = {
    narrow: /^[яфмаисонд]/i,
    abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
    wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
};
var $c7a1ab4598b92363$var$parseMonthPatterns = {
    narrow: [
        /^я/i,
        /^ф/i,
        /^м/i,
        /^а/i,
        /^м/i,
        /^и/i,
        /^и/i,
        /^а/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^я/i
    ],
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^ав/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
var $c7a1ab4598b92363$var$matchDayPatterns = {
    narrow: /^[впсч]/i,
    short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
    abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
    wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
};
var $c7a1ab4598b92363$var$parseDayPatterns = {
    narrow: [
        /^в/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^в[ос]/i,
        /^п[он]/i,
        /^в/i,
        /^ср/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
var $c7a1ab4598b92363$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
};
var $c7a1ab4598b92363$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^полн/i,
        noon: /^полд/i,
        morning: /^у/i,
        afternoon: /^д[ен]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var $c7a1ab4598b92363$var$match = {
    ordinalNumber: (0, $bFSku.default)({
        matchPattern: $c7a1ab4598b92363$var$matchOrdinalNumberPattern,
        parsePattern: $c7a1ab4598b92363$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5hQUT.default)({
        matchPatterns: $c7a1ab4598b92363$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c7a1ab4598b92363$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5hQUT.default)({
        matchPatterns: $c7a1ab4598b92363$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c7a1ab4598b92363$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $5hQUT.default)({
        matchPatterns: $c7a1ab4598b92363$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c7a1ab4598b92363$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5hQUT.default)({
        matchPatterns: $c7a1ab4598b92363$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c7a1ab4598b92363$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5hQUT.default)({
        matchPatterns: $c7a1ab4598b92363$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c7a1ab4598b92363$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $c7a1ab4598b92363$export$2e2bcd8739ae039 = $c7a1ab4598b92363$var$match;

});


parcelRegister("gjhJ4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $bdfc2baf148c6f7f$export$2e2bcd8739ae039);

var $aNl3g = parcelRequire("aNl3g");

var $K6Hbr = parcelRequire("K6Hbr");

var $5g3Ed = parcelRequire("5g3Ed");

var $8VNS6 = parcelRequire("8VNS6");

var $evRwj = parcelRequire("evRwj");
/**
 * @type {Locale}
 * @category Locales
 * @summary Swedish locale.
 * @language Swedish
 * @iso-639-2 swe
 * @author Johannes Ulén [@ejulen]{@link https://github.com/ejulen}
 * @author Alexander Nanberg [@alexandernanberg]{@link https://github.com/alexandernanberg}
 * @author Henrik Andersson [@limelights]{@link https://github.com/limelights}
 */ var $bdfc2baf148c6f7f$var$locale = {
    code: 'sv',
    formatDistance: (0, $aNl3g.default),
    formatLong: (0, $K6Hbr.default),
    formatRelative: (0, $5g3Ed.default),
    localize: (0, $8VNS6.default),
    match: (0, $evRwj.default),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
    }
};
var $bdfc2baf148c6f7f$export$2e2bcd8739ae039 = $bdfc2baf148c6f7f$var$locale;

});
parcelRegister("aNl3g", function(module, exports) {
$parcel$export(module.exports, "default", () => $7dbecf687bd61bca$export$2e2bcd8739ae039);
var $7dbecf687bd61bca$var$formatDistanceLocale = {
    lessThanXSeconds: {
        singular: "mindre \xe4n en sekund",
        plural: "mindre \xe4n {{count}} sekunder"
    },
    xSeconds: {
        singular: 'en sekund',
        plural: '{{count}} sekunder'
    },
    halfAMinute: 'en halv minut',
    lessThanXMinutes: {
        singular: "mindre \xe4n en minut",
        plural: "mindre \xe4n {{count}} minuter"
    },
    xMinutes: {
        singular: 'en minut',
        plural: '{{count}} minuter'
    },
    aboutXHours: {
        singular: "ungef\xe4r en timme",
        plural: "ungef\xe4r {{count}} timmar"
    },
    xHours: {
        singular: 'en timme',
        plural: '{{count}} timmar'
    },
    xDays: {
        singular: 'en dag',
        plural: '{{count}} dagar'
    },
    aboutXWeeks: {
        singular: "ungef\xe4r en vecka",
        plural: "ungef\xe4r {{count}} vecka"
    },
    xWeeks: {
        singular: 'en vecka',
        plural: '{{count}} vecka'
    },
    aboutXMonths: {
        singular: "ungef\xe4r en m\xe5nad",
        plural: "ungef\xe4r {{count}} m\xe5nader"
    },
    xMonths: {
        singular: "en m\xe5nad",
        plural: "{{count}} m\xe5nader"
    },
    aboutXYears: {
        singular: "ungef\xe4r ett \xe5r",
        plural: "ungef\xe4r {{count}} \xe5r"
    },
    xYears: {
        singular: "ett \xe5r",
        plural: "{{count}} \xe5r"
    },
    overXYears: {
        singular: "\xf6ver ett \xe5r",
        plural: "\xf6ver {{count}} \xe5r"
    },
    almostXYears: {
        singular: "n\xe4stan ett \xe5r",
        plural: "n\xe4stan {{count}} \xe5r"
    }
};
var $7dbecf687bd61bca$var$wordMapping = [
    'noll',
    'en',
    "tv\xe5",
    'tre',
    'fyra',
    'fem',
    'sex',
    'sju',
    "\xe5tta",
    'nio',
    'tio',
    'elva',
    'tolv'
];
function $7dbecf687bd61bca$export$2e2bcd8739ae039(token, count, options) {
    options = options || {
        onlyNumeric: false
    };
    var translation = $7dbecf687bd61bca$var$formatDistanceLocale[token];
    var result;
    if (typeof translation === 'string') result = translation;
    else if (count === 0 || count > 1) {
        if (options.onlyNumeric) result = translation.plural.replace('{{count}}', count);
        else result = translation.plural.replace('{{count}}', count < 13 ? $7dbecf687bd61bca$var$wordMapping[count] : count);
    } else result = translation.singular;
    if (options.addSuffix) {
        if (options.comparison > 0) return 'om ' + result;
        else return result + ' sedan';
    }
    return result;
}

});

parcelRegister("K6Hbr", function(module, exports) {
$parcel$export(module.exports, "default", () => $08a97d94da046450$export$2e2bcd8739ae039);

var $8D7sK = parcelRequire("8D7sK");
var $08a97d94da046450$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'y-MM-dd'
};
var $08a97d94da046450$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $08a97d94da046450$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $08a97d94da046450$var$formatLong = {
    date: (0, $8D7sK.default)({
        formats: $08a97d94da046450$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $8D7sK.default)({
        formats: $08a97d94da046450$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $8D7sK.default)({
        formats: $08a97d94da046450$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $08a97d94da046450$export$2e2bcd8739ae039 = $08a97d94da046450$var$formatLong;

});

parcelRegister("5g3Ed", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d4146bd01233dbc$export$2e2bcd8739ae039);
var $3d4146bd01233dbc$var$formatRelativeLocale = {
    lastWeek: "'i' EEEE's kl.' p",
    yesterday: "'ig\xe5r kl.' p",
    today: "'idag kl.' p",
    tomorrow: "'imorgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: 'P'
};
function $3d4146bd01233dbc$export$2e2bcd8739ae039(token, _date, _baseDate, _options) {
    return $3d4146bd01233dbc$var$formatRelativeLocale[token];
}

});

parcelRegister("8VNS6", function(module, exports) {
$parcel$export(module.exports, "default", () => $680a550ce989b71e$export$2e2bcd8739ae039);

var $7juaq = parcelRequire("7juaq");
var $680a550ce989b71e$var$eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        "f\xf6re Kristus",
        'efter Kristus'
    ]
};
var $680a550ce989b71e$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1:a kvartalet',
        '2:a kvartalet',
        '3:e kvartalet',
        '4:e kvartalet'
    ]
};
var $680a550ce989b71e$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        'apr.',
        'maj',
        'juni',
        'juli',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januari',
        'februari',
        'mars',
        'april',
        'maj',
        'juni',
        'juli',
        'augusti',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var $680a550ce989b71e$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        "s\xf6",
        "m\xe5",
        'ti',
        'on',
        'to',
        'fr',
        "l\xf6"
    ],
    abbreviated: [
        "s\xf6n",
        "m\xe5n",
        'tis',
        'ons',
        'tors',
        'fre',
        "l\xf6r"
    ],
    wide: [
        "s\xf6ndag",
        "m\xe5ndag",
        'tisdag',
        'onsdag',
        'torsdag',
        'fredag',
        "l\xf6rdag"
    ]
}; // https://www.unicode.org/cldr/charts/32/summary/sv.html#1888
var $680a550ce989b71e$var$dayPeriodValues = {
    narrow: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: 'morg.',
        afternoon: 'efterm.',
        evening: "kv\xe4ll",
        night: 'natt'
    },
    abbreviated: {
        am: 'f.m.',
        pm: 'e.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: 'morgon',
        afternoon: 'efterm.',
        evening: "kv\xe4ll",
        night: 'natt'
    },
    wide: {
        am: "f\xf6rmiddag",
        pm: 'eftermiddag',
        midnight: 'midnatt',
        noon: 'middag',
        morning: 'morgon',
        afternoon: 'eftermiddag',
        evening: "kv\xe4ll",
        night: 'natt'
    }
};
var $680a550ce989b71e$var$formattingDayPeriodValues = {
    narrow: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    wide: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morgonen",
        afternoon: "p\xe5 eftermiddagen",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    }
};
function $680a550ce989b71e$var$ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
        case 2:
            return number + ':a';
    }
    return number + ':e';
}
var $680a550ce989b71e$var$localize = {
    ordinalNumber: $680a550ce989b71e$var$ordinalNumber,
    era: (0, $7juaq.default)({
        values: $680a550ce989b71e$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $7juaq.default)({
        values: $680a550ce989b71e$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $7juaq.default)({
        values: $680a550ce989b71e$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $7juaq.default)({
        values: $680a550ce989b71e$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $7juaq.default)({
        values: $680a550ce989b71e$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $680a550ce989b71e$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $680a550ce989b71e$export$2e2bcd8739ae039 = $680a550ce989b71e$var$localize;

});

parcelRegister("evRwj", function(module, exports) {
$parcel$export(module.exports, "default", () => $a90d79eeed323a60$export$2e2bcd8739ae039);

var $bFSku = parcelRequire("bFSku");

var $5hQUT = parcelRequire("5hQUT");
var $a90d79eeed323a60$var$matchOrdinalNumberPattern = /^(\d+)(:a|:e)?/i;
var $a90d79eeed323a60$var$parseOrdinalNumberPattern = /\d+/i;
var $a90d79eeed323a60$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
};
var $a90d79eeed323a60$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^[ev]/i
    ]
};
var $a90d79eeed323a60$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](:a|:e)? kvartalet/i
};
var $a90d79eeed323a60$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $a90d79eeed323a60$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|aug|sep|okt|nov|dec)\.?/i,
    wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
};
var $a90d79eeed323a60$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $a90d79eeed323a60$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sö|må|ti|on|to|fr|lö)/i,
    abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
    wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
};
var $a90d79eeed323a60$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $a90d79eeed323a60$var$matchDayPeriodPatterns = {
    any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
};
var $a90d79eeed323a60$var$parseDayPeriodPatterns = {
    any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgon/i,
        afternoon: /eftermiddag/i,
        evening: /kväll/i,
        night: /natt/i
    }
};
var $a90d79eeed323a60$var$match = {
    ordinalNumber: (0, $bFSku.default)({
        matchPattern: $a90d79eeed323a60$var$matchOrdinalNumberPattern,
        parsePattern: $a90d79eeed323a60$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5hQUT.default)({
        matchPatterns: $a90d79eeed323a60$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a90d79eeed323a60$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5hQUT.default)({
        matchPatterns: $a90d79eeed323a60$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a90d79eeed323a60$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $5hQUT.default)({
        matchPatterns: $a90d79eeed323a60$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a90d79eeed323a60$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5hQUT.default)({
        matchPatterns: $a90d79eeed323a60$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a90d79eeed323a60$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5hQUT.default)({
        matchPatterns: $a90d79eeed323a60$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $a90d79eeed323a60$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $a90d79eeed323a60$export$2e2bcd8739ae039 = $a90d79eeed323a60$var$match;

});


parcelRegister("1Sotl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $15ddd148e96ac621$export$2e2bcd8739ae039);

var $hixxp = parcelRequire("hixxp");

var $bZnAl = parcelRequire("bZnAl");

var $a7l6Z = parcelRequire("a7l6Z");

var $18g9r = parcelRequire("18g9r");

var $jtBp1 = parcelRequire("jtBp1");
/**
 * @type {Locale}
 * @category Locales
 * @summary Turkish locale.
 * @language Turkish
 * @iso-639-2 tur
 * @author Alpcan Aydın [@alpcanaydin]{@link https://github.com/alpcanaydin}
 * @author Berkay Sargın [@berkaey]{@link https://github.com/berkaey}
 * @author Ismail Demirbilek [@dbtek]{@link https://github.com/dbtek}
 * @author İsmail Kayar [@ikayar]{@link https://github.com/ikayar}
 *
 *
 */ var $15ddd148e96ac621$var$locale = {
    code: 'tr',
    formatDistance: (0, $hixxp.default),
    formatLong: (0, $bZnAl.default),
    formatRelative: (0, $a7l6Z.default),
    localize: (0, $18g9r.default),
    match: (0, $jtBp1.default),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
    }
};
var $15ddd148e96ac621$export$2e2bcd8739ae039 = $15ddd148e96ac621$var$locale;

});
parcelRegister("hixxp", function(module, exports) {
$parcel$export(module.exports, "default", () => $c97e220996320151$export$2e2bcd8739ae039);
var $c97e220996320151$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'bir saniyeden az',
        other: '{{count}} saniyeden az'
    },
    xSeconds: {
        one: '1 saniye',
        other: '{{count}} saniye'
    },
    halfAMinute: "yar\u0131m dakika",
    lessThanXMinutes: {
        one: 'bir dakikadan az',
        other: '{{count}} dakikadan az'
    },
    xMinutes: {
        one: '1 dakika',
        other: '{{count}} dakika'
    },
    aboutXHours: {
        one: "yakla\u015F\u0131k 1 saat",
        other: "yakla\u015F\u0131k {{count}} saat"
    },
    xHours: {
        one: '1 saat',
        other: '{{count}} saat'
    },
    xDays: {
        one: "1 g\xfcn",
        other: "{{count}} g\xfcn"
    },
    aboutXWeeks: {
        one: "yakla\u015F\u0131k 1 hafta",
        other: "yakla\u015F\u0131k {{count}} hafta"
    },
    xWeeks: {
        one: '1 hafta',
        other: '{{count}} hafta'
    },
    aboutXMonths: {
        one: "yakla\u015F\u0131k 1 ay",
        other: "yakla\u015F\u0131k {{count}} ay"
    },
    xMonths: {
        one: '1 ay',
        other: '{{count}} ay'
    },
    aboutXYears: {
        one: "yakla\u015F\u0131k 1 y\u0131l",
        other: "yakla\u015F\u0131k {{count}} y\u0131l"
    },
    xYears: {
        one: "1 y\u0131l",
        other: "{{count}} y\u0131l"
    },
    overXYears: {
        one: "1 y\u0131ldan fazla",
        other: "{{count}} y\u0131ldan fazla"
    },
    almostXYears: {
        one: "neredeyse 1 y\u0131l",
        other: "neredeyse {{count}} y\u0131l"
    }
};
function $c97e220996320151$export$2e2bcd8739ae039(token, count, options) {
    options = options || {};
    var result;
    if (typeof $c97e220996320151$var$formatDistanceLocale[token] === 'string') result = $c97e220996320151$var$formatDistanceLocale[token];
    else if (count === 1) result = $c97e220996320151$var$formatDistanceLocale[token].one;
    else result = $c97e220996320151$var$formatDistanceLocale[token].other.replace('{{count}}', count);
    if (options.addSuffix) {
        if (options.comparison > 0) return result + ' sonra';
        else return result + " \xf6nce";
    }
    return result;
}

});

parcelRegister("bZnAl", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ba7afc1ba256eb6$export$2e2bcd8739ae039);

var $8D7sK = parcelRequire("8D7sK");
var $8ba7afc1ba256eb6$var$dateFormats = {
    full: 'd MMMM y EEEE',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd.MM.yyyy'
};
var $8ba7afc1ba256eb6$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $8ba7afc1ba256eb6$var$dateTimeFormats = {
    full: "{{date}} 'saat' {{time}}",
    long: "{{date}} 'saat' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $8ba7afc1ba256eb6$var$formatLong = {
    date: (0, $8D7sK.default)({
        formats: $8ba7afc1ba256eb6$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $8D7sK.default)({
        formats: $8ba7afc1ba256eb6$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $8D7sK.default)({
        formats: $8ba7afc1ba256eb6$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $8ba7afc1ba256eb6$export$2e2bcd8739ae039 = $8ba7afc1ba256eb6$var$formatLong;

});

parcelRegister("a7l6Z", function(module, exports) {
$parcel$export(module.exports, "default", () => $75daef2d0a12622d$export$2e2bcd8739ae039);
var $75daef2d0a12622d$var$formatRelativeLocale = {
    lastWeek: "'ge\xe7en hafta' eeee 'saat' p",
    yesterday: "'d\xfcn saat' p",
    today: "'bug\xfcn saat' p",
    tomorrow: "'yar\u0131n saat' p",
    nextWeek: "eeee 'saat' p",
    other: 'P'
};
function $75daef2d0a12622d$export$2e2bcd8739ae039(token, _date, _baseDate, _options) {
    return $75daef2d0a12622d$var$formatRelativeLocale[token];
}

});

parcelRegister("18g9r", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d3311151dd6c972$export$2e2bcd8739ae039);

var $7juaq = parcelRequire("7juaq");
var $0d3311151dd6c972$var$eraValues = {
    abbreviated: [
        "M\xd6",
        'MS'
    ],
    narrow: [
        "M\xd6",
        'MS'
    ],
    wide: [
        "Milattan \xd6nce",
        'Milattan Sonra'
    ]
};
var $0d3311151dd6c972$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1\xc7",
        "2\xc7",
        "3\xc7",
        "4\xc7"
    ],
    wide: [
        "\u0130lk \xe7eyrek",
        "\u0130kinci \xc7eyrek",
        "\xdc\xe7\xfcnc\xfc \xe7eyrek",
        "Son \xe7eyrek"
    ]
};
var $0d3311151dd6c972$var$monthValues = {
    narrow: [
        'O',
        "\u015E",
        'M',
        'N',
        'M',
        'H',
        'T',
        'A',
        'E',
        'E',
        'K',
        'A'
    ],
    abbreviated: [
        'Oca',
        "\u015Eub",
        'Mar',
        'Nis',
        'May',
        'Haz',
        'Tem',
        "A\u011Fu",
        'Eyl',
        'Eki',
        'Kas',
        'Ara'
    ],
    wide: [
        'Ocak',
        "\u015Eubat",
        'Mart',
        'Nisan',
        "May\u0131s",
        'Haziran',
        'Temmuz',
        "A\u011Fustos",
        "Eyl\xfcl",
        'Ekim',
        "Kas\u0131m",
        "Aral\u0131k"
    ]
};
var $0d3311151dd6c972$var$dayValues = {
    narrow: [
        'P',
        'P',
        'S',
        "\xc7",
        'P',
        'C',
        'C'
    ],
    short: [
        'Pz',
        'Pt',
        'Sa',
        "\xc7a",
        'Pe',
        'Cu',
        'Ct'
    ],
    abbreviated: [
        'Paz',
        'Pts',
        'Sal',
        "\xc7ar",
        'Per',
        'Cum',
        'Cts'
    ],
    wide: [
        'Pazar',
        'Pazartesi',
        "Sal\u0131",
        "\xc7ar\u015Famba",
        "Per\u015Fembe",
        'Cuma',
        'Cumartesi'
    ]
};
var $0d3311151dd6c972$var$dayPeriodValues = {
    narrow: {
        am: "\xf6\xf6",
        pm: "\xf6s",
        midnight: 'gy',
        noon: "\xf6",
        morning: 'sa',
        afternoon: "\xf6s",
        evening: 'ak',
        night: 'ge'
    },
    abbreviated: {
        am: "\xd6\xd6",
        pm: "\xd6S",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Fle",
        morning: 'sabah',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Fam",
        night: 'gece'
    },
    wide: {
        am: "\xd6.\xd6.",
        pm: "\xd6.S.",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Fle",
        morning: 'sabah',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Fam",
        night: 'gece'
    }
};
var $0d3311151dd6c972$var$formattingDayPeriodValues = {
    narrow: {
        am: "\xf6\xf6",
        pm: "\xf6s",
        midnight: 'gy',
        noon: "\xf6",
        morning: 'sa',
        afternoon: "\xf6s",
        evening: 'ak',
        night: 'ge'
    },
    abbreviated: {
        am: "\xd6\xd6",
        pm: "\xd6S",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Flen",
        morning: 'sabahleyin',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Famleyin",
        night: 'geceleyin'
    },
    wide: {
        am: "\xf6.\xf6.",
        pm: "\xf6.s.",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Flen",
        morning: 'sabahleyin',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Famleyin",
        night: 'geceleyin'
    }
};
function $0d3311151dd6c972$var$ordinalNumber(dirtyNumber, _dirtyOptions) {
    var number = Number(dirtyNumber);
    return number + '.';
}
var $0d3311151dd6c972$var$localize = {
    ordinalNumber: $0d3311151dd6c972$var$ordinalNumber,
    era: (0, $7juaq.default)({
        values: $0d3311151dd6c972$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $7juaq.default)({
        values: $0d3311151dd6c972$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $7juaq.default)({
        values: $0d3311151dd6c972$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $7juaq.default)({
        values: $0d3311151dd6c972$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $7juaq.default)({
        values: $0d3311151dd6c972$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $0d3311151dd6c972$var$formattingDayPeriodValues,
        defaulFormattingWidth: 'wide'
    })
};
var $0d3311151dd6c972$export$2e2bcd8739ae039 = $0d3311151dd6c972$var$localize;

});

parcelRegister("jtBp1", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2ddbd1acd2e4195$export$2e2bcd8739ae039);

var $bFSku = parcelRequire("bFSku");

var $5hQUT = parcelRequire("5hQUT");
var $e2ddbd1acd2e4195$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $e2ddbd1acd2e4195$var$parseOrdinalNumberPattern = /\d+/i;
var $e2ddbd1acd2e4195$var$matchEraPatterns = {
    narrow: /^(mö|ms)/i,
    abbreviated: /^(mö|ms)/i,
    wide: /^(milattan önce|milattan sonra)/i
};
var $e2ddbd1acd2e4195$var$parseEraPatterns = {
    any: [
        /(^mö|^milattan önce)/i,
        /(^ms|^milattan sonra)/i
    ]
};
var $e2ddbd1acd2e4195$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]ç/i,
    wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
};
var $e2ddbd1acd2e4195$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    abbreviated: [
        /1ç/i,
        /2ç/i,
        /3ç/i,
        /4ç/i
    ],
    wide: [
        /^(i|İ)lk çeyrek/i,
        /(i|İ)kinci çeyrek/i,
        /üçüncü çeyrek/i,
        /son çeyrek/i
    ]
};
var $e2ddbd1acd2e4195$var$matchMonthPatterns = {
    narrow: /^[oşmnhtaek]/i,
    abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
    wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
};
var $e2ddbd1acd2e4195$var$parseMonthPatterns = {
    narrow: [
        /^o/i,
        /^ş/i,
        /^m/i,
        /^n/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^a/i,
        /^e/i,
        /^e/i,
        /^k/i,
        /^a/i
    ],
    any: [
        /^o/i,
        /^ş/i,
        /^mar/i,
        /^n/i,
        /^may/i,
        /^h/i,
        /^t/i,
        /^ağ/i,
        /^ey/i,
        /^ek/i,
        /^k/i,
        /^ar/i
    ]
};
var $e2ddbd1acd2e4195$var$matchDayPatterns = {
    narrow: /^[psçc]/i,
    short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
    abbreviated: /^(paz|pts|sal|çar|per|cum|cts)/i,
    wide: /^(pazar|pazartesi|salı|çarşamba|perşembe|cuma|cumartesi)/i
};
var $e2ddbd1acd2e4195$var$parseDayPatterns = {
    narrow: [
        /^p/i,
        /^p/i,
        /^s/i,
        /^ç/i,
        /^p/i,
        /^c/i,
        /^c/i
    ],
    any: [
        /^pz/i,
        /^pt/i,
        /^sa/i,
        /^ça/i,
        /^pe/i,
        /^cu/i,
        /^ct/i
    ],
    wide: [
        /^pazar/i,
        /^pazartesi/i,
        /^salı/i,
        /^çarşamba/i,
        /^perşembe/i,
        /^cuma/i,
        /cumartesi/i
    ]
};
var $e2ddbd1acd2e4195$var$matchDayPeriodPatterns = {
    narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
    any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
};
var $e2ddbd1acd2e4195$var$parseDayPeriodPatterns = {
    any: {
        am: /^ö\.?ö\.?/i,
        pm: /^ö\.?s\.?/i,
        midnight: /^(gy|gece yarısı)/i,
        noon: /^öğ/i,
        morning: /^sa/i,
        afternoon: /^öğleden sonra/i,
        evening: /^ak/i,
        night: /^ge/i
    }
};
var $e2ddbd1acd2e4195$var$match = {
    ordinalNumber: (0, $bFSku.default)({
        matchPattern: $e2ddbd1acd2e4195$var$matchOrdinalNumberPattern,
        parsePattern: $e2ddbd1acd2e4195$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5hQUT.default)({
        matchPatterns: $e2ddbd1acd2e4195$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e2ddbd1acd2e4195$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5hQUT.default)({
        matchPatterns: $e2ddbd1acd2e4195$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e2ddbd1acd2e4195$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $5hQUT.default)({
        matchPatterns: $e2ddbd1acd2e4195$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e2ddbd1acd2e4195$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5hQUT.default)({
        matchPatterns: $e2ddbd1acd2e4195$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e2ddbd1acd2e4195$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5hQUT.default)({
        matchPatterns: $e2ddbd1acd2e4195$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $e2ddbd1acd2e4195$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $e2ddbd1acd2e4195$export$2e2bcd8739ae039 = $e2ddbd1acd2e4195$var$match;

});


parcelRegister("iL2gc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $da7e5e9eb5acdc0a$export$2e2bcd8739ae039);

var $dkUgI = parcelRequire("dkUgI");

var $fZ35k = parcelRequire("fZ35k");

var $k13hw = parcelRequire("k13hw");

var $1GVeC = parcelRequire("1GVeC");

var $8tbdL = parcelRequire("8tbdL");
/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Simplified locale.
 * @language Chinese Simplified
 * @iso-639-2 zho
 * @author Changyu Geng [@KingMario]{@link https://github.com/KingMario}
 * @author Song Shuoyun [@fnlctrl]{@link https://github.com/fnlctrl}
 * @author sabrinaM [@sabrinamiao]{@link https://github.com/sabrinamiao}
 * @author Carney Wu [@cubicwork]{@link https://github.com/cubicwork}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 */ var $da7e5e9eb5acdc0a$var$locale = {
    code: 'zh-CN',
    formatDistance: (0, $dkUgI.default),
    formatLong: (0, $fZ35k.default),
    formatRelative: (0, $k13hw.default),
    localize: (0, $1GVeC.default),
    match: (0, $8tbdL.default),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
    }
};
var $da7e5e9eb5acdc0a$export$2e2bcd8739ae039 = $da7e5e9eb5acdc0a$var$locale;

});
parcelRegister("dkUgI", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b58ca6938be69e6$export$2e2bcd8739ae039);
var $9b58ca6938be69e6$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u4E0D\u5230 1 \u79D2",
        other: "\u4E0D\u5230 {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u949F",
    lessThanXMinutes: {
        one: "\u4E0D\u5230 1 \u5206\u949F",
        other: "\u4E0D\u5230 {{count}} \u5206\u949F"
    },
    xMinutes: {
        one: "1 \u5206\u949F",
        other: "{{count}} \u5206\u949F"
    },
    xHours: {
        one: "1 \u5C0F\u65F6",
        other: "{{count}} \u5C0F\u65F6"
    },
    aboutXHours: {
        one: "\u5927\u7EA6 1 \u5C0F\u65F6",
        other: "\u5927\u7EA6 {{count}} \u5C0F\u65F6"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7EA6 1 \u4E2A\u661F\u671F",
        other: "\u5927\u7EA6 {{count}} \u4E2A\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u4E2A\u661F\u671F",
        other: "{{count}} \u4E2A\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7EA6 1 \u4E2A\u6708",
        other: "\u5927\u7EA6 {{count}} \u4E2A\u6708"
    },
    xMonths: {
        one: "1 \u4E2A\u6708",
        other: "{{count}} \u4E2A\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7EA6 1 \u5E74",
        other: "\u5927\u7EA6 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u8FC7 1 \u5E74",
        other: "\u8D85\u8FC7 {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C06\u8FD1 1 \u5E74",
        other: "\u5C06\u8FD1 {{count}} \u5E74"
    }
};
function $9b58ca6938be69e6$export$2e2bcd8739ae039(token, count, options) {
    options = options || {};
    var result;
    if (typeof $9b58ca6938be69e6$var$formatDistanceLocale[token] === 'string') result = $9b58ca6938be69e6$var$formatDistanceLocale[token];
    else if (count === 1) result = $9b58ca6938be69e6$var$formatDistanceLocale[token].one;
    else result = $9b58ca6938be69e6$var$formatDistanceLocale[token].other.replace('{{count}}', count);
    if (options.addSuffix) {
        if (options.comparison > 0) return result + "\u5185";
        else return result + "\u524D";
    }
    return result;
}

});

parcelRegister("fZ35k", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba2ef2216a72724b$export$2e2bcd8739ae039);

var $8D7sK = parcelRequire("8D7sK");
var $ba2ef2216a72724b$var$dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: 'yyyy-MM-dd',
    short: 'yy-MM-dd'
};
var $ba2ef2216a72724b$var$timeFormats = {
    full: 'zzzz a h:mm:ss',
    long: 'z a h:mm:ss',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var $ba2ef2216a72724b$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $ba2ef2216a72724b$var$formatLong = {
    date: (0, $8D7sK.default)({
        formats: $ba2ef2216a72724b$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $8D7sK.default)({
        formats: $ba2ef2216a72724b$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $8D7sK.default)({
        formats: $ba2ef2216a72724b$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $ba2ef2216a72724b$export$2e2bcd8739ae039 = $ba2ef2216a72724b$var$formatLong;

});

parcelRegister("k13hw", function(module, exports) {
$parcel$export(module.exports, "default", () => $e926725379420e6a$export$2e2bcd8739ae039);

var $2q0eX = parcelRequire("2q0eX");
function $e926725379420e6a$var$checkWeek(_date, _baseDate, _options, baseFormat) {
    if ((0, $2q0eX.default)(_date, _baseDate, _options)) return baseFormat; // in same week
    else if (_date.getTime() > _baseDate.getTime()) return "'\u4E0B\u4E2A'" + baseFormat; // in next week
    return "'\u4E0A\u4E2A'" + baseFormat; // in last week
}
var $e926725379420e6a$var$formatRelativeLocale = {
    lastWeek: $e926725379420e6a$var$checkWeek,
    // days before yesterday, maybe in this week or last week
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: $e926725379420e6a$var$checkWeek,
    // days after tomorrow, maybe in this week or next week
    other: 'PP p'
};
function $e926725379420e6a$export$2e2bcd8739ae039(token, _date, _baseDate, _options) {
    var format = $e926725379420e6a$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(_date, _baseDate, _options, 'eeee p');
    return format;
}

});

parcelRegister("1GVeC", function(module, exports) {
$parcel$export(module.exports, "default", () => $13b61c4f7c0de2d1$export$2e2bcd8739ae039);

var $7juaq = parcelRequire("7juaq");
var $13b61c4f7c0de2d1$var$eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
var $13b61c4f7c0de2d1$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u7B2C\u4E00\u523B",
        "\u7B2C\u4E8C\u523B",
        "\u7B2C\u4E09\u523B",
        "\u7B2C\u56DB\u523B"
    ],
    wide: [
        "\u7B2C\u4E00\u523B\u949F",
        "\u7B2C\u4E8C\u523B\u949F",
        "\u7B2C\u4E09\u523B\u949F",
        "\u7B2C\u56DB\u523B\u949F"
    ]
};
var $13b61c4f7c0de2d1$var$monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
var $13b61c4f7c0de2d1$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u5468\u65E5",
        "\u5468\u4E00",
        "\u5468\u4E8C",
        "\u5468\u4E09",
        "\u5468\u56DB",
        "\u5468\u4E94",
        "\u5468\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
var $13b61c4f7c0de2d1$var$dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    }
};
var $13b61c4f7c0de2d1$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    }
};
function $13b61c4f7c0de2d1$var$ordinalNumber(dirtyNumber, dirtyOptions) {
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`:
    //
    //   var options = dirtyOptions || {}
    //   var unit = String(options.unit)
    //
    // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'
    var number = Number(dirtyNumber);
    var options = dirtyOptions || {};
    var unit = String(options.unit);
    switch(unit){
        case 'date':
            return number.toString() + "\u65E5";
        case 'hour':
            return number.toString() + "\u65F6";
        case 'minute':
            return number.toString() + "\u5206";
        case 'second':
            return number.toString() + "\u79D2";
        default:
            return "\u7B2C " + number.toString();
    }
}
var $13b61c4f7c0de2d1$var$localize = {
    ordinalNumber: $13b61c4f7c0de2d1$var$ordinalNumber,
    era: (0, $7juaq.default)({
        values: $13b61c4f7c0de2d1$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $7juaq.default)({
        values: $13b61c4f7c0de2d1$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $7juaq.default)({
        values: $13b61c4f7c0de2d1$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $7juaq.default)({
        values: $13b61c4f7c0de2d1$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $7juaq.default)({
        values: $13b61c4f7c0de2d1$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $13b61c4f7c0de2d1$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $13b61c4f7c0de2d1$export$2e2bcd8739ae039 = $13b61c4f7c0de2d1$var$localize;

});

parcelRegister("8tbdL", function(module, exports) {
$parcel$export(module.exports, "default", () => $62a9bc6bb4c58063$export$2e2bcd8739ae039);

var $bFSku = parcelRequire("bFSku");

var $5hQUT = parcelRequire("5hQUT");
var $62a9bc6bb4c58063$var$matchOrdinalNumberPattern = /^(第\s*)?\d+(日|时|分|秒)?/i;
var $62a9bc6bb4c58063$var$parseOrdinalNumberPattern = /\d+/i;
var $62a9bc6bb4c58063$var$matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
var $62a9bc6bb4c58063$var$parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
var $62a9bc6bb4c58063$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]刻/i,
    wide: /^第[一二三四]刻钟/i
};
var $62a9bc6bb4c58063$var$parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
var $62a9bc6bb4c58063$var$matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var $62a9bc6bb4c58063$var$parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
var $62a9bc6bb4c58063$var$matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^周[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
var $62a9bc6bb4c58063$var$parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
var $62a9bc6bb4c58063$var$matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨|)/i
};
var $62a9bc6bb4c58063$var$parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
var $62a9bc6bb4c58063$var$match = {
    ordinalNumber: (0, $bFSku.default)({
        matchPattern: $62a9bc6bb4c58063$var$matchOrdinalNumberPattern,
        parsePattern: $62a9bc6bb4c58063$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5hQUT.default)({
        matchPatterns: $62a9bc6bb4c58063$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $62a9bc6bb4c58063$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5hQUT.default)({
        matchPatterns: $62a9bc6bb4c58063$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $62a9bc6bb4c58063$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $5hQUT.default)({
        matchPatterns: $62a9bc6bb4c58063$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $62a9bc6bb4c58063$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5hQUT.default)({
        matchPatterns: $62a9bc6bb4c58063$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $62a9bc6bb4c58063$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5hQUT.default)({
        matchPatterns: $62a9bc6bb4c58063$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $62a9bc6bb4c58063$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $62a9bc6bb4c58063$export$2e2bcd8739ae039 = $62a9bc6bb4c58063$var$match;

});


parcelRegister("8ZUjr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $68cfb3be7c97cc16$export$2e2bcd8739ae039);

var $dZG5E = parcelRequire("dZG5E");

var $g03UE = parcelRequire("g03UE");

var $jr7nA = parcelRequire("jr7nA");

var $5qxiW = parcelRequire("5qxiW");

var $RvSGR = parcelRequire("RvSGR");
/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Traditional locale.
 * @language Chinese Traditional
 * @iso-639-2 zho
 * @author tonypai [@tpai]{@link https://github.com/tpai}
 * @author Jack Hsu [@jackhsu978]{@link https://github.com/jackhsu978}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 */ var $68cfb3be7c97cc16$var$locale = {
    code: 'zh-TW',
    formatDistance: (0, $dZG5E.default),
    formatLong: (0, $g03UE.default),
    formatRelative: (0, $jr7nA.default),
    localize: (0, $5qxiW.default),
    match: (0, $RvSGR.default),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
    }
};
var $68cfb3be7c97cc16$export$2e2bcd8739ae039 = $68cfb3be7c97cc16$var$locale;

});
parcelRegister("dZG5E", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3019f16e9605286$export$2e2bcd8739ae039);
var $a3019f16e9605286$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u5C11\u65BC 1 \u79D2",
        other: "\u5C11\u65BC {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u9418",
    lessThanXMinutes: {
        one: "\u5C11\u65BC 1 \u5206\u9418",
        other: "\u5C11\u65BC {{count}} \u5206\u9418"
    },
    xMinutes: {
        one: "1 \u5206\u9418",
        other: "{{count}} \u5206\u9418"
    },
    xHours: {
        one: "1 \u5C0F\u6642",
        other: "{{count}} \u5C0F\u6642"
    },
    aboutXHours: {
        one: "\u5927\u7D04 1 \u5C0F\u6642",
        other: "\u5927\u7D04 {{count}} \u5C0F\u6642"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7D04 1 \u500B\u661F\u671F",
        other: "\u5927\u7D04 {{count}} \u500B\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u500B\u661F\u671F",
        other: "{{count}} \u500B\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7D04 1 \u500B\u6708",
        other: "\u5927\u7D04 {{count}} \u500B\u6708"
    },
    xMonths: {
        one: "1 \u500B\u6708",
        other: "{{count}} \u500B\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7D04 1 \u5E74",
        other: "\u5927\u7D04 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u904E 1 \u5E74",
        other: "\u8D85\u904E {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C07\u8FD1 1 \u5E74",
        other: "\u5C07\u8FD1 {{count}} \u5E74"
    }
};
function $a3019f16e9605286$export$2e2bcd8739ae039(token, count, options) {
    options = options || {};
    var result;
    if (typeof $a3019f16e9605286$var$formatDistanceLocale[token] === 'string') result = $a3019f16e9605286$var$formatDistanceLocale[token];
    else if (count === 1) result = $a3019f16e9605286$var$formatDistanceLocale[token].one;
    else result = $a3019f16e9605286$var$formatDistanceLocale[token].other.replace('{{count}}', count);
    if (options.addSuffix) {
        if (options.comparison > 0) return result + "\u5167";
        else return result + "\u524D";
    }
    return result;
}

});

parcelRegister("g03UE", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba5fae6f17360404$export$2e2bcd8739ae039);

var $8D7sK = parcelRequire("8D7sK");
var $ba5fae6f17360404$var$dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: 'yyyy-MM-dd',
    short: 'yy-MM-dd'
};
var $ba5fae6f17360404$var$timeFormats = {
    full: 'zzzz a h:mm:ss',
    long: 'z a h:mm:ss',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var $ba5fae6f17360404$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $ba5fae6f17360404$var$formatLong = {
    date: (0, $8D7sK.default)({
        formats: $ba5fae6f17360404$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $8D7sK.default)({
        formats: $ba5fae6f17360404$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $8D7sK.default)({
        formats: $ba5fae6f17360404$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $ba5fae6f17360404$export$2e2bcd8739ae039 = $ba5fae6f17360404$var$formatLong;

});

parcelRegister("jr7nA", function(module, exports) {
$parcel$export(module.exports, "default", () => $e266435c4dbfb864$export$2e2bcd8739ae039);
var $e266435c4dbfb864$var$formatRelativeLocale = {
    lastWeek: "'\u4E0A\u500B'eeee p",
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: "'\u4E0B\u500B'eeee p",
    other: 'P'
};
function $e266435c4dbfb864$export$2e2bcd8739ae039(token, _date, _baseDate, _options) {
    return $e266435c4dbfb864$var$formatRelativeLocale[token];
}

});

parcelRegister("5qxiW", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f39370d1aa4f875$export$2e2bcd8739ae039);

var $7juaq = parcelRequire("7juaq");
var $3f39370d1aa4f875$var$eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
var $3f39370d1aa4f875$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u7B2C\u4E00\u523B",
        "\u7B2C\u4E8C\u523B",
        "\u7B2C\u4E09\u523B",
        "\u7B2C\u56DB\u523B"
    ],
    wide: [
        "\u7B2C\u4E00\u523B\u9418",
        "\u7B2C\u4E8C\u523B\u9418",
        "\u7B2C\u4E09\u523B\u9418",
        "\u7B2C\u56DB\u523B\u9418"
    ]
};
var $3f39370d1aa4f875$var$monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
var $3f39370d1aa4f875$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u9031\u65E5",
        "\u9031\u4E00",
        "\u9031\u4E8C",
        "\u9031\u4E09",
        "\u9031\u56DB",
        "\u9031\u4E94",
        "\u9031\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
var $3f39370d1aa4f875$var$dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    }
};
var $3f39370d1aa4f875$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    }
};
function $3f39370d1aa4f875$var$ordinalNumber(dirtyNumber, dirtyOptions) {
    var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`:
    //
    //   var options = dirtyOptions || {}
    //   var unit = String(options.unit)
    //
    // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'
    var options = dirtyOptions || {};
    var unit = String(options.unit);
    switch(unit){
        case 'date':
            return number.toString() + "\u65E5";
        case 'hour':
            return number.toString() + "\u6642";
        case 'minute':
            return number.toString() + "\u5206";
        case 'second':
            return number.toString() + "\u79D2";
        default:
            return "\u7B2C " + number.toString();
    }
}
var $3f39370d1aa4f875$var$localize = {
    ordinalNumber: $3f39370d1aa4f875$var$ordinalNumber,
    era: (0, $7juaq.default)({
        values: $3f39370d1aa4f875$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $7juaq.default)({
        values: $3f39370d1aa4f875$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $7juaq.default)({
        values: $3f39370d1aa4f875$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $7juaq.default)({
        values: $3f39370d1aa4f875$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $7juaq.default)({
        values: $3f39370d1aa4f875$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $3f39370d1aa4f875$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $3f39370d1aa4f875$export$2e2bcd8739ae039 = $3f39370d1aa4f875$var$localize;

});

parcelRegister("RvSGR", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a0dae4654213af8$export$2e2bcd8739ae039);

var $bFSku = parcelRequire("bFSku");

var $5hQUT = parcelRequire("5hQUT");
var $0a0dae4654213af8$var$matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
var $0a0dae4654213af8$var$parseOrdinalNumberPattern = /\d+/i;
var $0a0dae4654213af8$var$matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
var $0a0dae4654213af8$var$parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
var $0a0dae4654213af8$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]刻/i,
    wide: /^第[一二三四]刻鐘/i
};
var $0a0dae4654213af8$var$parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
var $0a0dae4654213af8$var$matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var $0a0dae4654213af8$var$parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
var $0a0dae4654213af8$var$matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^週[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
var $0a0dae4654213af8$var$parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
var $0a0dae4654213af8$var$matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
};
var $0a0dae4654213af8$var$parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
var $0a0dae4654213af8$var$match = {
    ordinalNumber: (0, $bFSku.default)({
        matchPattern: $0a0dae4654213af8$var$matchOrdinalNumberPattern,
        parsePattern: $0a0dae4654213af8$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5hQUT.default)({
        matchPatterns: $0a0dae4654213af8$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0a0dae4654213af8$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5hQUT.default)({
        matchPatterns: $0a0dae4654213af8$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0a0dae4654213af8$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $5hQUT.default)({
        matchPatterns: $0a0dae4654213af8$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0a0dae4654213af8$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5hQUT.default)({
        matchPatterns: $0a0dae4654213af8$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0a0dae4654213af8$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5hQUT.default)({
        matchPatterns: $0a0dae4654213af8$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $0a0dae4654213af8$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $0a0dae4654213af8$export$2e2bcd8739ae039 = $0a0dae4654213af8$var$match;

});


parcelRegister("jPROM", function(module, exports) {
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $e70c86dbea1171fb$var$isNil(value) {
    return value == null;
}
module.exports = $e70c86dbea1171fb$var$isNil;

});

parcelRegister("109Mp", function(module, exports) {
$parcel$export(module.exports, "default", () => $0bad6097ad4790ca$export$2e2bcd8739ae039);

var $9HJl3 = parcelRequire("9HJl3");

var $44r5s = parcelRequire("44r5s");

var $7tZWU = parcelRequire("7tZWU");

var $dZhfT = parcelRequire("dZhfT");

var $jwO6P = parcelRequire("jwO6P");
/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Algerian Arabic).
 * @language Algerian Arabic
 * @iso-639-2 ara
 * @author Badreddine Boumaza [@badre429]{@link https://github.com/badre429}
 * @author Ahmed ElShahat [@elshahat]{@link https://github.com/elshahat}
 */ var $0bad6097ad4790ca$var$locale = {
    code: 'ar-DZ',
    formatDistance: (0, $9HJl3.default),
    formatLong: (0, $44r5s.default),
    formatRelative: (0, $7tZWU.default),
    localize: (0, $dZhfT.default),
    match: (0, $jwO6P.default),
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
var $0bad6097ad4790ca$export$2e2bcd8739ae039 = $0bad6097ad4790ca$var$locale;

});
parcelRegister("9HJl3", function(module, exports) {
$parcel$export(module.exports, "default", () => $710b4c8081982ccb$export$2e2bcd8739ae039);
var $710b4c8081982ccb$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
function $710b4c8081982ccb$export$2e2bcd8739ae039(token, count, options) {
    options = options || {};
    var result;
    if (typeof $710b4c8081982ccb$var$formatDistanceLocale[token] === 'string') result = $710b4c8081982ccb$var$formatDistanceLocale[token];
    else if (count === 1) result = $710b4c8081982ccb$var$formatDistanceLocale[token].one;
    else if (count === 2) result = $710b4c8081982ccb$var$formatDistanceLocale[token].two;
    else if (count <= 10) result = $710b4c8081982ccb$var$formatDistanceLocale[token].threeToTen.replace('{{count}}', count);
    else result = $710b4c8081982ccb$var$formatDistanceLocale[token].other.replace('{{count}}', count);
    if (options.addSuffix) {
        if (options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
}

});

parcelRegister("44r5s", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f6c8c1002faacc5$export$2e2bcd8739ae039);

var $8D7sK = parcelRequire("8D7sK");
var $2f6c8c1002faacc5$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $2f6c8c1002faacc5$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $2f6c8c1002faacc5$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $2f6c8c1002faacc5$var$formatLong = {
    date: (0, $8D7sK.default)({
        formats: $2f6c8c1002faacc5$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $8D7sK.default)({
        formats: $2f6c8c1002faacc5$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $8D7sK.default)({
        formats: $2f6c8c1002faacc5$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $2f6c8c1002faacc5$export$2e2bcd8739ae039 = $2f6c8c1002faacc5$var$formatLong;

});

parcelRegister("7tZWU", function(module, exports) {
$parcel$export(module.exports, "default", () => $572b4ba5362e5c0d$export$2e2bcd8739ae039);
var $572b4ba5362e5c0d$var$formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: 'P'
};
function $572b4ba5362e5c0d$export$2e2bcd8739ae039(token, _date, _baseDate, _options) {
    return $572b4ba5362e5c0d$var$formatRelativeLocale[token];
}

});

parcelRegister("dZhfT", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2ee5b719add76e4$export$2e2bcd8739ae039);

var $7juaq = parcelRequire("7juaq");
var $a2ee5b719add76e4$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var $a2ee5b719add76e4$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var $a2ee5b719add76e4$var$monthValues = {
    narrow: [
        "\u062C",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u062C",
        "\u062C",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u062C\u0627\u0646\u0640",
        "\u0641\u064A\u0641\u0640",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0640",
        "\u062C\u0648\u0627\u0646\u0640",
        "\u062C\u0648\u064A\u0640",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var $a2ee5b719add76e4$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var $a2ee5b719add76e4$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var $a2ee5b719add76e4$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
function $a2ee5b719add76e4$var$ordinalNumber(dirtyNumber) {
    return String(dirtyNumber);
}
var $a2ee5b719add76e4$var$localize = {
    ordinalNumber: $a2ee5b719add76e4$var$ordinalNumber,
    era: (0, $7juaq.default)({
        values: $a2ee5b719add76e4$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $7juaq.default)({
        values: $a2ee5b719add76e4$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $7juaq.default)({
        values: $a2ee5b719add76e4$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $7juaq.default)({
        values: $a2ee5b719add76e4$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $7juaq.default)({
        values: $a2ee5b719add76e4$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $a2ee5b719add76e4$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $a2ee5b719add76e4$export$2e2bcd8739ae039 = $a2ee5b719add76e4$var$localize;

});

parcelRegister("jwO6P", function(module, exports) {
$parcel$export(module.exports, "default", () => $e377e01d2e311f62$export$2e2bcd8739ae039);

var $bFSku = parcelRequire("bFSku");

var $5hQUT = parcelRequire("5hQUT");
var $e377e01d2e311f62$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $e377e01d2e311f62$var$parseOrdinalNumberPattern = /\d+/i;
var $e377e01d2e311f62$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var $e377e01d2e311f62$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var $e377e01d2e311f62$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
var $e377e01d2e311f62$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $e377e01d2e311f62$var$matchMonthPatterns = {
    narrow: /^[جفمأسند]/i,
    abbreviated: /^(جان|فيف|مار|أفر|ماي|جوا|جوي|أوت|سبت|أكت|نوف|ديس)/i,
    wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/i
};
var $e377e01d2e311f62$var$parseMonthPatterns = {
    narrow: [
        /^ج/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ج/i,
        /^ج/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^جان/i,
        /^فيف/i,
        /^مار/i,
        /^أفر/i,
        /^ماي/i,
        /^جوا/i,
        /^جوي/i,
        /^أوت/i,
        /^سبت/i,
        /^أكت/i,
        /^نوف/i,
        /^ديس/i
    ]
};
var $e377e01d2e311f62$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var $e377e01d2e311f62$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var $e377e01d2e311f62$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $e377e01d2e311f62$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $e377e01d2e311f62$var$match = {
    ordinalNumber: (0, $bFSku.default)({
        matchPattern: $e377e01d2e311f62$var$matchOrdinalNumberPattern,
        parsePattern: $e377e01d2e311f62$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5hQUT.default)({
        matchPatterns: $e377e01d2e311f62$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e377e01d2e311f62$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5hQUT.default)({
        matchPatterns: $e377e01d2e311f62$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e377e01d2e311f62$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $5hQUT.default)({
        matchPatterns: $e377e01d2e311f62$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e377e01d2e311f62$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5hQUT.default)({
        matchPatterns: $e377e01d2e311f62$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e377e01d2e311f62$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5hQUT.default)({
        matchPatterns: $e377e01d2e311f62$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $e377e01d2e311f62$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $e377e01d2e311f62$export$2e2bcd8739ae039 = $e377e01d2e311f62$var$match;

});


parcelRegister("01taM", function(module, exports) {
$parcel$export(module.exports, "default", () => $0046b943680dbb3d$export$2e2bcd8739ae039);

var $2C1qh = parcelRequire("2C1qh");

var $kl57T = parcelRequire("kl57T");

var $B1LtR = parcelRequire("B1LtR");

var $9NavE = parcelRequire("9NavE");

var $7NLAv = parcelRequire("7NLAv");
/**
 * @type {Locale}
 * @category Locales
 * @summary Estonian locale.
 * @language Estonian
 * @iso-639-2 est
 * @author Priit Hansen [@HansenPriit]{@link https://github.com/priithansen}
 */ var $0046b943680dbb3d$var$locale = {
    code: 'et',
    formatDistance: (0, $2C1qh.default),
    formatLong: (0, $kl57T.default),
    formatRelative: (0, $B1LtR.default),
    localize: (0, $9NavE.default),
    match: (0, $7NLAv.default),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
    }
};
var $0046b943680dbb3d$export$2e2bcd8739ae039 = $0046b943680dbb3d$var$locale;

});
parcelRegister("2C1qh", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e703bf3c0e07552$export$2e2bcd8739ae039);
var $1e703bf3c0e07552$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "v\xe4hem kui \xfcks sekund",
            other: "v\xe4hem kui {{count}} sekundit"
        },
        withPreposition: {
            one: "v\xe4hem kui \xfche sekundi",
            other: "v\xe4hem kui {{count}} sekundi"
        }
    },
    xSeconds: {
        standalone: {
            one: "\xfcks sekund",
            other: '{{count}} sekundit'
        },
        withPreposition: {
            one: "\xfche sekundi",
            other: '{{count}} sekundi'
        }
    },
    halfAMinute: {
        standalone: 'pool minutit',
        withPreposition: 'poole minuti'
    },
    lessThanXMinutes: {
        standalone: {
            one: "v\xe4hem kui \xfcks minut",
            other: "v\xe4hem kui {{count}} minutit"
        },
        withPreposition: {
            one: "v\xe4hem kui \xfche minuti",
            other: "v\xe4hem kui {{count}} minuti"
        }
    },
    xMinutes: {
        standalone: {
            one: "\xfcks minut",
            other: '{{count}} minutit'
        },
        withPreposition: {
            one: "\xfche minuti",
            other: '{{count}} minuti'
        }
    },
    aboutXHours: {
        standalone: {
            one: "umbes \xfcks tund",
            other: 'umbes {{count}} tundi'
        },
        withPreposition: {
            one: "umbes \xfche tunni",
            other: 'umbes {{count}} tunni'
        }
    },
    xHours: {
        standalone: {
            one: "\xfcks tund",
            other: '{{count}} tundi'
        },
        withPreposition: {
            one: "\xfche tunni",
            other: '{{count}} tunni'
        }
    },
    xDays: {
        standalone: {
            one: "\xfcks p\xe4ev",
            other: "{{count}} p\xe4eva"
        },
        withPreposition: {
            one: "\xfche p\xe4eva",
            other: "{{count}} p\xe4eva"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "umbes \xfcks n\xe4dal",
            other: "umbes {{count}} n\xe4dalat"
        },
        withPreposition: {
            one: "umbes \xfche n\xe4dala",
            other: "umbes {{count}} n\xe4dala"
        }
    },
    xWeeks: {
        standalone: {
            one: "\xfcks n\xe4dal",
            other: "{{count}} n\xe4dalat"
        },
        withPreposition: {
            one: "\xfche n\xe4dala",
            other: "{{count}} n\xe4dala"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "umbes \xfcks kuu",
            other: 'umbes {{count}} kuud'
        },
        withPreposition: {
            one: "umbes \xfche kuu",
            other: 'umbes {{count}} kuu'
        }
    },
    xMonths: {
        standalone: {
            one: "\xfcks kuu",
            other: '{{count}} kuud'
        },
        withPreposition: {
            one: "\xfche kuu",
            other: '{{count}} kuu'
        }
    },
    aboutXYears: {
        standalone: {
            one: "umbes \xfcks aasta",
            other: 'umbes {{count}} aastat'
        },
        withPreposition: {
            one: "umbes \xfche aasta",
            other: 'umbes {{count}} aasta'
        }
    },
    xYears: {
        standalone: {
            one: "\xfcks aasta",
            other: '{{count}} aastat'
        },
        withPreposition: {
            one: "\xfche aasta",
            other: '{{count}} aasta'
        }
    },
    overXYears: {
        standalone: {
            one: "rohkem kui \xfcks aasta",
            other: 'rohkem kui {{count}} aastat'
        },
        withPreposition: {
            one: "rohkem kui \xfche aasta",
            other: 'rohkem kui {{count}} aasta'
        }
    },
    almostXYears: {
        standalone: {
            one: "peaaegu \xfcks aasta",
            other: 'peaaegu {{count}} aastat'
        },
        withPreposition: {
            one: "peaaegu \xfche aasta",
            other: 'peaaegu {{count}} aasta'
        }
    }
};
function $1e703bf3c0e07552$export$2e2bcd8739ae039(token, count, options) {
    options = options || {};
    var usageGroup = options.addSuffix ? $1e703bf3c0e07552$var$formatDistanceLocale[token].withPreposition : $1e703bf3c0e07552$var$formatDistanceLocale[token].standalone;
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else result = usageGroup.other.replace('{{count}}', count);
    if (options.addSuffix) {
        if (options.comparison > 0) return result + " p\xe4rast";
        else return result + ' eest';
    }
    return result;
}

});

parcelRegister("kl57T", function(module, exports) {
$parcel$export(module.exports, "default", () => $ece9bec84fc7acaf$export$2e2bcd8739ae039);

var $8D7sK = parcelRequire("8D7sK");
var $ece9bec84fc7acaf$var$dateFormats = {
    full: 'eeee, d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd.MM.y'
};
var $ece9bec84fc7acaf$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $ece9bec84fc7acaf$var$dateTimeFormats = {
    full: "{{date}} 'kell' {{time}}",
    long: "{{date}} 'kell' {{time}}",
    medium: '{{date}}. {{time}}',
    short: '{{date}}. {{time}}'
};
var $ece9bec84fc7acaf$var$formatLong = {
    date: (0, $8D7sK.default)({
        formats: $ece9bec84fc7acaf$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $8D7sK.default)({
        formats: $ece9bec84fc7acaf$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $8D7sK.default)({
        formats: $ece9bec84fc7acaf$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $ece9bec84fc7acaf$export$2e2bcd8739ae039 = $ece9bec84fc7acaf$var$formatLong;

});

parcelRegister("B1LtR", function(module, exports) {
$parcel$export(module.exports, "default", () => $06f4d3459ad0cfe5$export$2e2bcd8739ae039);
var $06f4d3459ad0cfe5$var$formatRelativeLocale = {
    lastWeek: "'eelmine' eeee 'kell' p",
    yesterday: "'eile kell' p",
    today: "'t\xe4na kell' p",
    tomorrow: "'homme kell' p",
    nextWeek: "'j\xe4rgmine' eeee 'kell' p",
    other: 'P'
};
function $06f4d3459ad0cfe5$export$2e2bcd8739ae039(token, _date, _baseDate, _options) {
    return $06f4d3459ad0cfe5$var$formatRelativeLocale[token];
}

});

parcelRegister("9NavE", function(module, exports) {
$parcel$export(module.exports, "default", () => $7210d79af0648065$export$2e2bcd8739ae039);

var $7juaq = parcelRequire("7juaq");
var $7210d79af0648065$var$eraValues = {
    narrow: [
        'e.m.a',
        'm.a.j'
    ],
    abbreviated: [
        'e.m.a',
        'm.a.j'
    ],
    wide: [
        'enne meie ajaarvamist',
        "meie ajaarvamise j\xe4rgi"
    ]
};
var $7210d79af0648065$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $7210d79af0648065$var$monthValues = {
    narrow: [
        'J',
        'V',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jaan',
        'veebr',
        "m\xe4rts",
        'apr',
        'mai',
        'juuni',
        'juuli',
        'aug',
        'sept',
        'okt',
        'nov',
        'dets'
    ],
    wide: [
        'jaanuar',
        'veebruar',
        "m\xe4rts",
        'aprill',
        'mai',
        'juuni',
        'juuli',
        'august',
        'september',
        'oktoober',
        'november',
        'detsember'
    ]
};
var $7210d79af0648065$var$dayValues = {
    narrow: [
        'P',
        'E',
        'T',
        'K',
        'N',
        'R',
        'L'
    ],
    short: [
        'P',
        'E',
        'T',
        'K',
        'N',
        'R',
        'L'
    ],
    abbreviated: [
        "p\xfchap.",
        'esmasp.',
        'teisip.',
        'kolmap.',
        'neljap.',
        'reede.',
        'laup.'
    ],
    wide: [
        "p\xfchap\xe4ev",
        "esmasp\xe4ev",
        "teisip\xe4ev",
        "kolmap\xe4ev",
        "neljap\xe4ev",
        'reede',
        "laup\xe4ev"
    ]
};
var $7210d79af0648065$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: 'hommik',
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: 'hommik',
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: 'hommik',
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    }
};
var $7210d79af0648065$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: 'hommikul',
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: 'hommikul',
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: 'hommikul',
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    }
};
function $7210d79af0648065$var$ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + '.';
}
var $7210d79af0648065$var$localize = {
    ordinalNumber: $7210d79af0648065$var$ordinalNumber,
    era: (0, $7juaq.default)({
        values: $7210d79af0648065$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $7juaq.default)({
        values: $7210d79af0648065$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $7juaq.default)({
        values: $7210d79af0648065$var$monthValues,
        formattingValues: $7210d79af0648065$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $7juaq.default)({
        values: $7210d79af0648065$var$dayValues,
        formattingValues: $7210d79af0648065$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $7juaq.default)({
        values: $7210d79af0648065$var$dayPeriodValues,
        formattingValues: $7210d79af0648065$var$formattingDayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $7210d79af0648065$export$2e2bcd8739ae039 = $7210d79af0648065$var$localize;

});

parcelRegister("7NLAv", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ae205f50346ea4f$export$2e2bcd8739ae039);

var $bFSku = parcelRequire("bFSku");

var $5hQUT = parcelRequire("5hQUT");
var $5ae205f50346ea4f$var$matchOrdinalNumberPattern = /^\d+\./i;
var $5ae205f50346ea4f$var$parseOrdinalNumberPattern = /\d+/i;
var $5ae205f50346ea4f$var$matchEraPatterns = {
    narrow: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
    abbreviated: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
    wide: /^(enne meie ajaarvamist|meie ajaarvamise järgi|enne Kristust|pärast Kristust)/i
};
var $5ae205f50346ea4f$var$parseEraPatterns = {
    any: [
        /^e/i,
        /^(m|p)/i
    ]
};
var $5ae205f50346ea4f$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var $5ae205f50346ea4f$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $5ae205f50346ea4f$var$matchMonthPatterns = {
    narrow: /^[jvmasond]/i,
    abbreviated: /^('jaan|veebr|märts|apr|mai|juuni|juuli|aug|sept|okt|nov|dets')/i,
    wide: /^('jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember')/i
};
var $5ae205f50346ea4f$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^v/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^v/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $5ae205f50346ea4f$var$matchDayPatterns = {
    narrow: /^[petknrl]/i,
    short: /^[petknrl]/i,
    abbreviated: /^(püh?|esm?|tei?|kolm?|nel?|ree?|laup?)\.?/i,
    wide: /^('pühapäev|esmaspäev|teisipäev|kolmapäev|neljapäev|reede|laupäev')/i
};
var $5ae205f50346ea4f$var$parseDayPatterns = {
    any: [
        /^p/i,
        /^e/i,
        /^t/i,
        /^k/i,
        /^n/i,
        /^r/i,
        /^l/i
    ]
};
var $5ae205f50346ea4f$var$matchDayPeriodPatterns = {
    any: /^(am|pm|kesköö|keskpäev|hommik|pärastlõuna|õhtu|öö)/i
};
var $5ae205f50346ea4f$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^keskö/i,
        noon: /^keskp/i,
        morning: /hommik/i,
        afternoon: /pärastlõuna/i,
        evening: /õhtu/i,
        night: /öö/i
    }
};
var $5ae205f50346ea4f$var$match = {
    ordinalNumber: (0, $bFSku.default)({
        matchPattern: $5ae205f50346ea4f$var$matchOrdinalNumberPattern,
        parsePattern: $5ae205f50346ea4f$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5hQUT.default)({
        matchPatterns: $5ae205f50346ea4f$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5ae205f50346ea4f$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5hQUT.default)({
        matchPatterns: $5ae205f50346ea4f$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5ae205f50346ea4f$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $5hQUT.default)({
        matchPatterns: $5ae205f50346ea4f$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5ae205f50346ea4f$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5hQUT.default)({
        matchPatterns: $5ae205f50346ea4f$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5ae205f50346ea4f$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5hQUT.default)({
        matchPatterns: $5ae205f50346ea4f$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $5ae205f50346ea4f$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $5ae205f50346ea4f$export$2e2bcd8739ae039 = $5ae205f50346ea4f$var$match;

});


parcelRegister("6e6Ha", function(module, exports) {
$parcel$export(module.exports, "default", () => $012b8101b2352da8$export$2e2bcd8739ae039);

var $8o690 = parcelRequire("8o690");

var $4p9js = parcelRequire("4p9js");

var $cWU9K = parcelRequire("cWU9K");

var $l9Mt8 = parcelRequire("l9Mt8");

var $2Eu2O = parcelRequire("2Eu2O");
/**
 * @type {Locale}
 * @category Locales
 * @summary Icelandic locale.
 * @language Icelandic
 * @iso-639-2 isl
 * @author Derek Blank [@derekblank]{@link https://github.com/derekblank}
 * @author Arnór Ýmir [@lamayg]{@link https://github.com/lamayg}
 */ var $012b8101b2352da8$var$locale = {
    code: 'is',
    formatDistance: (0, $8o690.default),
    formatLong: (0, $4p9js.default),
    formatRelative: (0, $cWU9K.default),
    localize: (0, $l9Mt8.default),
    match: (0, $2Eu2O.default),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
    }
};
var $012b8101b2352da8$export$2e2bcd8739ae039 = $012b8101b2352da8$var$locale;

});
parcelRegister("8o690", function(module, exports) {
$parcel$export(module.exports, "default", () => $61b554c30e23299b$export$2e2bcd8739ae039);
var $61b554c30e23299b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minna en 1 sek\xfanda",
        other: "minna en {{count}} sek\xfandur"
    },
    xSeconds: {
        one: "1 sek\xfanda",
        other: "{{count}} sek\xfandur"
    },
    halfAMinute: "h\xe1lf m\xedn\xfata",
    lessThanXMinutes: {
        one: "minna en 1 m\xedn\xfata",
        other: "minna en {{count}} m\xedn\xfatur"
    },
    xMinutes: {
        one: "1 m\xedn\xfata",
        other: "{{count}} m\xedn\xfatur"
    },
    aboutXHours: {
        one: "u.\xfe.b. 1 klukkustund",
        other: "u.\xfe.b. {{count}} klukkustundir"
    },
    xHours: {
        one: '1 klukkustund',
        other: '{{count}} klukkustundir'
    },
    xDays: {
        one: '1 dagur',
        other: '{{count}} dagar'
    },
    aboutXWeeks: {
        one: 'um viku',
        other: 'um {{count}} vikur'
    },
    xWeeks: {
        one: '1 viku',
        other: '{{count}} vikur'
    },
    aboutXMonths: {
        one: "u.\xfe.b. 1 m\xe1nu\xf0ur",
        other: "u.\xfe.b. {{count}} m\xe1nu\xf0ir"
    },
    xMonths: {
        one: "1 m\xe1nu\xf0ur",
        other: "{{count}} m\xe1nu\xf0ir"
    },
    aboutXYears: {
        one: "u.\xfe.b. 1 \xe1r",
        other: "u.\xfe.b. {{count}} \xe1r"
    },
    xYears: {
        one: "1 \xe1r",
        other: "{{count}} \xe1r"
    },
    overXYears: {
        one: "meira en 1 \xe1r",
        other: "meira en {{count}} \xe1r"
    },
    almostXYears: {
        one: "n\xe6stum 1 \xe1r",
        other: "n\xe6stum {{count}} \xe1r"
    }
};
function $61b554c30e23299b$export$2e2bcd8739ae039(token, count, options) {
    options = options || {};
    var result;
    if (typeof $61b554c30e23299b$var$formatDistanceLocale[token] === 'string') result = $61b554c30e23299b$var$formatDistanceLocale[token];
    else if (count === 1) result = $61b554c30e23299b$var$formatDistanceLocale[token].one;
    else result = $61b554c30e23299b$var$formatDistanceLocale[token].other.replace('{{count}}', count);
    if (options.addSuffix) {
        if (options.comparison > 0) return "\xed " + result;
        else return result + " s\xed\xf0an";
    }
    return result;
}

});

parcelRegister("4p9js", function(module, exports) {
$parcel$export(module.exports, "default", () => $3350b88bce4f6586$export$2e2bcd8739ae039);

var $8D7sK = parcelRequire("8D7sK");
var $3350b88bce4f6586$var$dateFormats = {
    full: 'EEEE, do MMMM y',
    long: 'do MMMM y',
    medium: 'do MMM y',
    short: 'd.MM.y'
};
var $3350b88bce4f6586$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $3350b88bce4f6586$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $3350b88bce4f6586$var$formatLong = {
    date: (0, $8D7sK.default)({
        formats: $3350b88bce4f6586$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $8D7sK.default)({
        formats: $3350b88bce4f6586$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $8D7sK.default)({
        formats: $3350b88bce4f6586$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $3350b88bce4f6586$export$2e2bcd8739ae039 = $3350b88bce4f6586$var$formatLong;

});

parcelRegister("cWU9K", function(module, exports) {
$parcel$export(module.exports, "default", () => $96d67644f42d35b4$export$2e2bcd8739ae039);
var $96d67644f42d35b4$var$formatRelativeLocale = {
    lastWeek: "'s\xed\xf0asta' dddd 'kl.' p",
    yesterday: "'\xed g\xe6r kl.' p",
    today: "'\xed dag kl.' p",
    tomorrow: "'\xe1 morgun kl.' p",
    nextWeek: "dddd 'kl.' p",
    other: 'L'
};
function $96d67644f42d35b4$export$2e2bcd8739ae039(token, _date, _baseDate, _options) {
    return $96d67644f42d35b4$var$formatRelativeLocale[token];
}

});

parcelRegister("l9Mt8", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6700924a4b7bb48$export$2e2bcd8739ae039);

var $7juaq = parcelRequire("7juaq");
var $f6700924a4b7bb48$var$eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        'fyrir Krist',
        'eftir Krist'
    ]
};
var $f6700924a4b7bb48$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1F',
        '2F',
        '3F',
        '4F'
    ],
    wide: [
        "1. fj\xf3r\xf0ungur",
        "2. fj\xf3r\xf0ungur",
        "3. fj\xf3r\xf0ungur",
        "4. fj\xf3r\xf0ungur"
    ]
};
var $f6700924a4b7bb48$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        "\xc1",
        'S',
        "\xd3",
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        "apr\xedl",
        "ma\xed",
        "j\xfan\xed",
        "j\xfal\xed",
        "\xe1g\xfast",
        'sept.',
        'okt.',
        "n\xf3v.",
        'des.'
    ],
    wide: [
        "jan\xfaar",
        "febr\xfaar",
        'mars',
        "apr\xedl",
        "ma\xed",
        "j\xfan\xed",
        "j\xfal\xed",
        "\xe1g\xfast",
        'september',
        "okt\xf3ber",
        "n\xf3vember",
        'desember'
    ]
};
var $f6700924a4b7bb48$var$dayValues = {
    narrow: [
        'S',
        'M',
        "\xde",
        'M',
        'F',
        'F',
        'L'
    ],
    short: [
        'Su',
        "M\xe1",
        "\xder",
        'Mi',
        'Fi',
        "F\xf6",
        'La'
    ],
    abbreviated: [
        'sun.',
        "m\xe1n.",
        "\xferi.",
        "mi\xf0.",
        'fim.',
        "f\xf6s.",
        'lau'
    ],
    wide: [
        'sunnudagur',
        "m\xe1nudagur",
        "\xferi\xf0judagur",
        "mi\xf0vikudagur",
        'fimmtudagur',
        "f\xf6studagur",
        'laugardagur'
    ]
};
var $f6700924a4b7bb48$var$dayPeriodValues = {
    narrow: {
        am: 'f',
        pm: 'e',
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: 'morgunn',
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    },
    abbreviated: {
        am: 'f.h.',
        pm: 'e.h.',
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: 'morgunn',
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    },
    wide: {
        am: "fyrir h\xe1degi",
        pm: "eftir h\xe1degi",
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: 'morgunn',
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    }
};
var $f6700924a4b7bb48$var$formattingDayPeriodValues = {
    narrow: {
        am: 'f',
        pm: 'e',
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    },
    abbreviated: {
        am: 'f.h.',
        pm: 'e.h.',
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    },
    wide: {
        am: "fyrir h\xe1degi",
        pm: "eftir h\xe1degi",
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    }
};
function $f6700924a4b7bb48$var$ordinalNumber(dirtyNumber, _dirtyOptions) {
    var number = Number(dirtyNumber);
    return number + '.';
}
var $f6700924a4b7bb48$var$localize = {
    ordinalNumber: $f6700924a4b7bb48$var$ordinalNumber,
    era: (0, $7juaq.default)({
        values: $f6700924a4b7bb48$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $7juaq.default)({
        values: $f6700924a4b7bb48$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $7juaq.default)({
        values: $f6700924a4b7bb48$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $7juaq.default)({
        values: $f6700924a4b7bb48$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $7juaq.default)({
        values: $f6700924a4b7bb48$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $f6700924a4b7bb48$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $f6700924a4b7bb48$export$2e2bcd8739ae039 = $f6700924a4b7bb48$var$localize;

});

parcelRegister("2Eu2O", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ee69f5e634eaaaf$export$2e2bcd8739ae039);

var $bFSku = parcelRequire("bFSku");

var $5hQUT = parcelRequire("5hQUT");
var $1ee69f5e634eaaaf$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $1ee69f5e634eaaaf$var$parseOrdinalNumberPattern = /\d+/i;
var $1ee69f5e634eaaaf$var$matchEraPatterns = {
    narrow: /^(f\.Kr\.|e\.Kr\.)/i,
    abbreviated: /^(f\.Kr\.|e\.Kr\.)/i,
    wide: /^(fyrir Krist|eftir Krist)/i
};
var $1ee69f5e634eaaaf$var$parseEraPatterns = {
    any: [
        /^(f\.Kr\.|e\.Kr\.)/i
    ]
};
var $1ee69f5e634eaaaf$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234] fjórðungur/i
};
var $1ee69f5e634eaaaf$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $1ee69f5e634eaaaf$var$matchMonthPatterns = {
    narrow: /^[jfmásónd]/i,
    abbreviated: /^(jan\.|feb\.|mars\.|apríl\.|maí|júní|júlí|águst|sep\.|oct\.|nov\.|dec\.)/i,
    wide: /^(januar|februar|mars|apríl|maí|júní|júlí|águst|september|október|nóvember|desember)/i
};
var $1ee69f5e634eaaaf$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^á/i,
        /^s/i,
        /^ó/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maí/i,
        /^jún/i,
        /^júl/i,
        /^áu/i,
        /^s/i,
        /^ó/i,
        /^n/i,
        /^d/i
    ]
};
var $1ee69f5e634eaaaf$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|má|þr|mi|fi|fö|la)/i,
    abbreviated: /^(sun|mán|þri|mið|fim|fös|lau)\.?/i,
    wide: /^(sunnudagur|mánudagur|þriðjudagur|miðvikudagur|fimmtudagur|föstudagur|laugardagur)/i
};
var $1ee69f5e634eaaaf$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^þ/i,
        /^m/i,
        /^f/i,
        /^f/i,
        /^l/i
    ],
    any: [
        /^su/i,
        /^má/i,
        /^þr/i,
        /^mi/i,
        /^fi/i,
        /^fö/i,
        /^la/i
    ]
};
var $1ee69f5e634eaaaf$var$matchDayPeriodPatterns = {
    narrow: /^(f|e|síðdegis|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i,
    any: /^(fyrir hádegi|eftir hádegi|[ef]\.?h\.?|síðdegis|morgunn|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i
};
var $1ee69f5e634eaaaf$var$parseDayPeriodPatterns = {
    any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^mi/i,
        noon: /^há/i,
        morning: /morgunn/i,
        afternoon: /síðdegi/i,
        evening: /kvöld/i,
        night: /nótt/i
    }
};
var $1ee69f5e634eaaaf$var$match = {
    ordinalNumber: (0, $bFSku.default)({
        matchPattern: $1ee69f5e634eaaaf$var$matchOrdinalNumberPattern,
        parsePattern: $1ee69f5e634eaaaf$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5hQUT.default)({
        matchPatterns: $1ee69f5e634eaaaf$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1ee69f5e634eaaaf$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5hQUT.default)({
        matchPatterns: $1ee69f5e634eaaaf$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1ee69f5e634eaaaf$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $5hQUT.default)({
        matchPatterns: $1ee69f5e634eaaaf$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1ee69f5e634eaaaf$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5hQUT.default)({
        matchPatterns: $1ee69f5e634eaaaf$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1ee69f5e634eaaaf$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5hQUT.default)({
        matchPatterns: $1ee69f5e634eaaaf$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $1ee69f5e634eaaaf$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $1ee69f5e634eaaaf$export$2e2bcd8739ae039 = $1ee69f5e634eaaaf$var$match;

});


parcelRegister("gYYzt", function(module, exports) {
$parcel$export(module.exports, "default", () => $c5d13c1f02f25baf$export$2e2bcd8739ae039);

var $6GYcY = parcelRequire("6GYcY");

var $bt3ih = parcelRequire("bt3ih");

var $gpiol = parcelRequire("gpiol");

var $5RFhh = parcelRequire("5RFhh");

var $biL7m = parcelRequire("biL7m");
/**
 * @type {Locale}
 * @category Locales
 * @summary Portuguese locale (Brazil).
 * @language Portuguese
 * @iso-639-2 por
 * @author Lucas Duailibe [@duailibe]{@link https://github.com/duailibe}
 * @author Yago Carballo [@yagocarballo]{@link https://github.com/YagoCarballo}
 */ var $c5d13c1f02f25baf$var$locale = {
    code: 'pt-BR',
    formatDistance: (0, $6GYcY.default),
    formatLong: (0, $bt3ih.default),
    formatRelative: (0, $gpiol.default),
    localize: (0, $5RFhh.default),
    match: (0, $biL7m.default),
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
var $c5d13c1f02f25baf$export$2e2bcd8739ae039 = $c5d13c1f02f25baf$var$locale;

});
parcelRegister("6GYcY", function(module, exports) {
$parcel$export(module.exports, "default", () => $4df55e6e7ee179d3$export$2e2bcd8739ae039);
var $4df55e6e7ee179d3$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos de um segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'meio minuto',
    lessThanXMinutes: {
        one: 'menos de um minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'cerca de 1 hora',
        other: 'cerca de {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: '1 dia',
        other: '{{count}} dias'
    },
    aboutXWeeks: {
        one: 'cerca de 1 semana',
        other: 'cerca de {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: "cerca de 1 m\xeas",
        other: 'cerca de {{count}} meses'
    },
    xMonths: {
        one: "1 m\xeas",
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'cerca de 1 ano',
        other: 'cerca de {{count}} anos'
    },
    xYears: {
        one: '1 ano',
        other: '{{count}} anos'
    },
    overXYears: {
        one: 'mais de 1 ano',
        other: 'mais de {{count}} anos'
    },
    almostXYears: {
        one: 'quase 1 ano',
        other: 'quase {{count}} anos'
    }
};
function $4df55e6e7ee179d3$export$2e2bcd8739ae039(token, count, options) {
    options = options || {};
    var result;
    if (typeof $4df55e6e7ee179d3$var$formatDistanceLocale[token] === 'string') result = $4df55e6e7ee179d3$var$formatDistanceLocale[token];
    else if (count === 1) result = $4df55e6e7ee179d3$var$formatDistanceLocale[token].one;
    else result = $4df55e6e7ee179d3$var$formatDistanceLocale[token].other.replace('{{count}}', count);
    if (options.addSuffix) {
        if (options.comparison > 0) return 'em ' + result;
        else return "h\xe1 " + result;
    }
    return result;
}

});

parcelRegister("bt3ih", function(module, exports) {
$parcel$export(module.exports, "default", () => $8594f53a55f6fdf8$export$2e2bcd8739ae039);

var $8D7sK = parcelRequire("8D7sK");
var $8594f53a55f6fdf8$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var $8594f53a55f6fdf8$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $8594f53a55f6fdf8$var$dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $8594f53a55f6fdf8$var$formatLong = {
    date: (0, $8D7sK.default)({
        formats: $8594f53a55f6fdf8$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $8D7sK.default)({
        formats: $8594f53a55f6fdf8$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $8D7sK.default)({
        formats: $8594f53a55f6fdf8$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $8594f53a55f6fdf8$export$2e2bcd8739ae039 = $8594f53a55f6fdf8$var$formatLong;

});

parcelRegister("gpiol", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf1d3f5c1a483d03$export$2e2bcd8739ae039);
var $bf1d3f5c1a483d03$var$formatRelativeLocale = {
    lastWeek: function(date, _baseDate, _options) {
        var weekday = date.getUTCDay();
        var last = weekday === 0 || weekday === 6 ? "\xfaltimo" : "\xfaltima";
        return "'" + last + "' eeee '\xe0s' p";
    },
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: 'P'
};
function $bf1d3f5c1a483d03$export$2e2bcd8739ae039(token, date, baseDate, options) {
    var format = $bf1d3f5c1a483d03$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
}

});

parcelRegister("5RFhh", function(module, exports) {
$parcel$export(module.exports, "default", () => $4451ebe1568a1275$export$2e2bcd8739ae039);

var $7juaq = parcelRequire("7juaq");
var $4451ebe1568a1275$var$eraValues = {
    narrow: [
        'AC',
        'DC'
    ],
    abbreviated: [
        'AC',
        'DC'
    ],
    wide: [
        'antes de cristo',
        'depois de cristo'
    ]
};
var $4451ebe1568a1275$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $4451ebe1568a1275$var$monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'fev',
        'mar',
        'abr',
        'mai',
        'jun',
        'jul',
        'ago',
        'set',
        'out',
        'nov',
        'dez'
    ],
    wide: [
        'janeiro',
        'fevereiro',
        "mar\xe7o",
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro'
    ]
};
var $4451ebe1568a1275$var$dayValues = {
    narrow: [
        'D',
        'S',
        'T',
        'Q',
        'Q',
        'S',
        'S'
    ],
    short: [
        'dom',
        'seg',
        'ter',
        'qua',
        'qui',
        'sex',
        'sab'
    ],
    abbreviated: [
        'domingo',
        'segunda',
        "ter\xe7a",
        'quarta',
        'quinta',
        'sexta',
        "s\xe1bado"
    ],
    wide: [
        'domingo',
        'segunda-feira',
        "ter\xe7a-feira",
        'quarta-feira',
        'quinta-feira',
        'sexta-feira',
        "s\xe1bado"
    ]
};
var $4451ebe1568a1275$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    }
};
var $4451ebe1568a1275$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da tarde',
        night: 'da noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da tarde',
        night: 'da noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da tarde',
        night: 'da noite'
    }
};
function $4451ebe1568a1275$var$ordinalNumber(dirtyNumber, dirtyOptions) {
    var number = Number(dirtyNumber);
    var options = dirtyOptions || {};
    var unit = String(options.unit);
    if (unit === 'week' || unit === 'isoWeek') return number + "\xaa";
    return number + "\xba";
}
var $4451ebe1568a1275$var$localize = {
    ordinalNumber: $4451ebe1568a1275$var$ordinalNumber,
    era: (0, $7juaq.default)({
        values: $4451ebe1568a1275$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $7juaq.default)({
        values: $4451ebe1568a1275$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $7juaq.default)({
        values: $4451ebe1568a1275$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $7juaq.default)({
        values: $4451ebe1568a1275$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $7juaq.default)({
        values: $4451ebe1568a1275$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $4451ebe1568a1275$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $4451ebe1568a1275$export$2e2bcd8739ae039 = $4451ebe1568a1275$var$localize;

});

parcelRegister("biL7m", function(module, exports) {
$parcel$export(module.exports, "default", () => $83a5ecc1c574ab7a$export$2e2bcd8739ae039);

var $5hQUT = parcelRequire("5hQUT");

var $bFSku = parcelRequire("bFSku");
var $83a5ecc1c574ab7a$var$matchOrdinalNumberPattern = /^(\d+)[ºªo]?/i;
var $83a5ecc1c574ab7a$var$parseOrdinalNumberPattern = /\d+/i;
var $83a5ecc1c574ab7a$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
    wide: /^(antes de cristo|depois de cristo)/i
};
var $83a5ecc1c574ab7a$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^antes de cristo/i,
        /^depois de cristo/i
    ]
};
var $83a5ecc1c574ab7a$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $83a5ecc1c574ab7a$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $83a5ecc1c574ab7a$var$matchMonthPatterns = {
    narrow: /^[jfmajsond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var $83a5ecc1c574ab7a$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^fev/i,
        /^mar/i,
        /^abr/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^set/i,
        /^out/i,
        /^nov/i,
        /^dez/i
    ]
};
var $83a5ecc1c574ab7a$var$matchDayPatterns = {
    narrow: /^(dom|[23456]ª?|s[aá]b)/i,
    short: /^(dom|[23456]ª?|s[aá]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
    wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
};
var $83a5ecc1c574ab7a$var$parseDayPatterns = {
    short: [
        /^d/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^s[aá]/i
    ],
    narrow: [
        /^d/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^s[aá]/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[aá]b/i
    ]
};
var $83a5ecc1c574ab7a$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
};
var $83a5ecc1c574ab7a$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn|^meia[-\s]noite/i,
        noon: /^md|^meio[-\s]dia/i,
        morning: /manhã/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noite/i
    }
};
var $83a5ecc1c574ab7a$var$match = {
    ordinalNumber: (0, $bFSku.default)({
        matchPattern: $83a5ecc1c574ab7a$var$matchOrdinalNumberPattern,
        parsePattern: $83a5ecc1c574ab7a$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5hQUT.default)({
        matchPatterns: $83a5ecc1c574ab7a$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $83a5ecc1c574ab7a$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5hQUT.default)({
        matchPatterns: $83a5ecc1c574ab7a$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $83a5ecc1c574ab7a$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $5hQUT.default)({
        matchPatterns: $83a5ecc1c574ab7a$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $83a5ecc1c574ab7a$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5hQUT.default)({
        matchPatterns: $83a5ecc1c574ab7a$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $83a5ecc1c574ab7a$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5hQUT.default)({
        matchPatterns: $83a5ecc1c574ab7a$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $83a5ecc1c574ab7a$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $83a5ecc1c574ab7a$export$2e2bcd8739ae039 = $83a5ecc1c574ab7a$var$match;

});


parcelRegister("fA5Lp", function(module, exports) {
$parcel$export(module.exports, "default", () => $b57eb0574c083fa6$export$2e2bcd8739ae039);

var $lg4Ll = parcelRequire("lg4Ll");

var $2ivzJ = parcelRequire("2ivzJ");

var $b7DVB = parcelRequire("b7DVB");

var $9VIVS = parcelRequire("9VIVS");

var $j0bdU = parcelRequire("j0bdU");
/**
 * @type {Locale}
 * @category Locales
 * @summary Romanian locale.
 * @language Romanian
 * @iso-639-2 ron
 * @author Sergiu Munteanu [@jsergiu]{@link https://github.com/jsergiu}
 * @author Adrian Ocneanu [@aocneanu]{@link https://github.com/aocneanu}
 * @author Mihai Ocneanu [@gandesc]{@link https://github.com/gandesc}
 */ var $b57eb0574c083fa6$var$locale = {
    code: 'ro',
    formatDistance: (0, $lg4Ll.default),
    formatLong: (0, $2ivzJ.default),
    formatRelative: (0, $b7DVB.default),
    localize: (0, $9VIVS.default),
    match: (0, $j0bdU.default),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
    }
};
var $b57eb0574c083fa6$export$2e2bcd8739ae039 = $b57eb0574c083fa6$var$locale;

});
parcelRegister("lg4Ll", function(module, exports) {
$parcel$export(module.exports, "default", () => $f79ec960d7745484$export$2e2bcd8739ae039);
var $f79ec960d7745484$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mai pu\u021Bin de o secund\u0103",
        other: "mai pu\u021Bin de {{count}} secunde"
    },
    xSeconds: {
        one: "1 secund\u0103",
        other: '{{count}} secunde'
    },
    halfAMinute: "jum\u0103tate de minut",
    lessThanXMinutes: {
        one: "mai pu\u021Bin de un minut",
        other: "mai pu\u021Bin de {{count}} minute"
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minute'
    },
    aboutXHours: {
        one: "circa 1 or\u0103",
        other: 'circa {{count}} ore'
    },
    xHours: {
        one: "1 or\u0103",
        other: '{{count}} ore'
    },
    xDays: {
        one: '1 zi',
        other: '{{count}} zile'
    },
    aboutXWeeks: {
        one: "circa o s\u0103pt\u0103m\xe2n\u0103",
        other: "circa {{count}} s\u0103pt\u0103m\xe2ni"
    },
    xWeeks: {
        one: "1 s\u0103pt\u0103m\xe2n\u0103",
        other: "{{count}} s\u0103pt\u0103m\xe2ni"
    },
    aboutXMonths: {
        one: "circa 1 lun\u0103",
        other: 'circa {{count}} luni'
    },
    xMonths: {
        one: "1 lun\u0103",
        other: '{{count}} luni'
    },
    aboutXYears: {
        one: 'circa 1 an',
        other: 'circa {{count}} ani'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} ani'
    },
    overXYears: {
        one: 'peste 1 an',
        other: 'peste {{count}} ani'
    },
    almostXYears: {
        one: 'aproape 1 an',
        other: 'aproape {{count}} ani'
    }
};
function $f79ec960d7745484$export$2e2bcd8739ae039(token, count, options) {
    options = options || {};
    var result;
    if (typeof $f79ec960d7745484$var$formatDistanceLocale[token] === 'string') result = $f79ec960d7745484$var$formatDistanceLocale[token];
    else if (count === 1) result = $f79ec960d7745484$var$formatDistanceLocale[token].one;
    else result = $f79ec960d7745484$var$formatDistanceLocale[token].other.replace('{{count}}', count);
    if (options.addSuffix) {
        if (options.comparison > 0) return "\xeen " + result;
        else return result + " \xeen urm\u0103";
    }
    return result;
}

});

parcelRegister("2ivzJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ac5c16ac00a81c4$export$2e2bcd8739ae039);

var $8D7sK = parcelRequire("8D7sK");
var $1ac5c16ac00a81c4$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $1ac5c16ac00a81c4$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $1ac5c16ac00a81c4$var$dateTimeFormats = {
    full: "{{date}} 'la' {{time}}",
    long: "{{date}} 'la' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $1ac5c16ac00a81c4$var$formatLong = {
    date: (0, $8D7sK.default)({
        formats: $1ac5c16ac00a81c4$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $8D7sK.default)({
        formats: $1ac5c16ac00a81c4$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $8D7sK.default)({
        formats: $1ac5c16ac00a81c4$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $1ac5c16ac00a81c4$export$2e2bcd8739ae039 = $1ac5c16ac00a81c4$var$formatLong;

});

parcelRegister("b7DVB", function(module, exports) {
$parcel$export(module.exports, "default", () => $818f5210acb54a6b$export$2e2bcd8739ae039);
var $818f5210acb54a6b$var$formatRelativeLocale = {
    lastWeek: "eeee 'trecut\u0103 la' p",
    yesterday: "'ieri la' p",
    today: "'ast\u0103zi la' p",
    tomorrow: "'m\xe2ine la' p",
    nextWeek: "eeee 'viitoare la' p",
    other: 'P'
};
function $818f5210acb54a6b$export$2e2bcd8739ae039(token, _date, _baseDate, _options) {
    return $818f5210acb54a6b$var$formatRelativeLocale[token];
}

});

parcelRegister("9VIVS", function(module, exports) {
$parcel$export(module.exports, "default", () => $73ac4a984278275d$export$2e2bcd8739ae039);

var $7juaq = parcelRequire("7juaq");
var $73ac4a984278275d$var$eraValues = {
    narrow: [
        "\xce",
        'D'
    ],
    abbreviated: [
        "\xce.d.C.",
        'D.C.'
    ],
    wide: [
        "\xcenainte de Cristos",
        "Dup\u0103 Cristos"
    ]
};
var $73ac4a984278275d$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        'primul trimestru',
        'al doilea trimestru',
        'al treilea trimestru',
        'al patrulea trimestru'
    ]
};
var $73ac4a984278275d$var$monthValues = {
    narrow: [
        'I',
        'F',
        'M',
        'A',
        'M',
        'I',
        'I',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'ian',
        'feb',
        'mar',
        'apr',
        'mai',
        'iun',
        'iul',
        'aug',
        'sep',
        'oct',
        'noi',
        'dec'
    ],
    wide: [
        'ianuarie',
        'februarie',
        'martie',
        'aprilie',
        'mai',
        'iunie',
        'iulie',
        'august',
        'septembrie',
        'octombrie',
        'noiembrie',
        'decembrie'
    ]
};
var $73ac4a984278275d$var$dayValues = {
    narrow: [
        'd',
        'l',
        'm',
        'm',
        'j',
        'v',
        's'
    ],
    short: [
        'du',
        'lu',
        'ma',
        'mi',
        'jo',
        'vi',
        "s\xe2"
    ],
    abbreviated: [
        'dum',
        'lun',
        'mar',
        'mie',
        'joi',
        'vin',
        "s\xe2m"
    ],
    wide: [
        "duminic\u0103",
        'luni',
        "mar\u021Bi",
        'miercuri',
        'joi',
        'vineri',
        "s\xe2mb\u0103t\u0103"
    ]
};
var $73ac4a984278275d$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'ami',
        morning: 'dim',
        afternoon: 'da',
        evening: 's',
        night: 'n'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    }
};
var $73ac4a984278275d$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    }
};
function $73ac4a984278275d$var$ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return String(number);
}
var $73ac4a984278275d$var$localize = {
    ordinalNumber: $73ac4a984278275d$var$ordinalNumber,
    era: (0, $7juaq.default)({
        values: $73ac4a984278275d$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $7juaq.default)({
        values: $73ac4a984278275d$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $7juaq.default)({
        values: $73ac4a984278275d$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $7juaq.default)({
        values: $73ac4a984278275d$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $7juaq.default)({
        values: $73ac4a984278275d$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $73ac4a984278275d$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $73ac4a984278275d$export$2e2bcd8739ae039 = $73ac4a984278275d$var$localize;

});

parcelRegister("j0bdU", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd56b926298b0510$export$2e2bcd8739ae039);

var $bFSku = parcelRequire("bFSku");

var $5hQUT = parcelRequire("5hQUT");
var $dd56b926298b0510$var$matchOrdinalNumberPattern = /^(\d+)?/i;
var $dd56b926298b0510$var$parseOrdinalNumberPattern = /\d+/i;
var $dd56b926298b0510$var$matchEraPatterns = {
    narrow: /^(Î|D)/i,
    abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
    wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
};
var $dd56b926298b0510$var$parseEraPatterns = {
    any: [
        /^ÎC/i,
        /^DC/i
    ],
    wide: [
        /^(Înainte de Cristos|Înaintea erei noastre)/i,
        /^(După Cristos|Era noastră)/i
    ]
};
var $dd56b926298b0510$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^trimestrul [1234]/i
};
var $dd56b926298b0510$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $dd56b926298b0510$var$matchMonthPatterns = {
    narrow: /^[ifmaasond]/i,
    abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
    wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
};
var $dd56b926298b0510$var$parseMonthPatterns = {
    narrow: [
        /^i/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^i/i,
        /^i/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ia/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^iun/i,
        /^iul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $dd56b926298b0510$var$matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(d|l|ma|mi|j|v|s)/i,
    abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
    wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
};
var $dd56b926298b0510$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^mi/i,
        /^j/i,
        /^v/i,
        /^s/i
    ]
};
var $dd56b926298b0510$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
    any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
};
var $dd56b926298b0510$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /amiaza/i,
        morning: /dimineaţa/i,
        afternoon: /după-amiaza/i,
        evening: /seara/i,
        night: /noaptea/i
    }
};
var $dd56b926298b0510$var$match = {
    ordinalNumber: (0, $bFSku.default)({
        matchPattern: $dd56b926298b0510$var$matchOrdinalNumberPattern,
        parsePattern: $dd56b926298b0510$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5hQUT.default)({
        matchPatterns: $dd56b926298b0510$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dd56b926298b0510$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5hQUT.default)({
        matchPatterns: $dd56b926298b0510$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dd56b926298b0510$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $5hQUT.default)({
        matchPatterns: $dd56b926298b0510$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dd56b926298b0510$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5hQUT.default)({
        matchPatterns: $dd56b926298b0510$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dd56b926298b0510$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5hQUT.default)({
        matchPatterns: $dd56b926298b0510$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $dd56b926298b0510$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $dd56b926298b0510$export$2e2bcd8739ae039 = $dd56b926298b0510$var$match;

});


parcelRegister("cmLAh", function(module, exports) {
$parcel$export(module.exports, "default", () => $900c735bd2df523c$export$2e2bcd8739ae039);

var $xvuj7 = parcelRequire("xvuj7");

var $9MrPd = parcelRequire("9MrPd");

var $89qJr = parcelRequire("89qJr");

var $47PVG = parcelRequire("47PVG");

var $aaBU7 = parcelRequire("aaBU7");
/**
 * @type {Locale}
 * @category Locales
 * @summary Slovak locale.
 * @language Slovak
 * @iso-639-2 slk
 * @author Marek Suscak [@mareksuscak]{@link https://github.com/mareksuscak}
 */ var $900c735bd2df523c$var$locale = {
    code: 'sk',
    formatDistance: (0, $xvuj7.default),
    formatLong: (0, $9MrPd.default),
    formatRelative: (0, $89qJr.default),
    localize: (0, $47PVG.default),
    match: (0, $aaBU7.default),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
    }
};
var $900c735bd2df523c$export$2e2bcd8739ae039 = $900c735bd2df523c$var$locale;

});
parcelRegister("xvuj7", function(module, exports) {
$parcel$export(module.exports, "default", () => $064b8202509c0414$export$2e2bcd8739ae039);
// NOTE: should prolly be improved
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1308
function $064b8202509c0414$var$declensionGroup(scheme, count) {
    if (count === 1) return scheme.one;
    if (count >= 2 && count <= 4) return scheme.twoFour;
     // if count === null || count === 0 || count >= 5
    return scheme.other;
}
function $064b8202509c0414$var$declension(scheme, count, time) {
    var group = $064b8202509c0414$var$declensionGroup(scheme, count);
    var finalText = group[time] || group;
    return finalText.replace('{{count}}', count);
}
function $064b8202509c0414$var$extractPreposition(token) {
    var result = [
        'lessThan',
        'about',
        'over',
        'almost'
    ].filter(function(preposition) {
        return !!token.match(new RegExp('^' + preposition));
    });
    return result[0];
}
function $064b8202509c0414$var$prefixPreposition(preposition) {
    var translation = '';
    if (preposition === 'almost') translation = 'takmer';
    if (preposition === 'about') translation = "pribli\u017Ene";
    return translation.length > 0 ? translation + ' ' : '';
}
function $064b8202509c0414$var$suffixPreposition(preposition) {
    var translation = '';
    if (preposition === 'lessThan') translation = "menej ne\u017E";
    if (preposition === 'over') translation = "viac ne\u017E";
    return translation.length > 0 ? translation + ' ' : '';
}
function $064b8202509c0414$var$lowercaseFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
}
var $064b8202509c0414$var$formatDistanceLocale = {
    xSeconds: {
        one: {
            regular: 'sekunda',
            past: 'sekundou',
            future: 'sekundu'
        },
        twoFour: {
            regular: '{{count}} sekundy',
            past: '{{count}} sekundami',
            future: '{{count}} sekundy'
        },
        other: {
            regular: "{{count}} sek\xfand",
            past: '{{count}} sekundami',
            future: "{{count}} sek\xfand"
        }
    },
    halfAMinute: {
        other: {
            regular: "pol min\xfaty",
            past: "pol min\xfatou",
            future: "pol min\xfaty"
        }
    },
    xMinutes: {
        one: {
            regular: "min\xfata",
            past: "min\xfatou",
            future: "min\xfatu"
        },
        twoFour: {
            regular: "{{count}} min\xfaty",
            past: "{{count}} min\xfatami",
            future: "{{count}} min\xfaty"
        },
        other: {
            regular: "{{count}} min\xfat",
            past: "{{count}} min\xfatami",
            future: "{{count}} min\xfat"
        }
    },
    xHours: {
        one: {
            regular: 'hodina',
            past: 'hodinou',
            future: 'hodinu'
        },
        twoFour: {
            regular: '{{count}} hodiny',
            past: '{{count}} hodinami',
            future: '{{count}} hodiny'
        },
        other: {
            regular: "{{count}} hod\xedn",
            past: '{{count}} hodinami',
            future: "{{count}} hod\xedn"
        }
    },
    xDays: {
        one: {
            regular: "de\u0148",
            past: "d\u0148om",
            future: "de\u0148"
        },
        twoFour: {
            regular: '{{count}} dni',
            past: "{{count}} d\u0148ami",
            future: '{{count}} dni'
        },
        other: {
            regular: "{{count}} dn\xed",
            past: "{{count}} d\u0148ami",
            future: "{{count}} dn\xed"
        }
    },
    xWeeks: {
        one: {
            regular: 'mesiac',
            // TODO
            past: 'mesiacom',
            // TODO
            future: 'mesiac' // TODO
        },
        twoFour: {
            regular: '{{count}} mesiace',
            // TODO
            past: '{{count}} mesiacmi',
            // TODO
            future: '{{count}} mesiace' // TODO
        },
        other: {
            regular: '{{count}} mesiacov',
            // TODO
            past: '{{count}} mesiacmi',
            // TODO
            future: '{{count}} mesiacov' // TODO
        }
    },
    xMonths: {
        one: {
            regular: 'mesiac',
            past: 'mesiacom',
            future: 'mesiac'
        },
        twoFour: {
            regular: '{{count}} mesiace',
            past: '{{count}} mesiacmi',
            future: '{{count}} mesiace'
        },
        other: {
            regular: '{{count}} mesiacov',
            past: '{{count}} mesiacmi',
            future: '{{count}} mesiacov'
        }
    },
    xYears: {
        one: {
            regular: 'rok',
            past: 'rokom',
            future: 'rok'
        },
        twoFour: {
            regular: '{{count}} roky',
            past: '{{count}} rokmi',
            future: '{{count}} roky'
        },
        other: {
            regular: '{{count}} rokov',
            past: '{{count}} rokmi',
            future: '{{count}} rokov'
        }
    }
};
function $064b8202509c0414$export$2e2bcd8739ae039(token, count, options) {
    options = options || {};
    var preposition = $064b8202509c0414$var$extractPreposition(token) || '';
    var key = $064b8202509c0414$var$lowercaseFirstLetter(token.substring(preposition.length));
    var scheme = $064b8202509c0414$var$formatDistanceLocale[key];
    if (!options.addSuffix) return $064b8202509c0414$var$prefixPreposition(preposition) + $064b8202509c0414$var$suffixPreposition(preposition) + $064b8202509c0414$var$declension(scheme, count, 'regular');
    if (options.comparison > 0) return $064b8202509c0414$var$prefixPreposition(preposition) + 'o ' + $064b8202509c0414$var$suffixPreposition(preposition) + $064b8202509c0414$var$declension(scheme, count, 'future');
    else return $064b8202509c0414$var$prefixPreposition(preposition) + 'pred ' + $064b8202509c0414$var$suffixPreposition(preposition) + $064b8202509c0414$var$declension(scheme, count, 'past');
}

});

parcelRegister("9MrPd", function(module, exports) {
$parcel$export(module.exports, "default", () => $71ee2e383dbc7771$export$2e2bcd8739ae039);

var $8D7sK = parcelRequire("8D7sK");
var $71ee2e383dbc7771$var$dateFormats = {
    full: 'EEEE d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. M. y',
    short: 'd. M. y'
}; // https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#2149
var $71ee2e383dbc7771$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
}; // https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1994
var $71ee2e383dbc7771$var$dateTimeFormats = {
    full: '{{date}}, {{time}}',
    long: '{{date}}, {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}} {{time}}'
};
var $71ee2e383dbc7771$var$formatLong = {
    date: (0, $8D7sK.default)({
        formats: $71ee2e383dbc7771$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $8D7sK.default)({
        formats: $71ee2e383dbc7771$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $8D7sK.default)({
        formats: $71ee2e383dbc7771$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $71ee2e383dbc7771$export$2e2bcd8739ae039 = $71ee2e383dbc7771$var$formatLong;

});

parcelRegister("89qJr", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ef3e66ac380fb00$export$2e2bcd8739ae039);

var $2q0eX = parcelRequire("2q0eX");
var $5ef3e66ac380fb00$var$accusativeWeekdays = [
    "nede\u013Eu",
    'pondelok',
    'utorok',
    'stredu',
    "\u0161tvrtok",
    'piatok',
    'sobotu'
];
function $5ef3e66ac380fb00$var$lastWeek(day) {
    var weekday = $5ef3e66ac380fb00$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        /* Sun */ case 3:
        /* Wed */ case 6:
            return "'minul\xfa " + weekday + " o' p";
        default:
            return "'minul\xfd' eeee 'o' p";
    }
}
function $5ef3e66ac380fb00$var$thisWeek(day) {
    var weekday = $5ef3e66ac380fb00$var$accusativeWeekdays[day];
    if (day === 4) return "'vo' eeee 'o' p";
    else return "'v " + weekday + " o' p";
}
function $5ef3e66ac380fb00$var$nextWeek(day) {
    var weekday = $5ef3e66ac380fb00$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        /* Sun */ case 4:
        /* Wed */ case 6:
            return "'bud\xfacu' " + weekday + " 'o' p";
        default:
            return "'bud\xfaci' eeee 'o' p";
    }
}
var $5ef3e66ac380fb00$var$formatRelativeLocale = {
    lastWeek: function(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $2q0eX.default)(date, baseDate, options)) return $5ef3e66ac380fb00$var$thisWeek(day);
        else return $5ef3e66ac380fb00$var$lastWeek(day);
    },
    yesterday: "'v\u010Dera o' p",
    today: "'dnes o' p",
    tomorrow: "'zajtra o' p",
    nextWeek: function(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $2q0eX.default)(date, baseDate, options)) return $5ef3e66ac380fb00$var$thisWeek(day);
        else return $5ef3e66ac380fb00$var$nextWeek(day);
    },
    other: 'P'
};
function $5ef3e66ac380fb00$export$2e2bcd8739ae039(token, date, baseDate, options) {
    var format = $5ef3e66ac380fb00$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
}

});

parcelRegister("47PVG", function(module, exports) {
$parcel$export(module.exports, "default", () => $301018f81d303665$export$2e2bcd8739ae039);

var $7juaq = parcelRequire("7juaq");
var $301018f81d303665$var$eraValues = {
    narrow: [
        'pred Kr.',
        'po Kr.'
    ],
    abbreviated: [
        'pred Kr.',
        'po Kr.'
    ],
    wide: [
        'pred Kristom',
        'po Kristovi'
    ]
}; // https://www.unicode.org/cldr/charts/32/summary/sk.html#1780
var $301018f81d303665$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "1. \u0161tvr\u0165rok",
        "2. \u0161tvr\u0165rok",
        "3. \u0161tvr\u0165rok",
        "4. \u0161tvr\u0165rok"
    ]
}; // https://www.unicode.org/cldr/charts/32/summary/sk.html#1804
var $301018f81d303665$var$monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        'aug',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        "janu\xe1r",
        "febru\xe1r",
        'marec',
        "apr\xedl",
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        'august',
        'september',
        "okt\xf3ber",
        'november',
        'december'
    ]
};
var $301018f81d303665$var$formattingMonthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        'aug',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        "janu\xe1ra",
        "febru\xe1ra",
        'marca',
        "apr\xedla",
        "m\xe1ja",
        "j\xfana",
        "j\xfala",
        'augusta',
        'septembra',
        "okt\xf3bra",
        'novembra',
        'decembra'
    ]
}; // https://www.unicode.org/cldr/charts/32/summary/sk.html#1876
var $301018f81d303665$var$dayValues = {
    narrow: [
        'n',
        'p',
        'u',
        's',
        "\u0161",
        'p',
        's'
    ],
    short: [
        'ne',
        'po',
        'ut',
        'st',
        "\u0161t",
        'pi',
        'so'
    ],
    abbreviated: [
        'ne',
        'po',
        'ut',
        'st',
        "\u0161t",
        'pi',
        'so'
    ],
    wide: [
        "nede\u013Ea",
        'pondelok',
        'utorok',
        'streda',
        "\u0161tvrtok",
        'piatok',
        'sobota'
    ]
}; // https://www.unicode.org/cldr/charts/32/summary/sk.html#1932
var $301018f81d303665$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'poln.',
        noon: 'pol.',
        morning: "r\xe1no",
        afternoon: 'pop.',
        evening: "ve\u010D.",
        night: 'noc'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'poln.',
        noon: 'pol.',
        morning: "r\xe1no",
        afternoon: 'popol.',
        evening: "ve\u010Der",
        night: 'noc'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'polnoc',
        noon: 'poludnie',
        morning: "r\xe1no",
        afternoon: 'popoludnie',
        evening: "ve\u010Der",
        night: 'noc'
    }
};
var $301018f81d303665$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'o poln.',
        noon: 'nap.',
        morning: "r\xe1no",
        afternoon: 'pop.',
        evening: "ve\u010D.",
        night: 'v n.'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'o poln.',
        noon: 'napol.',
        morning: "r\xe1no",
        afternoon: 'popol.',
        evening: "ve\u010Der",
        night: 'v noci'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'o polnoci',
        noon: 'napoludnie',
        morning: "r\xe1no",
        afternoon: "popoludn\xed",
        evening: "ve\u010Der",
        night: 'v noci'
    }
};
function $301018f81d303665$var$ordinalNumber(dirtyNumber, _dirtyOptions) {
    var number = Number(dirtyNumber);
    return number + '.';
}
var $301018f81d303665$var$localize = {
    ordinalNumber: $301018f81d303665$var$ordinalNumber,
    era: (0, $7juaq.default)({
        values: $301018f81d303665$var$eraValues // defaultWidth: 'wide'
    }),
    quarter: (0, $7juaq.default)({
        values: $301018f81d303665$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $7juaq.default)({
        values: $301018f81d303665$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $301018f81d303665$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $7juaq.default)({
        values: $301018f81d303665$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $7juaq.default)({
        values: $301018f81d303665$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $301018f81d303665$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $301018f81d303665$export$2e2bcd8739ae039 = $301018f81d303665$var$localize;

});

parcelRegister("aaBU7", function(module, exports) {
$parcel$export(module.exports, "default", () => $76783d8d2ffb51d8$export$2e2bcd8739ae039);

var $bFSku = parcelRequire("bFSku");

var $5hQUT = parcelRequire("5hQUT");
var $76783d8d2ffb51d8$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $76783d8d2ffb51d8$var$parseOrdinalNumberPattern = /\d+/i;
var $76783d8d2ffb51d8$var$matchEraPatterns = {
    narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
    abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
    wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
};
var $76783d8d2ffb51d8$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|n)/i
    ]
};
var $76783d8d2ffb51d8$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]\. [šs]tvr[ťt]rok/i
};
var $76783d8d2ffb51d8$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $76783d8d2ffb51d8$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
    wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
};
var $76783d8d2ffb51d8$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^m[áa]j/i,
        /^j[úu]n/i,
        /^j[úu]l/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $76783d8d2ffb51d8$var$matchDayPatterns = {
    narrow: /^[npusšp]/i,
    short: /^(ne|po|ut|st|št|pi|so)/i,
    abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
    wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
};
var $76783d8d2ffb51d8$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^u/i,
        /^s/i,
        /^š/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^u/i,
        /^st/i,
        /^(št|stv)/i,
        /^pi/i,
        /^so/i
    ]
};
var $76783d8d2ffb51d8$var$matchDayPeriodPatterns = {
    narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
    abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
    any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
};
var $76783d8d2ffb51d8$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /poln/i,
        noon: /^(nap|(na)?pol(\.|u))/i,
        morning: /^r[áa]no/i,
        afternoon: /^pop/i,
        evening: /^ve[čc]/i,
        night: /^(noc|v n\.)/i
    }
};
var $76783d8d2ffb51d8$var$match = {
    ordinalNumber: (0, $bFSku.default)({
        matchPattern: $76783d8d2ffb51d8$var$matchOrdinalNumberPattern,
        parsePattern: $76783d8d2ffb51d8$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $5hQUT.default)({
        matchPatterns: $76783d8d2ffb51d8$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $76783d8d2ffb51d8$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $5hQUT.default)({
        matchPatterns: $76783d8d2ffb51d8$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $76783d8d2ffb51d8$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: (0, $5hQUT.default)({
        matchPatterns: $76783d8d2ffb51d8$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $76783d8d2ffb51d8$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $5hQUT.default)({
        matchPatterns: $76783d8d2ffb51d8$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $76783d8d2ffb51d8$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $5hQUT.default)({
        matchPatterns: $76783d8d2ffb51d8$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $76783d8d2ffb51d8$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $76783d8d2ffb51d8$export$2e2bcd8739ae039 = $76783d8d2ffb51d8$var$match;

});


parcelRegister("2yYrH", function(module, exports) {

var $8B2Vs = parcelRequire("8B2Vs");

var $ez1ap = parcelRequire("ez1ap");

var $7Nmeo = parcelRequire("7Nmeo");

var $aahcv = parcelRequire("aahcv");

var $2Q03h = parcelRequire("2Q03h");

var $c28Gz = parcelRequire("c28Gz");

var $k4ZVz = parcelRequire("k4ZVz");

var $6gAuB = parcelRequire("6gAuB");

var $8BJ9i = parcelRequire("8BJ9i");

var $1tysM = parcelRequire("1tysM");

var $a5UJr = parcelRequire("a5UJr");

var $PodIB = parcelRequire("PodIB");

var $44NVg = parcelRequire("44NVg");

var $cAZOR = parcelRequire("cAZOR");

var $ffjTI = parcelRequire("ffjTI");

var $4sprp = parcelRequire("4sprp");

var $1bF8d = parcelRequire("1bF8d");

var $eA2jw = parcelRequire("eA2jw");

var $546O5 = parcelRequire("546O5");

var $aFR54 = parcelRequire("aFR54");

var $4c94y = parcelRequire("4c94y");

var $bIi70 = parcelRequire("bIi70");
/** Used to compose bitmasks for cloning. */ var $1ddda508b625bf95$var$CLONE_DEEP_FLAG = 1, $1ddda508b625bf95$var$CLONE_FLAT_FLAG = 2, $1ddda508b625bf95$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $1ddda508b625bf95$var$argsTag = '[object Arguments]', $1ddda508b625bf95$var$arrayTag = '[object Array]', $1ddda508b625bf95$var$boolTag = '[object Boolean]', $1ddda508b625bf95$var$dateTag = '[object Date]', $1ddda508b625bf95$var$errorTag = '[object Error]', $1ddda508b625bf95$var$funcTag = '[object Function]', $1ddda508b625bf95$var$genTag = '[object GeneratorFunction]', $1ddda508b625bf95$var$mapTag = '[object Map]', $1ddda508b625bf95$var$numberTag = '[object Number]', $1ddda508b625bf95$var$objectTag = '[object Object]', $1ddda508b625bf95$var$regexpTag = '[object RegExp]', $1ddda508b625bf95$var$setTag = '[object Set]', $1ddda508b625bf95$var$stringTag = '[object String]', $1ddda508b625bf95$var$symbolTag = '[object Symbol]', $1ddda508b625bf95$var$weakMapTag = '[object WeakMap]';
var $1ddda508b625bf95$var$arrayBufferTag = '[object ArrayBuffer]', $1ddda508b625bf95$var$dataViewTag = '[object DataView]', $1ddda508b625bf95$var$float32Tag = '[object Float32Array]', $1ddda508b625bf95$var$float64Tag = '[object Float64Array]', $1ddda508b625bf95$var$int8Tag = '[object Int8Array]', $1ddda508b625bf95$var$int16Tag = '[object Int16Array]', $1ddda508b625bf95$var$int32Tag = '[object Int32Array]', $1ddda508b625bf95$var$uint8Tag = '[object Uint8Array]', $1ddda508b625bf95$var$uint8ClampedTag = '[object Uint8ClampedArray]', $1ddda508b625bf95$var$uint16Tag = '[object Uint16Array]', $1ddda508b625bf95$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $1ddda508b625bf95$var$cloneableTags = {};
$1ddda508b625bf95$var$cloneableTags[$1ddda508b625bf95$var$argsTag] = $1ddda508b625bf95$var$cloneableTags[$1ddda508b625bf95$var$arrayTag] = $1ddda508b625bf95$var$cloneableTags[$1ddda508b625bf95$var$arrayBufferTag] = $1ddda508b625bf95$var$cloneableTags[$1ddda508b625bf95$var$dataViewTag] = $1ddda508b625bf95$var$cloneableTags[$1ddda508b625bf95$var$boolTag] = $1ddda508b625bf95$var$cloneableTags[$1ddda508b625bf95$var$dateTag] = $1ddda508b625bf95$var$cloneableTags[$1ddda508b625bf95$var$float32Tag] = $1ddda508b625bf95$var$cloneableTags[$1ddda508b625bf95$var$float64Tag] = $1ddda508b625bf95$var$cloneableTags[$1ddda508b625bf95$var$int8Tag] = $1ddda508b625bf95$var$cloneableTags[$1ddda508b625bf95$var$int16Tag] = $1ddda508b625bf95$var$cloneableTags[$1ddda508b625bf95$var$int32Tag] = $1ddda508b625bf95$var$cloneableTags[$1ddda508b625bf95$var$mapTag] = $1ddda508b625bf95$var$cloneableTags[$1ddda508b625bf95$var$numberTag] = $1ddda508b625bf95$var$cloneableTags[$1ddda508b625bf95$var$objectTag] = $1ddda508b625bf95$var$cloneableTags[$1ddda508b625bf95$var$regexpTag] = $1ddda508b625bf95$var$cloneableTags[$1ddda508b625bf95$var$setTag] = $1ddda508b625bf95$var$cloneableTags[$1ddda508b625bf95$var$stringTag] = $1ddda508b625bf95$var$cloneableTags[$1ddda508b625bf95$var$symbolTag] = $1ddda508b625bf95$var$cloneableTags[$1ddda508b625bf95$var$uint8Tag] = $1ddda508b625bf95$var$cloneableTags[$1ddda508b625bf95$var$uint8ClampedTag] = $1ddda508b625bf95$var$cloneableTags[$1ddda508b625bf95$var$uint16Tag] = $1ddda508b625bf95$var$cloneableTags[$1ddda508b625bf95$var$uint32Tag] = true;
$1ddda508b625bf95$var$cloneableTags[$1ddda508b625bf95$var$errorTag] = $1ddda508b625bf95$var$cloneableTags[$1ddda508b625bf95$var$funcTag] = $1ddda508b625bf95$var$cloneableTags[$1ddda508b625bf95$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $1ddda508b625bf95$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $1ddda508b625bf95$var$CLONE_DEEP_FLAG, isFlat = bitmask & $1ddda508b625bf95$var$CLONE_FLAT_FLAG, isFull = bitmask & $1ddda508b625bf95$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$546O5(value)) return value;
    var isArr = $4sprp(value);
    if (isArr) {
        result = $44NVg(value);
        if (!isDeep) return $k4ZVz(value, result);
    } else {
        var tag = $PodIB(value), isFunc = tag == $1ddda508b625bf95$var$funcTag || tag == $1ddda508b625bf95$var$genTag;
        if ($1bF8d(value)) return $c28Gz(value, isDeep);
        if (tag == $1ddda508b625bf95$var$objectTag || tag == $1ddda508b625bf95$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $ffjTI(value);
            if (!isDeep) return isFlat ? $8BJ9i(value, $2Q03h(result, value)) : $6gAuB(value, $aahcv(result, value));
        } else {
            if (!$1ddda508b625bf95$var$cloneableTags[tag]) return object ? value : {};
            result = $cAZOR(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $8B2Vs);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($aFR54(value)) value.forEach(function(subValue) {
        result.add($1ddda508b625bf95$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($eA2jw(value)) value.forEach(function(subValue, key) {
        result.set(key, $1ddda508b625bf95$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $a5UJr : $1tysM : isFlat ? $bIi70 : $4c94y;
    var props = isArr ? undefined : keysFunc(value);
    $ez1ap(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $7Nmeo(result, key, $1ddda508b625bf95$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $1ddda508b625bf95$var$baseClone;

});
parcelRegister("ez1ap", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $a9a53d46f1750193$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $a9a53d46f1750193$var$arrayEach;

});

parcelRegister("aahcv", function(module, exports) {

var $9Zabf = parcelRequire("9Zabf");

var $4c94y = parcelRequire("4c94y");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $76682e3d63c256bf$var$baseAssign(object, source) {
    return object && $9Zabf(source, $4c94y(source), object);
}
module.exports = $76682e3d63c256bf$var$baseAssign;

});

parcelRegister("2Q03h", function(module, exports) {

var $9Zabf = parcelRequire("9Zabf");

var $bIi70 = parcelRequire("bIi70");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $21107a6617fd771a$var$baseAssignIn(object, source) {
    return object && $9Zabf(source, $bIi70(source), object);
}
module.exports = $21107a6617fd771a$var$baseAssignIn;

});

parcelRegister("6gAuB", function(module, exports) {

var $9Zabf = parcelRequire("9Zabf");

var $2OzRB = parcelRequire("2OzRB");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $49008b58d735e9d5$var$copySymbols(source, object) {
    return $9Zabf(source, $2OzRB(source), object);
}
module.exports = $49008b58d735e9d5$var$copySymbols;

});

parcelRegister("8BJ9i", function(module, exports) {

var $9Zabf = parcelRequire("9Zabf");

var $kcrUf = parcelRequire("kcrUf");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $6444cd0db522ea71$var$copySymbolsIn(source, object) {
    return $9Zabf(source, $kcrUf(source), object);
}
module.exports = $6444cd0db522ea71$var$copySymbolsIn;

});

parcelRegister("44NVg", function(module, exports) {
/** Used for built-in method references. */ var $2f7e42c289b8f068$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2f7e42c289b8f068$var$hasOwnProperty = $2f7e42c289b8f068$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $2f7e42c289b8f068$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $2f7e42c289b8f068$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $2f7e42c289b8f068$var$initCloneArray;

});

parcelRegister("cAZOR", function(module, exports) {

var $kdzE7 = parcelRequire("kdzE7");

var $9mNM9 = parcelRequire("9mNM9");

var $c4r97 = parcelRequire("c4r97");

var $hcAMd = parcelRequire("hcAMd");

var $G4nZW = parcelRequire("G4nZW");
/** `Object#toString` result references. */ var $92b8ccd8f879bff1$var$boolTag = '[object Boolean]', $92b8ccd8f879bff1$var$dateTag = '[object Date]', $92b8ccd8f879bff1$var$mapTag = '[object Map]', $92b8ccd8f879bff1$var$numberTag = '[object Number]', $92b8ccd8f879bff1$var$regexpTag = '[object RegExp]', $92b8ccd8f879bff1$var$setTag = '[object Set]', $92b8ccd8f879bff1$var$stringTag = '[object String]', $92b8ccd8f879bff1$var$symbolTag = '[object Symbol]';
var $92b8ccd8f879bff1$var$arrayBufferTag = '[object ArrayBuffer]', $92b8ccd8f879bff1$var$dataViewTag = '[object DataView]', $92b8ccd8f879bff1$var$float32Tag = '[object Float32Array]', $92b8ccd8f879bff1$var$float64Tag = '[object Float64Array]', $92b8ccd8f879bff1$var$int8Tag = '[object Int8Array]', $92b8ccd8f879bff1$var$int16Tag = '[object Int16Array]', $92b8ccd8f879bff1$var$int32Tag = '[object Int32Array]', $92b8ccd8f879bff1$var$uint8Tag = '[object Uint8Array]', $92b8ccd8f879bff1$var$uint8ClampedTag = '[object Uint8ClampedArray]', $92b8ccd8f879bff1$var$uint16Tag = '[object Uint16Array]', $92b8ccd8f879bff1$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $92b8ccd8f879bff1$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $92b8ccd8f879bff1$var$arrayBufferTag:
            return $kdzE7(object);
        case $92b8ccd8f879bff1$var$boolTag:
        case $92b8ccd8f879bff1$var$dateTag:
            return new Ctor(+object);
        case $92b8ccd8f879bff1$var$dataViewTag:
            return $9mNM9(object, isDeep);
        case $92b8ccd8f879bff1$var$float32Tag:
        case $92b8ccd8f879bff1$var$float64Tag:
        case $92b8ccd8f879bff1$var$int8Tag:
        case $92b8ccd8f879bff1$var$int16Tag:
        case $92b8ccd8f879bff1$var$int32Tag:
        case $92b8ccd8f879bff1$var$uint8Tag:
        case $92b8ccd8f879bff1$var$uint8ClampedTag:
        case $92b8ccd8f879bff1$var$uint16Tag:
        case $92b8ccd8f879bff1$var$uint32Tag:
            return $G4nZW(object, isDeep);
        case $92b8ccd8f879bff1$var$mapTag:
            return new Ctor;
        case $92b8ccd8f879bff1$var$numberTag:
        case $92b8ccd8f879bff1$var$stringTag:
            return new Ctor(object);
        case $92b8ccd8f879bff1$var$regexpTag:
            return $c4r97(object);
        case $92b8ccd8f879bff1$var$setTag:
            return new Ctor;
        case $92b8ccd8f879bff1$var$symbolTag:
            return $hcAMd(object);
    }
}
module.exports = $92b8ccd8f879bff1$var$initCloneByTag;

});
parcelRegister("9mNM9", function(module, exports) {

var $kdzE7 = parcelRequire("kdzE7");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $6d1cc78e063d69e0$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $kdzE7(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $6d1cc78e063d69e0$var$cloneDataView;

});

parcelRegister("c4r97", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $8c9aea631d29b9fc$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $8c9aea631d29b9fc$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $8c9aea631d29b9fc$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $8c9aea631d29b9fc$var$cloneRegExp;

});

parcelRegister("hcAMd", function(module, exports) {

var $g60Jt = parcelRequire("g60Jt");
/** Used to convert symbols to primitives and strings. */ var $c86015be4f515e1a$var$symbolProto = $g60Jt ? $g60Jt.prototype : undefined, $c86015be4f515e1a$var$symbolValueOf = $c86015be4f515e1a$var$symbolProto ? $c86015be4f515e1a$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $c86015be4f515e1a$var$cloneSymbol(symbol) {
    return $c86015be4f515e1a$var$symbolValueOf ? Object($c86015be4f515e1a$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $c86015be4f515e1a$var$cloneSymbol;

});


parcelRegister("eA2jw", function(module, exports) {

var $9NRD3 = parcelRequire("9NRD3");

var $cUaWv = parcelRequire("cUaWv");

var $bLZOH = parcelRequire("bLZOH");
/* Node.js helper references. */ var $a9d638fd7655743b$var$nodeIsMap = $bLZOH && $bLZOH.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $a9d638fd7655743b$var$isMap = $a9d638fd7655743b$var$nodeIsMap ? $cUaWv($a9d638fd7655743b$var$nodeIsMap) : $9NRD3;
module.exports = $a9d638fd7655743b$var$isMap;

});
parcelRegister("9NRD3", function(module, exports) {

var $PodIB = parcelRequire("PodIB");

var $7gKgM = parcelRequire("7gKgM");
/** `Object#toString` result references. */ var $72324a3884c66385$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $72324a3884c66385$var$baseIsMap(value) {
    return $7gKgM(value) && $PodIB(value) == $72324a3884c66385$var$mapTag;
}
module.exports = $72324a3884c66385$var$baseIsMap;

});


parcelRegister("aFR54", function(module, exports) {

var $d3jJU = parcelRequire("d3jJU");

var $cUaWv = parcelRequire("cUaWv");

var $bLZOH = parcelRequire("bLZOH");
/* Node.js helper references. */ var $7c56e8763735cf57$var$nodeIsSet = $bLZOH && $bLZOH.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $7c56e8763735cf57$var$isSet = $7c56e8763735cf57$var$nodeIsSet ? $cUaWv($7c56e8763735cf57$var$nodeIsSet) : $d3jJU;
module.exports = $7c56e8763735cf57$var$isSet;

});
parcelRegister("d3jJU", function(module, exports) {

var $PodIB = parcelRequire("PodIB");

var $7gKgM = parcelRequire("7gKgM");
/** `Object#toString` result references. */ var $980ade0b1d3ba54a$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $980ade0b1d3ba54a$var$baseIsSet(value) {
    return $7gKgM(value) && $PodIB(value) == $980ade0b1d3ba54a$var$setTag;
}
module.exports = $980ade0b1d3ba54a$var$baseIsSet;

});



parcelRegister("fqICx", function(module, exports) {

var $2yYrH = parcelRequire("2yYrH");
/** Used to compose bitmasks for cloning. */ var $b3bbe575e797cce6$var$CLONE_DEEP_FLAG = 1, $b3bbe575e797cce6$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $b3bbe575e797cce6$var$cloneDeep(value) {
    return $2yYrH(value, $b3bbe575e797cce6$var$CLONE_DEEP_FLAG | $b3bbe575e797cce6$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $b3bbe575e797cce6$var$cloneDeep;

});

parcelRegister("a5R5f", function(module, exports) {
$parcel$export(module.exports, "getUserTiming", () => $75938c5592273bb5$export$4660d4a735328f2a);
var $75938c5592273bb5$var$n = "undefined" != typeof window ? window.performance : null;
function $75938c5592273bb5$export$a2a699fa5b2b1ed4(n) {
    void 0 === n && (n = {});
    var t = {
        deviceType: $75938c5592273bb5$export$abfb0136cf8e916b(),
        effectiveConnectionType: $75938c5592273bb5$export$265dfeca3f5017b9(),
        firstPaint: $75938c5592273bb5$export$819e7a0b13f5961(),
        firstContentfulPaint: $75938c5592273bb5$export$3086fa1a9fb7f683(),
        domContentLoaded: $75938c5592273bb5$export$d6856d1fab905de0(),
        onLoad: $75938c5592273bb5$export$7259a7b98f0280a3()
    };
    return (n.url || n.all) && (t.url = $75938c5592273bb5$export$94df0e59ebebf4a7()), (n.userAgent || n.all) && (t.userAgent = $75938c5592273bb5$export$7935961ef7719cb0()), (n.deviceMemory || n.all) && (t.deviceMemory = $75938c5592273bb5$export$bf34885f68c1d5e5()), (n.userTiming || n.all) && (t.userTiming = $75938c5592273bb5$export$4660d4a735328f2a()), (n.longTasks || n.all) && (t.longTasks = $75938c5592273bb5$export$a08a64ac61b1ac4e()), (n.resources || n.all) && (t.resources = $75938c5592273bb5$export$a0d4d2a74c7df9f()), t.onLoad < 0 ? new Promise(function(n) {
        return setTimeout(n, 250);
    }).then(function() {
        return $75938c5592273bb5$export$a2a699fa5b2b1ed4(n);
    }) : Promise.resolve(t);
}
function $75938c5592273bb5$export$bf7f2fce5c1cf636(e) {
    $75938c5592273bb5$var$n && $75938c5592273bb5$var$n.mark && $75938c5592273bb5$var$n.mark(e);
}
function $75938c5592273bb5$export$83602b44513dc228(e, t) {
    if ($75938c5592273bb5$var$n && $75938c5592273bb5$var$n.measure) try {
        $75938c5592273bb5$var$n.measure(e, t);
    } catch (n) {
        console.error(n);
    }
}
function $75938c5592273bb5$export$265dfeca3f5017b9() {
    var n = "undefined" != typeof navigator ? navigator.connection || navigator.mozConnection || navigator.webkitConnection : null;
    return n ? n.effectiveType : null;
}
function $75938c5592273bb5$export$819e7a0b13f5961() {
    if ("undefined" == typeof PerformancePaintTiming) return null;
    var e = $75938c5592273bb5$var$n.getEntriesByType("paint").find(function(n) {
        return "first-paint" === n.name;
    });
    return e ? Math.round(e.startTime) : null;
}
function $75938c5592273bb5$export$3086fa1a9fb7f683() {
    if ("undefined" == typeof PerformancePaintTiming) return null;
    var e = $75938c5592273bb5$var$n.getEntriesByType("paint").find(function(n) {
        return "first-contentful-paint" === n.name;
    });
    return e ? Math.round(e.startTime) : null;
}
function $75938c5592273bb5$export$7259a7b98f0280a3() {
    return $75938c5592273bb5$var$n && $75938c5592273bb5$var$n.timing ? $75938c5592273bb5$var$n.timing.loadEventEnd - $75938c5592273bb5$var$n.timing.fetchStart : null;
}
function $75938c5592273bb5$export$d6856d1fab905de0() {
    return $75938c5592273bb5$var$n && $75938c5592273bb5$var$n.timing ? $75938c5592273bb5$var$n.timing.domContentLoadedEventEnd - $75938c5592273bb5$var$n.timing.fetchStart : null;
}
function $75938c5592273bb5$export$abfb0136cf8e916b(n) {
    n = (n || $75938c5592273bb5$export$7935961ef7719cb0()).toLowerCase();
    var e = function(e) {
        return -1 !== n.indexOf(e);
    }, t = e("windows"), r = t && e("phone"), i = t && e("touch") && !r, o = !t && e("iphone"), a = e("ipod"), u = e("ipad"), f = !t && e("android"), d = f && e("mobile"), l = f && !e("mobile");
    return d || o || a || r ? "phone" : u || l || i ? "tablet" : "desktop";
}
function $75938c5592273bb5$export$94df0e59ebebf4a7() {
    return window.location.href;
}
function $75938c5592273bb5$export$7935961ef7719cb0() {
    return window.navigator.userAgent;
}
function $75938c5592273bb5$export$bf34885f68c1d5e5() {
    var n = "undefined" != typeof navigator ? navigator.deviceMemory : void 0;
    return void 0 === n ? null : n > 1 ? "full" : "lite";
}
function $75938c5592273bb5$export$4660d4a735328f2a() {
    if (!$75938c5592273bb5$var$n || "undefined" == typeof PerformanceMark) return null;
    var e = $75938c5592273bb5$var$n.getEntriesByType("mark").map(function(n) {
        return {
            type: "mark",
            name: n.name,
            startTime: Math.round(n.startTime)
        };
    }), t = $75938c5592273bb5$var$n.getEntriesByType("measure").map(function(n) {
        return {
            type: "measure",
            name: n.name,
            startTime: Math.round(n.startTime),
            duration: Math.round(n.duration)
        };
    });
    return e.concat(t);
}
function $75938c5592273bb5$export$a0d4d2a74c7df9f() {
    return $75938c5592273bb5$var$n && "undefined" != typeof PerformanceResourceTiming ? $75938c5592273bb5$var$n.getEntriesByType("navigation").concat($75938c5592273bb5$var$n.getEntriesByType("resource")).map(function(n) {
        return {
            url: n.name,
            type: n.initiatorType,
            size: n.transferSize,
            startTime: Math.round(n.startTime),
            duration: Math.round(n.duration)
        };
    }) : null;
}
function $75938c5592273bb5$export$a08a64ac61b1ac4e() {
    return void 0 === window.__lt ? null : window.__lt.e.map(function(n) {
        return {
            startTime: Math.round(n.startTime),
            duration: Math.round(n.duration)
        };
    });
}

});

const $758f26253b3d4f8b$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $758f26253b3d4f8b$export$f005e2e9f707cb5f = 'commercial';
const $758f26253b3d4f8b$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $758f26253b3d4f8b$export$a739cd5aac835909 = 'stg';
const $758f26253b3d4f8b$export$42dd0cdd351a4a9 = 'prod';
const $758f26253b3d4f8b$export$404582bc18fe4d9e = 'dev';

const $84d12136aa8dcfaf$export$42f4885608027d0c = 'non_boolean';

// This constant will be true on entry-fs (modern SSR) bundles and false on jira-fe-gateway (legacy SSR) and client bundles
const $9790b8dfe6f31c81$export$19d68f5aa485d903 = false;

const $652f5f63189f3e2a$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $652f5f63189f3e2a$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $652f5f63189f3e2a$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $652f5f63189f3e2a$export$b2c0462ff17aa26e = 'BUSINESS_BOARD';
const $652f5f63189f3e2a$export$f154708d773ba5a0 = 'JIRA_BOARD';
const $652f5f63189f3e2a$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $652f5f63189f3e2a$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $652f5f63189f3e2a$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $652f5f63189f3e2a$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $652f5f63189f3e2a$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $652f5f63189f3e2a$export$4695c1a423ffe431 = 'DASHBOARD';
const $652f5f63189f3e2a$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $652f5f63189f3e2a$export$9a80695e72849f84 = 'X-Atlassian-Capability';

// SCREENS
const $aa42ce8e355d58fa$export$f636b5b56f1d624a = 'Screen';
const $aa42ce8e355d58fa$export$9d2de6eebf7462b5 = 'Drawer';
const $aa42ce8e355d58fa$export$1171103ea9083ffa = 'Modal';
const $aa42ce8e355d58fa$export$cae2783c9279926 = 'InlineDialog';
const $aa42ce8e355d58fa$export$d1123261ca8831d2 = 'Dropdown';
const $aa42ce8e355d58fa$export$238d30785c4bca84 = 'Banner';
const $aa42ce8e355d58fa$export$a1562d08625f5d7e = 'UI';
const $aa42ce8e355d58fa$export$947dac6c72b26f81 = 'TRACK';
const $aa42ce8e355d58fa$export$f1d537d508d2945a = 'SCREEN';
const $aa42ce8e355d58fa$export$12346a674644c156 = 'OPERATIONAL';

const $2105caca302b8178$export$f636b5b56f1d624a = 'Screen';
const $2105caca302b8178$export$9d2de6eebf7462b5 = 'Drawer';
const $2105caca302b8178$export$1171103ea9083ffa = 'Modal';
const $2105caca302b8178$export$cae2783c9279926 = 'InlineDialog';
const $2105caca302b8178$export$d1123261ca8831d2 = 'Dropdown';
const $2105caca302b8178$export$a1562d08625f5d7e = 'UI';
const $2105caca302b8178$export$947dac6c72b26f81 = 'TRACK';
const $2105caca302b8178$export$f1d537d508d2945a = 'SCREEN';
const $2105caca302b8178$export$12346a674644c156 = 'OPERATIONAL';
const $2105caca302b8178$export$2ceccf177fae277c = 'analyticsBridge';

const $315aedf92e50a945$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $315aedf92e50a945$export$e9c56aa3b027d98f = 'jira-customer-service';
const $315aedf92e50a945$export$1346c9aa3cbb477d = 'jira-software';
const $315aedf92e50a945$export$202f50ee62667e32 = 'jira-product-discovery';
const $315aedf92e50a945$export$db515c8cec1e6f79 = 'jira-core';
const $315aedf92e50a945$export$c811f21c9ad05dc2 = 'confluence';
const $315aedf92e50a945$export$961148c98d198270 = 'opsgenie';
const $315aedf92e50a945$export$a310f85340477585 = 'assets';

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $c1d236d1310af702$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

// same types defined in analytics-web-client but avoid creating dependency with that
const $c336a4a8eee57272$export$a1562d08625f5d7e = 'ui';
const $c336a4a8eee57272$export$947dac6c72b26f81 = 'track';
const $c336a4a8eee57272$export$f1d537d508d2945a = 'screen';
const $c336a4a8eee57272$export$12346a674644c156 = 'operational';
const $c336a4a8eee57272$export$b055de0e665cb20c = 'unknown';

const $07c351e56f78ee75$export$cf090d5281b5ae06 = 10000;
const $07c351e56f78ee75$export$8575e30be0feb909 = 30000;

const $576a115f874e345f$export$3288b14b6745c572 = 204;
const $576a115f874e345f$export$c09e7ea0fc79f34f = 409;
const $576a115f874e345f$export$974c37534b0191b1 = 503;

const $fcc2379b1f384e36$export$56940a9488e85199 = 'jira.fe.spa-';
const $fcc2379b1f384e36$export$45c4b6bf7935c69a = `${$fcc2379b1f384e36$export$56940a9488e85199}start`;
const $fcc2379b1f384e36$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $fcc2379b1f384e36$export$ff834eccc35b9089 = 'appBundleReady';
const $fcc2379b1f384e36$export$86b05e34d462ead8 = 'prefetchApiReady';
const $fcc2379b1f384e36$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $fcc2379b1f384e36$export$3ae43cc1782d058f = 'jswRenderStart';
const $fcc2379b1f384e36$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $fcc2379b1f384e36$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $fcc2379b1f384e36$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $fcc2379b1f384e36$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $fcc2379b1f384e36$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $fcc2379b1f384e36$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $fcc2379b1f384e36$export$99c08ec92759c71c = 'tti-raf-mark';
const $fcc2379b1f384e36$export$48552baa9db8ce1d = 'tti-raf';

const $c9205e2bc9c7de44$export$b98e411ae80c806f = '/';

// temp solution until a proper versioning
const $411379f1f11af709$export$93809551debf385f = '0.1.7';

const $a3bc304a28ecf017$export$b98e411ae80c806f = '/';

const $c2258fadc4095860$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


$parcel$global.rlb("eZlSX")
//# sourceMappingURL=shared~commons~stable~ar.328fa90a.js.map
